import React from "react";
export const IFXSVGTemplates = {
  phone: [
    32,
    32,
    <path d="M 2.56635 12.9241C 0.708307 9.55549 0 6.83983 0 5.00558C 0 3.17134 0.450658 2.64526 0.907953 2.22025C 1.36525 1.79524 3.42732 0.523908 3.77867 0.286808C 4.13002 0.0497085 5.47099 -0.41107 6.31193 0.798636C 7.15287 2.00834 8.73646 4.43718 9.82825 6.05069C 11.5415 8.33611 10.1766 9.33937 9.73572 9.94069C 8.92447 11.0472 8.45734 11.3201 8.45734 12.6788C 8.45734 14.0375 12.2545 17.8976 13.1625 18.8487C 14.0635 19.7926 17.8471 23.1094 19.0195 23.2868C 20.2002 23.4654 21.7807 22.2154 22.1168 21.8985C 23.8263 20.586 24.7912 21.581 25.5787 22.0136C 26.3661 22.4461 29.9239 24.663 31.0264 25.4103C 32.0641 26.1576 31.9992 27.3125 31.9992 27.3125C 31.9992 27.3125 29.859 30.7092 29.5996 31.1168C 29.2753 31.5924 28.4971 32 26.746 32C 24.995 32 23.1241 31.6802 18.6777 29.2349C 15.0396 27.234 11.5714 24.1009 9.75551 22.2666C 7.87475 20.4324 4.68876 16.772 2.56635 12.9241Z" />,
  ],
  printer: [
    512,
    512,
    <>
      <path
        d="M174.08,389.12h163.84c5.652,0,10.24-4.588,10.24-10.24s-4.588-10.24-10.24-10.24H174.08
      c-5.653,0-10.24,4.588-10.24,10.24S168.427,389.12,174.08,389.12z"
      />
      <path
        d="M481.28,122.88H409.6V30.72c0-5.652-4.588-10.24-10.24-10.24H112.64c-5.653,0-10.24,4.588-10.24,10.24v92.16H30.72
      C13.783,122.88,0,136.663,0,153.6v225.28c0,16.937,13.783,30.72,30.72,30.72h71.68v71.68c0,5.652,4.587,10.24,10.24,10.24h286.72
      c5.652,0,10.24-4.588,10.24-10.24V409.6h71.68c16.937,0,30.72-13.783,30.72-30.72V153.6
      C512,136.663,498.217,122.88,481.28,122.88z M122.88,40.96h266.24v81.92H122.88V40.96z M389.12,399.36v71.68H122.88v-71.68
      v-71.68h266.24V399.36z M491.52,378.88c0,5.632-4.588,10.24-10.24,10.24H409.6v-71.68c0-5.652-4.588-10.24-10.24-10.24H112.64
      c-5.653,0-10.24,4.588-10.24,10.24v71.68H30.72c-5.652,0-10.24-4.608-10.24-10.24V153.6c0-5.632,4.588-10.24,10.24-10.24h81.92
      h286.72h81.92c5.652,0,10.24,4.608,10.24,10.24V378.88z"
      />
      <path
        d="M174.08,430.08H256c5.652,0,10.24-4.588,10.24-10.24S261.652,409.6,256,409.6h-81.92c-5.653,0-10.24,4.588-10.24,10.24
      S168.427,430.08,174.08,430.08z"
      />
      <path
        d="M440.32,184.32c-5.652,0-10.24,4.588-10.24,10.24s4.588,10.24,10.24,10.24s10.24-4.588,10.24-10.24
      S445.972,184.32,440.32,184.32z"
      />
    </>,
  ],

  csv: [
    490.667,
    490.667,
    <>
      <path
        d="M117.333,384H160c5.888,0,10.667-4.779,10.667-10.667s-4.779-10.667-10.667-10.667h-42.667c-17.643,0-32-14.357-32-32
      V288c0-17.643,14.357-32,32-32H160c5.888,0,10.667-4.779,10.667-10.667s-4.779-10.667-10.667-10.667h-42.667
      C87.936,234.667,64,258.581,64,288v42.667C64,360.085,87.936,384,117.333,384z"
      />
      <path
        d="M261.632,362.667H224c-5.888,0-10.667-4.8-10.667-10.667c0-5.888-4.779-10.667-10.667-10.667S192,346.112,192,352
      c0,17.643,14.357,32,32,32h37.632c20.416,0,37.035-16.619,37.035-37.035c0-14.101-7.829-26.795-20.459-33.131l-56.171-28.075
      c-5.376-2.688-8.704-8.064-8.704-14.059c0-8.661,7.04-15.701,15.701-15.701h37.632c5.888,0,10.667,4.8,10.667,10.667
      c0,5.888,4.779,10.667,10.667,10.667s10.667-4.779,10.667-10.667c0-17.643-14.357-32-32-32h-37.632
      c-20.416,0-37.035,16.619-37.035,37.035c0,14.101,7.829,26.795,20.459,33.131l56.171,28.075
      c5.376,2.688,8.704,8.064,8.704,14.059C277.333,355.627,270.293,362.667,261.632,362.667z"
      />
      <path
        d="M363.221,376.725c1.451,4.331,5.525,7.275,10.112,7.275s8.661-2.944,10.112-7.296l42.667-128
      c1.856-5.589-1.152-11.627-6.741-13.504c-5.611-1.856-11.627,1.195-13.483,6.763l-32.555,97.643l-32.555-97.643
      c-1.856-5.568-7.851-8.597-13.483-6.741c-5.589,1.877-8.597,7.915-6.741,13.504L363.221,376.725z"
      />
      <path
        d="M458.667,192h-32V10.667C426.667,4.779,421.888,0,416,0H181.333c-0.491,0-0.917,0.213-1.387,0.277
      c-0.469,0.064-0.853,0.149-1.301,0.256c-1.813,0.491-3.52,1.259-4.864,2.581L67.115,109.781
      c-1.323,1.344-2.091,3.051-2.581,4.843c-0.128,0.469-0.213,0.875-0.256,1.344c-0.064,0.469-0.277,0.896-0.277,1.365V192H32
      c-5.888,0-10.667,4.779-10.667,10.667V416c0,5.888,4.779,10.667,10.667,10.667h32V480c0,5.888,4.779,10.667,10.667,10.667H416
      c5.888,0,10.667-4.779,10.667-10.667v-53.333h32c5.888,0,10.667-4.779,10.667-10.667V202.667
      C469.333,196.779,464.555,192,458.667,192z M170.667,36.416v70.251h-70.251L170.667,36.416z M85.333,128h96
      c5.888,0,10.667-4.779,10.667-10.667v-96h213.333V192h-320V128z M405.333,469.333h-320v-42.667h320V469.333z M448,405.333H42.667
      v-192H448V405.333z"
      />
    </>,
  ],
  excel: [
    512.001,
    512.001,
    <>
      <path
        d="M469.334,42.668H324.267V8.535c0-2.479-1.075-4.837-2.958-6.458c-1.875-1.621-4.375-2.35-6.817-1.983L38.942,40.614
      c-12.475,1.837-21.875,12.725-21.875,25.329V446.06c0,12.604,9.4,23.492,21.875,25.329l275.55,40.521
      c0.417,0.062,0.825,0.092,1.242,0.092c2.033,0,4.017-0.729,5.575-2.075c1.883-1.621,2.958-3.979,2.958-6.458v-34.133h145.067
      c14.117,0,25.6-11.483,25.6-25.6V68.268C494.934,54.151,483.451,42.668,469.334,42.668z M307.201,51.201v59.733v34.133v51.2
      v34.133v51.2v34.133v51.2v34.133v59.733v32.788L41.426,454.506c-4.158-0.613-7.292-4.242-7.292-8.446V65.943
      c0-4.204,3.133-7.833,7.292-8.446l265.775-39.083V51.201z M324.267,119.468h42.667v17.067h-42.667V119.468z M324.267,204.801
      h42.667v17.067h-42.667V204.801z M324.267,290.135h42.667v17.067h-42.667V290.135z M324.267,375.468h42.667v17.067h-42.667
      V375.468z M477.867,443.735c0,4.704-3.825,8.533-8.533,8.533H324.267v-42.667h102.4c9.408,0,17.067-7.654,17.067-17.067v-17.067
      c0-9.413-7.658-17.067-17.067-17.067h-102.4v-34.133h102.4c9.408,0,17.067-7.654,17.067-17.067v-17.067
      c0-9.413-7.658-17.067-17.067-17.067h-102.4v-34.133h102.4c9.408,0,17.067-7.654,17.067-17.067v-17.067
      c0-9.412-7.658-17.067-17.067-17.067h-102.4v-34.133h102.4c9.408,0,17.067-7.654,17.067-17.067v-17.067
      c0-9.413-7.658-17.067-17.067-17.067h-102.4V59.735h145.067c4.708,0,8.533,3.829,8.533,8.533V443.735z M384.001,392.535v-17.067
      h42.667l0.008,17.067H384.001z M384.001,307.201v-17.067h42.667l0.008,17.067H384.001z M384.001,221.868v-17.067h42.667
      l0.008,17.067H384.001z M384.001,136.535v-17.067h42.667l0.008,17.067H384.001z"
      />
      <path
        d="M156.103,256.001l-51.752,62.842c-3,3.637-2.483,9.017,1.158,12.012c1.592,1.308,3.508,1.946,5.417,1.946
      c2.467,0,4.908-1.058,6.592-3.108l49.636-60.272l56.664,68.806c1.683,2.05,4.125,3.108,6.592,3.108
      c1.908,0,3.825-0.638,5.417-1.946c3.642-2.996,4.158-8.375,1.158-12.013l-58.779-71.375l58.779-71.375
      c3-3.638,2.483-9.017-1.158-12.012c-3.65-2.996-9.017-2.471-12.008,1.162l-56.664,68.806l-49.636-60.272
      c-2.983-3.638-8.367-4.162-12.008-1.163c-3.642,2.996-4.158,8.375-1.158,12.012L156.103,256.001z"
      />
    </>,
  ],
  download1: [
    512.001,
    512,
    <>
      <path d="m470.667969 147.335938c-9.015625-24.789063-23.714844-42.316407-42.683594-50.816407-16.417969-7.363281-35.65625-7.605469-56.125-.792969-8.226563-19.714843-20.457031-37.648437-35.757813-52.328124-4.019531-3.859376-10.402343-3.726563-14.257812.296874-3.855469 4.019532-3.722656 10.40625.296875 14.261719 15.476563 14.851563 27.347656 33.542969 34.328125 54.058594.90625 2.671875 2.890625 4.835937 5.46875 5.976563 2.574219 1.140624 5.511719 1.148437 8.097656.023437 19.0625-8.285156 35.785156-9.328125 49.703125-3.085937 14.652344 6.570312 26.117188 21.335937 33.152344 42.707031.863281 2.625 2.765625 4.777343 5.261719 5.960937 20.457031 9.691406 33.675781 30.484375 33.675781 52.96875 0 32.304688-26.238281 58.585938-58.488281 58.585938h-85.074219c.707031-5.6875-.148437-11.160156-2.628906-16.011719-4.539063-8.878906-13.921875-14.535156-25.105469-15.132813-.175781-.011718-.355469-.015624-.535156-.015624h-14.824219v-59.238282c0-16.03125-12.453125-27.226562-30.289063-27.226562h-53.949218c-17.835938 0-30.289063 11.195312-30.289063 27.226562v59.238282h-14.851562c-.179688 0-.359375.003906-.539063.015624-11.164062.597657-20.539062 6.25-25.074218 15.125-2.480469 4.855469-3.335938 10.332032-2.628907 16.019532h-68.921875c-32.234375 0-58.460937-26.28125-58.460937-58.585938 0-22.761718 13.132812-43.28125 34.277343-53.550781 3.328126-1.617187 5.503907-4.929687 5.667969-8.625.816407-18.316406 9.875-27.5 31.253907-31.695313 3.640624-.714843 6.597656-3.375 7.695312-6.921874 12.78125-41.378907 44.800781-74.398438 85.65625-88.320313 20.664062-7.054687 41.988281-9.019531 63.382812-5.84375 5.507813.828125 10.636719-2.984375 11.457032-8.496094.816406-5.511719-2.988282-10.640625-8.496094-11.460937-24.257812-3.605469-49.453125-1.285156-72.851562 6.703125-45.089844 15.367187-80.8125 50.964843-96.578126 95.871093-24.425781 6.382813-38.242187 20.9375-41.160156 43.367188-25.109375 14.398438-40.472656 40.335938-40.472656 68.976562 0 43.425782 35.273438 78.757813 78.628906 78.757813h78.007813l76.390625 97.203125c3.070312 4.804688 7.597656 7.703125 12.820312 8.191406.511719.046875 1.023438.070313 1.53125.070313 5.332032 0 10.507813-2.589844 14.722656-7.40625.117188-.132813.230469-.269531.339844-.410157l76.742188-97.648437h94.160156c43.371094 0 78.65625-35.332031 78.65625-78.757813 0-28.792968-16.085938-55.507812-41.332031-69.234374zm-222.757813 231.484374-77.304687-98.367187c-3.035157-4.859375-3.933594-9.261719-2.464844-12.132813 1.199219-2.351562 4.164063-3.890624 7.957031-4.148437h24.632813c5.570312 0 10.082031-4.519531 10.082031-10.089844v-69.324219c0-5.828124 5.503906-7.050781 10.121094-7.050781h53.949218c4.617188 0 10.121094 1.222657 10.121094 7.050781v69.324219c0 5.570313 4.515625 10.089844 10.082032 10.089844h24.609374c3.804688.257813 6.78125 1.800781 7.984376 4.152344 1.464843 2.871093.566406 7.273437-2.46875 12.132812zm0 0" />
      <path d="m298.605469 420.980469h-88.636719c-5.570312 0-10.085938 4.515625-10.085938 10.085937 0 5.570313 4.515626 10.089844 10.085938 10.089844h88.636719c5.570312 0 10.082031-4.519531 10.082031-10.089844 0-5.570312-4.511719-10.085937-10.082031-10.085937zm0 0" />
      <path d="m197.753906 55.914062c-31.792968 10.863282-56.707031 36.550782-66.644531 68.714844-1.644531 5.324219 1.335937 10.972656 6.65625 12.617188.992187.308594 1.992187.453125 2.980469.453125 4.304687 0 8.292968-2.78125 9.632812-7.113281 8.039063-26.015626 28.1875-46.792969 53.894532-55.578126 5.269531-1.800781 8.085937-7.535156 6.285156-12.804687-1.800782-5.273437-7.535156-8.085937-12.804688-6.289063zm0 0" />
      <path d="m283.320312 31.71875.167969.109375c1.71875 1.148437 3.664063 1.699219 5.585938 1.699219 3.257812 0 6.457031-1.578125 8.398437-4.496094 3.089844-4.636719 1.839844-10.898438-2.796875-13.988281l-.167969-.113281c-4.636718-3.09375-10.898437-1.835938-13.984374 2.796874-3.089844 4.636719-1.839844 10.902344 2.796874 13.992188zm0 0" />
    </>,
  ],
  upload: [
    511,
    511.999,
    <>
      <path d="m483.769531 332.492188c-4.734375-2.847657-10.878906-1.316407-13.726562 3.417968-13.59375 22.605469-37.445313 36.105469-63.804688 36.105469h-78.460937l-68.480469-122.914063c-1.765625-3.167968-5.109375-5.136718-8.734375-5.136718-3.628906 0-6.972656 1.964844-8.738281 5.136718l-68.480469 122.914063h-102.375c-27.828125 0-50.46875-22.625-50.46875-50.429687 0-20.628907 12.371094-38.976563 31.515625-46.734376 4.53125-1.839843 7.070313-6.6875 5.996094-11.460937-.824219-3.671875-1.242188-7.402344-1.242188-11.097656 0-27.808594 22.640625-50.429688 50.46875-50.429688 1.742188 0 3.5.097657 5.378907.296875 4.546874.480469 8.859374-2.195312 10.4375-6.496094 20.152343-54.839843 72.960937-91.683593 131.410156-91.683593 66.105468 0 123.75 46.914062 137.070312 111.554687 1 4.859375 5.410156 8.25 10.371094 7.964844 1.625-.09375 3.042969-.140625 4.332031-.140625 16.808594 0 32.589844 5.496094 45.347657 15.332031.472656.453125.984374.859375 1.539062 1.214844 6.605469 5.378906 12.347656 11.953125 16.921875 19.5625 2.847656 4.730469 8.988281 6.261719 13.726563 3.417969 4.730468-2.847657 6.261718-8.992188 3.414062-13.726563-5.074219-8.441406-11.40625-15.921875-18.664062-22.269531v-139.472656c0-2.652344-1.050782-5.195313-2.925782-7.070313l-77.421875-77.417968c-1.875-1.875-4.417969-2.929688-7.070312-2.929688h-246.621094c-16.542969 0-30.003906 13.460938-30.003906 30.003906v25.941406h-25.941407c-16.542968 0-30.003906 13.460938-30.003906 30.003907v127.433593c-7.425781 11.15625-11.765625 24.535157-11.765625 38.910157 0 2.488281.132813 4.988281.402344 7.484375-22.515625 12.25-36.671875 35.71875-36.671875 61.808594 0 38.835937 31.609375 70.429687 70.46875 70.429687h91.230469l-3.046875 5.46875c-1.726563 3.097656-1.683594 6.875.113281 9.933594 1.796875 3.058593 5.078125 4.933593 8.621094 4.933593h36.195312v89.644532c0 5.523437 4.476563 10.003906 10 10.003906h72.957031c5.523438 0 10-4.480469 10-10.003906v-89.644532h36.195313c3.542969 0 6.824219-1.875 8.621094-4.933593 1.796875-3.058594 1.839843-6.835938.113281-9.933594l-3.046875-5.46875h67.316406c32.941407 0 63.960938-17.546875 80.949219-45.796875 2.847656-4.738281 1.316406-10.882812-3.417969-13.726562zm-92.664062-298.347657 43.273437 43.273438h-29.207031c-7.757813 0-14.066406-6.308594-14.066406-14.066407zm-266.621094-4.140625c0-5.515625 4.484375-10 10-10h236.617187v43.347656c0 18.785157 15.285157 34.070313 34.070313 34.070313h43.351563v116.019531c-12.09375-6.070312-25.488282-9.589844-39.289063-10.035156-8.464844-32.324219-27.109375-61.542969-53.101563-82.964844-28.527343-23.511718-64.636718-36.460937-101.667968-36.460937-33.398438 0-65.390625 10.1875-92.53125 29.464843-14.609375 10.375-27.203125 22.953126-37.449219 37.222657zm-45.945313 45.941406h25.941407v105.988282c-13.238281.515625-25.542969 4.6875-35.941407 11.542968v-107.527343c0-5.515625 4.484376-10.003907 10-10.003907zm208.5 316.402344c-5.523437 0-10 4.480469-10 10.003906v89.644532h-52.957031v-89.644532c0-5.523437-4.476562-10.003906-10-10.003906h-29.171875l65.652344-117.832031 65.648438 117.832031zm0 0" />
      <path d="m497.691406 290.613281c-1.859375-1.859375-4.441406-2.929687-7.070312-2.929687-2.632813 0-5.210938 1.070312-7.070313 2.929687-1.863281 1.859375-2.933593 4.441407-2.933593 7.070313 0 2.640625 1.070312 5.210937 2.933593 7.074218 1.859375 1.859376 4.4375 2.929688 7.070313 2.929688 2.628906 0 5.210937-1.070312 7.070312-2.929688 1.859375-1.863281 2.929688-4.441406 2.929688-7.074218 0-2.628906-1.070313-5.199219-2.929688-7.070313zm0 0" />
    </>,
  ],
  filter: [
    48,
    48,
    <>
      <path d="m19 28.3v15.7c0 .35.18.67.47.85.16.1.35.15.53.15.15 0 .31-.04.45-.11l8-4c.34-.16.55-.51.55-.89v-11.7l15.83-23.75c.2-.31.22-.7.05-1.03-.17-.32-.51-.52-.88-.52h-40c-.37 0-.71.2-.88.53-.18.32-.16.72.05 1.02zm23.13-23.3-14.96 22.45c-.11.16-.17.35-.17.55v11.38l-6 3v-14.38c0-.2-.06-.39-.17-.55l-14.96-22.45z" />
    </>,
  ],
  pdf: [
    511.962,
    511.962,
    <>
      <path
        id="XMLID_522_"
        d="m485.05 66.889-64-63.962c-1.876-1.874-4.418-2.927-7.069-2.927h-296c-5.522 0-10 4.477-10 10v321.962h-34c-27.57 0-50 22.43-50 50v80c0 27.57 22.43 50 50 50h264 140c5.522 0 10-4.478 10-10v-200.873c0-5.522-4.478-10-10-10s-10 4.478-10 10v190.873h-90.027c6.292-8.363 10.027-18.753 10.027-30v-80c0-27.57-22.43-50-50-50h-210v-311.962h276v53.962c0 5.523 4.477 10 10 10h54v127.127c0 5.523 4.478 10 10 10s10-4.477 10-10v-137.127c0-2.653-1.055-5.198-2.931-7.073zm-117.069 315.073v80c0 16.542-13.458 30-30 30h-264c-16.542 0-30-13.458-30-30v-80c0-16.542 13.458-30 30-30h264c16.542 0 30 13.458 30 30zm56-347.83 29.848 29.83h-29.848z"
      />
      <path
        id="XMLID_524_"
        d="m477.981 246.092c-2.63 0-5.21 1.06-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.069 5.21 2.93 7.07c1.86 1.859 4.44 2.93 7.07 2.93s5.21-1.07 7.069-2.93c1.86-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07c-1.859-1.87-4.439-2.93-7.069-2.93z"
      />
      <path
        id="XMLID_525_"
        d="m269.981 471.962c5.522 0 10-4.478 10-10v-30h34c5.522 0 10-4.478 10-10s-4.478-10-10-10h-34v-6.092-13.908h34c5.522 0 10-4.478 10-10s-4.478-10-10-10h-44c-5.522 0-10 4.478-10 10v23.908 16.092 40c0 5.522 4.477 10 10 10z"
      />
      <path
        id="XMLID_1047_"
        d="m87.981 381.962v23.908 16.092 40c0 5.522 4.478 10 10 10s10-4.478 10-10v-30h14c16.542 0 30-13.458 30-30s-13.458-30-30-30h-24c-5.523 0-10 4.477-10 10zm20 10h14c5.514 0 10 4.486 10 10s-4.486 10-10 10h-14v-6.092z"
      />
      <path
        id="XMLID_1159_"
        d="m181.981 471.962h22.25c19.713 0 35.75-16.037 35.75-35.75v-28.5c0-19.713-16.037-35.75-35.75-35.75h-22.25c-5.522 0-10 4.478-10 10v80c0 5.522 4.477 10 10 10zm10-80h12.25c8.685 0 15.75 7.065 15.75 15.75v28.5c0 8.685-7.065 15.75-15.75 15.75h-12.25z"
      />
      <path
        id="XMLID_1175_"
        d="m250.729 213.225c-44.507 13.348-78.355 35.157-85.486 56.806-3.144 9.541-1.096 18.745 5.765 25.918 5.017 5.245 11.431 7.975 18.5 7.975 2.122 0 4.305-.247 6.524-.745 22.54-5.057 49.062-36.881 68.356-73.046 8.073-2.163 16.661-4.07 25.73-5.638 13.903-2.403 27.667-4.01 40.812-4.8 39.838 32.336 68.076 44.395 86.021 36.821 9.091-3.836 14.623-12.395 15.178-23.483.219-4.37-.967-10.86-7.855-16.961-13.903-12.313-46.635-18.206-86.57-16.726-3.4-2.846-6.952-5.895-10.658-9.16-14.531-12.802-25.42-25.534-33.453-37.701 3.858-13.965 7.475-28.983 9.937-43.406 4.934-28.907 3.884-47.014-3.305-56.986-3.944-5.474-9.811-8.488-16.516-8.488-11.08 0-20.868 8.402-26.183 22.475-6.641 17.584-7.979 51.274 14.383 89.518-2.433 8.359-5.127 16.986-8.047 25.746-3.679 11.034-8.165 21.77-13.133 31.881zm-59.076 70.438c-3.235.729-4.769-.05-6.192-1.539-1.728-1.806-2.047-3.333-1.223-5.836 3.25-9.864 21.691-24.728 51.638-36.727-15.745 24.454-32.918 41.566-44.223 44.102zm186.153-62.893c25.342 3.196 33.344 9.68 34.333 11.508-.2 3.11-1.196 5.064-2.964 5.811-1.468.618-12.662 3.992-45.266-18.568 4.821.274 9.464.69 13.897 1.249zm-68.1-19.285c-7.543.86-15.229 1.959-22.993 3.301-3.775.653-7.518 1.37-11.207 2.146 2.757-6.473 5.22-12.935 7.33-19.265 1.139-3.417 2.342-7.108 3.579-11.017 6.543 8.207 14.25 16.518 23.291 24.835zm-33.471-128.339c2.485-6.581 5.866-9.541 7.473-9.541.059 0 .106.002.146.004.679.825 5.373 7.872.515 38.722-1.118 7.103-2.669 14.942-4.603 23.33-8.7-23.255-7.387-42.305-3.531-52.515z"
      />
    </>,
  ],
  ui: [
    512,
    512,
    <>
      <path
        d="M500.364,0H337.455c-6.427,0-11.636,5.21-11.636,11.636s5.21,11.636,11.636,11.636H472.32L282.647,212.829
      c-4.881,4.18-5.45,11.526-1.269,16.407c4.18,4.881,11.526,5.45,16.407,1.269c0.455-0.39,0.88-0.814,1.269-1.269L488.727,39.68
      v134.865c0,6.427,5.21,11.636,11.636,11.636S512,180.972,512,174.545V11.636C512,5.21,506.79,0,500.364,0z"
      />
      <path
        d="M221.091,279.273c-3.093-0.018-6.066,1.196-8.262,3.375L23.273,472.32V337.455c0-6.427-5.21-11.636-11.636-11.636
      S0,331.028,0,337.455v162.909C0,506.79,5.21,512,11.636,512h162.909c6.427,0,11.636-5.21,11.636-11.636
      s-5.21-11.636-11.636-11.636H39.68l189.673-189.556c4.563-4.526,4.593-11.893,0.068-16.456
      C227.219,280.495,224.217,279.255,221.091,279.273z"
      />
    </>,
  ],
  refresh: [
    199.898,
    199.898,
    <>
      <path
        d="M186.656,106.782c-0.329,22.683-9.344,44.006-25.396,60.053
			c-33.817,33.817-88.841,33.817-122.658,0c-33.817-33.82-33.817-88.852,0-122.669C70.68,12.1,121.811,10.44,155.853,39.196
			l-30.689,7.895l1.564,7.548l44.274-10.497l-0.222-0.215l0.179-0.05L162.338,0l-7.455,1.954l6.284,31.676
			C124.108,2.004,68.192,3.686,33.152,38.712c-36.819,36.826-36.819,96.743,0,133.566c36.83,36.826,96.736,36.826,133.566,0
			c17.468-17.468,27.282-40.692,27.643-65.389L186.656,106.782z"
      />
    </>,
  ],
  word: [
    511.995,
    511.995,
    <>
      <path
        d="M460.798,42.662H315.731V8.528c0-2.492-1.092-4.862-2.983-6.483c-1.9-1.625-4.4-2.321-6.867-1.946L47.248,40.508
      c-12.542,1.958-21.65,12.596-21.65,25.296v380.383c0,12.7,9.108,23.338,21.65,25.292l258.633,40.412
      c0.442,0.071,0.875,0.104,1.317,0.104c2.017,0,3.992-0.717,5.55-2.05c1.892-1.621,2.983-3.992,2.983-6.483v-34.133h145.067
      c14.117,0,25.6-11.483,25.6-25.6V68.262C486.398,54.145,474.914,42.662,460.798,42.662z M298.664,51.195v409.6v32.696
      L49.881,454.616c-4.183-0.65-7.217-4.196-7.217-8.429V65.803c0-4.233,3.033-7.779,7.217-8.433l248.783-38.871V51.195z
       M469.331,443.728c0,4.704-3.825,8.533-8.533,8.533H315.731v-59.733h93.867c4.717,0,8.533-3.821,8.533-8.533
      s-3.817-8.533-8.533-8.533h-93.867v-34.133h93.867c4.717,0,8.533-3.821,8.533-8.533c0-4.713-3.817-8.533-8.533-8.533h-93.867
      v-34.133h93.867c4.717,0,8.533-3.821,8.533-8.533s-3.817-8.533-8.533-8.533h-93.867v-34.133h93.867
      c4.717,0,8.533-3.821,8.533-8.533s-3.817-8.533-8.533-8.533h-93.867v-34.133h93.867c4.717,0,8.533-3.821,8.533-8.533
      s-3.817-8.533-8.533-8.533h-93.867v-34.133h93.867c4.717,0,8.533-3.821,8.533-8.533c0-4.713-3.817-8.533-8.533-8.533h-93.867
      V59.728h145.067c4.708,0,8.533,3.829,8.533,8.533V443.728z"
      />
      <path
        d="M111.081,334.366c0.675,3.604,3.567,6.371,7.2,6.879c3.658,0.513,7.175-1.358,8.817-4.633l43.258-86.521l43.758,94.813
      c1.408,3.05,4.458,4.958,7.75,4.958c0.375,0,0.758-0.025,1.133-0.075c3.717-0.5,6.667-3.362,7.283-7.054l25.6-153.6
      c0.775-4.65-2.367-9.046-7.017-9.821c-4.65-0.792-9.042,2.367-9.817,7.013l-21.042,126.271l-39.592-85.775
      c-1.375-2.979-4.333-4.904-7.617-4.958c-3.417-0.221-6.3,1.787-7.767,4.717l-39.858,79.713l-20.925-111.6
      c-0.867-4.629-5.242-7.7-9.958-6.817c-4.633,0.871-7.683,5.329-6.808,9.958L111.081,334.366z"
      />
    </>,
  ],
  forward: [
    511.998,
    511.998,
    <>
      <path
        d="M509.645,250.116l-170.667-179.2c-1.612-1.692-3.846-2.65-6.179-2.65h-102.4c-3.412,0-6.5,2.033-7.842,5.171
      c-1.346,3.137-0.692,6.775,1.663,9.246l165.062,173.317L224.22,429.316c-2.354,2.467-3.008,6.108-1.663,9.242
      c1.342,3.142,4.429,5.175,7.842,5.175h102.4c2.333,0,4.567-0.958,6.179-2.65l170.667-179.2
      C512.783,258.587,512.783,253.412,509.645,250.116z M329.141,426.666h-78.829l156.933-164.783c3.138-3.296,3.138-8.471,0-11.767
      L250.312,85.333h78.829l162.542,170.667L329.141,426.666z"
      />
      <path
        d="M287.779,250.116l-170.667-179.2c-1.612-1.692-3.846-2.65-6.179-2.65H8.533c-3.412,0-6.5,2.033-7.842,5.171
      c-1.346,3.137-0.692,6.775,1.663,9.246l165.063,173.317L2.354,429.316c-2.354,2.467-3.008,6.108-1.663,9.242
      c1.342,3.142,4.429,5.175,7.842,5.175h102.4c2.333,0,4.567-0.958,6.179-2.65l170.667-179.2
      C290.916,258.587,290.916,253.412,287.779,250.116z M107.274,426.666H28.445l156.933-164.783c3.138-3.296,3.138-8.471,0-11.767
      L28.445,85.333h78.829l162.542,170.667L107.274,426.666z"
      />
    </>,
  ],
  "multimedia-option": [
    512,
    512,
    <>
      <path
        d="M256,42.667c76.075,0,146.283,41.536,184.149,106.667H309.333c-5.888,0-10.667,4.779-10.667,10.667
      s4.779,10.667,10.667,10.667h149.184c1.109,0,2.197-0.277,3.264-0.64c0.363-0.107,0.768-0.128,1.131-0.277
      c0.043-0.021,0.085-0.021,0.107-0.021c0.277-0.128,0.427-0.363,0.683-0.512c3.307-1.813,5.632-5.184,5.632-9.216V10.667
      C469.333,4.779,464.555,0,458.667,0S448,4.779,448,10.667v110.656c-43.499-61.696-115.179-99.989-192-99.989
      C126.613,21.333,21.333,126.613,21.333,256c0,5.888,4.779,10.667,10.667,10.667S42.667,261.888,42.667,256
      C42.667,138.368,138.368,42.667,256,42.667z"
      />
      <path
        d="M480,245.333c-5.888,0-10.667,4.779-10.667,10.667c0,117.632-95.701,213.333-213.333,213.333
      c-76.928,0-146.091-40.747-184.213-106.667h130.88c5.888,0,10.667-4.779,10.667-10.667c0-5.888-4.779-10.667-10.667-10.667
      H53.333c-5.888,0-10.667,4.779-10.667,10.667v149.333c0,5.888,4.779,10.667,10.667,10.667S64,507.221,64,501.333V390.848
      c43.541,62.251,114.304,99.819,192,99.819c129.387,0,234.667-105.28,234.667-234.667
      C490.667,250.112,485.888,245.333,480,245.333z"
      />
    </>,
  ],
  share: [
    463.06667,
    463,
    <>
      <path d="m405.332031 430.300781h-405.332031v-405.335937h266.667969v21.335937h-245.335938v362.664063h362.667969v-181.332032h21.332031zm0 0" />
      <path d="m374.398438 177.632812-15.066407-15.066406 73.601563-73.601562-73.867188-73.730469 15.199219-15.1992188 88.800781 88.9296878zm0 0" />
      <path d="m213.332031 238.300781h-21.332031v-32c0-70.535156 57.464844-128 128-128h128v21.332031h-128c-58.800781 0-106.667969 47.867188-106.667969 106.667969zm0 0" />
    </>,
  ],
  back1: [
    512.068,
    512.068,
    <>
      <path
        d="M162.977,69.886V11.704C163.014,5.278,157.835,0.038,151.408,0c-3.126-0.018-6.128,1.222-8.33,3.442l-139.636,128
			c-4.563,4.526-4.593,11.893-0.068,16.456c0.022,0.023,0.045,0.045,0.068,0.068l139.636,128c4.526,4.563,11.893,4.593,16.456,0.068
			c2.22-2.201,3.46-5.203,3.442-8.33v-57.018c52.842,3.45,104.746,15.64,153.6,36.073
			c114.036,48.175,172.218,133.585,172.218,253.673c0,6.427,5.21,11.636,11.636,11.636s11.636-5.21,11.636-11.636
			C512.068,118.293,224.533,74.773,162.977,69.886z M162.977,186.249H151.34c-6.427,0-11.636,5.21-11.636,11.636v43.404
			L28.926,139.704L139.704,38.119v43.404c0,6.427,5.21,11.636,11.636,11.636h11.636c50.735,3.258,235.055,30.022,302.545,242.385
			C379.529,207.66,210.453,188.809,162.977,186.249z"
      />
    </>,
  ],
  search: [
    512.005,
    512.005,
    <>
      <path
        d="M330.672,0.003c-99.989,0-181.333,81.344-181.333,181.333c0,44.928,16.32,87.189,45.867,120.384l-57.6,57.6
			l-14.848-14.848c-2.005-2.005-4.715-3.136-7.552-3.136s-5.547,1.131-7.552,3.115L3.12,448.984c-4.16,4.16-4.16,10.923,0,15.083
			l44.8,44.8c2.005,2.005,4.715,3.136,7.552,3.136s5.547-1.131,7.552-3.115l104.533-104.533c4.16-4.16,4.16-10.923,0-15.083
			l-14.869-14.869l57.6-57.6c33.195,29.547,75.456,45.867,120.384,45.867c99.989,0,181.333-81.344,181.333-181.333
			S430.661,0.003,330.672,0.003z M55.472,486.253l-29.717-29.717l89.451-89.451l29.717,29.717L55.472,486.253z M330.672,341.336
			c-42.816,0-83.029-16.619-113.216-46.784c-30.165-30.187-46.784-70.379-46.784-113.216c0-88.235,71.765-160,160-160
			s160,71.765,160,160S418.907,341.336,330.672,341.336z"
      />
    </>,
  ],
  gear: [
    512,
    512,
    <>
      <path
        d="M256,162.34c-50.811,0-92.16,41.349-92.16,92.16c0,50.811,41.349,92.16,92.16,92.16c50.811,0,92.16-41.349,92.16-92.16
      C348.16,203.689,306.811,162.34,256,162.34z M256,326.18c-39.526,0-71.68-32.174-71.68-71.68s32.154-71.68,71.68-71.68
      s71.68,32.174,71.68,71.68C327.68,294.026,295.526,326.18,256,326.18z"
      />
      <path
        d="M487.322,210.448l-38.748-7.741c-10.035-2.007-18.371-8.929-22.487-18.924c-3.932-9.564-2.929-20.337,2.724-28.815
      l21.914-32.87c8.09-12.124,6.492-28.447-3.85-38.769l-19.681-19.661c-10.322-10.342-26.604-12.001-38.769-3.85l-32.87,21.893
      c-8.479,5.652-19.292,6.676-29.225,2.56c-9.585-3.953-16.507-12.288-18.514-22.323l-7.741-38.748
      C297.185,8.883,284.529-1.5,269.926-1.5h-27.853c-14.582,0-27.238,10.383-30.106,24.699l-7.741,38.748
      c-2.007,10.015-8.929,18.35-18.944,22.487c-9.585,3.953-20.337,2.929-28.815-2.724l-32.85-21.873
      c-12.165-8.11-28.467-6.533-38.769,3.83L65.147,83.328c-10.342,10.322-11.94,26.624-3.85,38.769l21.914,32.87
      c5.652,8.479,6.656,19.251,3.523,27.218c-0.307,0.512-0.758,1.454-0.983,2.007c-3.953,9.585-12.268,16.507-22.323,18.514
      l-38.728,7.741C10.383,213.315,0,225.992,0,240.574v27.873c0,14.623,10.404,27.279,24.699,30.085l38.728,7.741
      c10.035,2.007,18.371,8.929,22.487,18.944c3.953,9.544,2.949,20.316-2.703,28.795l-21.914,32.87
      c-8.09,12.145-6.472,28.426,3.85,38.748l19.681,19.702c10.342,10.363,26.644,11.96,38.748,3.85l32.87-21.873
      c8.499-5.652,19.251-6.697,29.204-2.581c9.626,3.973,16.548,12.329,18.555,22.323l7.741,38.81
      c2.888,14.275,15.565,24.637,30.126,24.637h27.853c14.582,0,27.259-10.383,30.106-24.637l7.741-38.769
      c2.007-10.015,8.95-18.35,18.944-22.487c9.585-3.973,20.316-2.888,28.795,2.744l32.85,21.852
      c12.186,8.172,28.467,6.533,38.769-3.83l19.702-19.702c10.342-10.342,11.96-26.644,3.85-38.748l-21.893-32.87
      c-5.652-8.479-6.676-19.272-2.539-29.205c3.953-9.605,12.288-16.527,22.303-18.534l38.748-7.741
      C501.596,295.726,512,283.07,512,268.447v-27.873C512,225.992,501.617,213.315,487.322,210.448z M491.52,268.447
      c0,4.874-3.461,9.093-8.213,10.015l-38.748,7.741c-16.753,3.338-30.7,14.848-37.396,31.171
      c-6.554,15.893-4.854,33.833,4.608,48.005l21.893,32.891c2.683,4.014,2.15,9.441-1.29,12.882l-19.722,19.702
      c-3.42,3.461-8.847,4.035-12.882,1.29l-32.87-21.873c-14.193-9.482-32.174-11.223-48.353-4.465
      c-15.954,6.574-27.484,20.5-30.822,37.233l-7.741,38.748c-0.963,4.751-5.181,8.212-10.056,8.212h-27.853
      c-4.874,0-9.093-3.461-10.056-8.192l-7.741-38.769c-3.338-16.732-14.869-30.659-31.191-37.396
      c-6.369-2.642-13.066-3.932-19.743-3.932c-9.912,0-19.743,2.908-28.242,8.561l-32.891,21.893
      c-4.055,2.662-9.441,2.13-12.882-1.29l-19.702-19.702c-3.441-3.441-3.994-8.868-1.29-12.902l21.914-32.87
      c9.462-14.172,11.162-32.113,4.444-48.333c-6.533-15.954-20.48-27.505-37.253-30.843l-38.748-7.741
      c-4.751-0.942-8.213-5.161-8.213-10.035v-27.873c0-4.854,3.461-9.093,8.233-10.056l38.707-7.741
      c16.794-3.338,30.72-14.848,37.417-31.171c6.574-15.892,4.854-33.833-4.588-48.005l-21.914-32.87
      c-2.703-4.035-2.15-9.462,1.29-12.902l19.722-19.702c3.4-3.441,8.806-3.973,12.861-1.27l32.87,21.893
      c14.172,9.421,32.113,11.141,48.394,4.444c15.954-6.554,27.464-20.48,30.802-37.233l7.741-38.728
      c0.963-4.792,5.202-8.253,10.056-8.253h27.853c4.874,0,9.093,3.461,10.056,8.233l7.741,38.728
      c3.338,16.773,14.848,30.679,31.191,37.417c15.933,6.574,33.833,4.833,47.985-4.608l32.891-21.893
      c4.035-2.703,9.441-2.15,12.882,1.29l19.702,19.661c3.441,3.441,3.994,8.868,1.29,12.923l-21.893,32.87
      c-9.441,14.172-11.162,32.113-4.444,48.374c6.554,15.954,20.48,27.464,37.233,30.802l38.728,7.741
      c4.772,0.963,8.233,5.202,8.233,10.056V268.447z"
      />
    </>,
  ],
  order: [
    512,
    512,
    <>
      <path d="m88 288h352a8.00008 8.00008 0 0 0 8-8v-256a8.00008 8.00008 0 0 0 -8-8h-352a8.00008 8.00008 0 0 0 -8 8v256a8.00008 8.00008 0 0 0 8 8zm344-16h-128v-240h128zm-224-240v32h-32v-32zm-112 0h64v40a8.00008 8.00008 0 0 0 8 8h48a8.00008 8.00008 0 0 0 8-8v-40h64v240h-192z" />
      <path d="m176 188.68652-18.34326-18.34375-11.31348 11.31446 24 24a8.00063 8.00063 0 0 0 11.31348 0l48-48-11.31348-11.31446z" />
      <path d="m400 240h16v16h-16z" />
      <path d="m368 240h16v16h-16z" />
      <path d="m336 240h16v16h-16z" />
      <path d="m192 96a80 80 0 1 0 80 80 80.09041 80.09041 0 0 0 -80-80zm0 144a64 64 0 1 1 64-64 64.07239 64.07239 0 0 1 -64 64z" />
      <path d="m485.65723 306.34375a30.62622 30.62622 0 0 0 -43.314-.001l-69.82323 69.82325a135.3368 135.3368 0 0 1 -28.58 21.854c.03717-.66895.05994-1.3418.05994-2.02a36.04061 36.04061 0 0 0 -36-36h-96.68646l-13.65674-13.65723a64.595 64.595 0 0 0 -77.65674-10.4353v-7.90747a8.00008 8.00008 0 0 0 -8-8h-24v-8a8.00008 8.00008 0 0 0 -8-8h-64v16h56v160h-56v16h64a8.00008 8.00008 0 0 0 8-8v-16h24a8.00008 8.00008 0 0 0 8-8v-20.96a201.12553 201.12553 0 0 0 278.2251-5.95117l87.43213-87.43262a30.662 30.662 0 0 0 0-43.31246zm-381.65723 149.65625h-16v-120h16zm370.34326-117.65723-87.43164 87.43164a185.13634 185.13634 0 0 1 -261.82275 0l-5.08887-5.08886v-65.208a48.546 48.546 0 0 1 66.34326 2.17969l16 16a8.00035 8.00035 0 0 0 5.65674 2.34276h100a20 20 0 0 1 0 40h-100v16h100a35.90213 35.90213 0 0 0 26.36035-11.51709 151.07142 151.07142 0 0 0 49.47315-33.00244l69.82373-69.82422a14.62741 14.62741 0 0 1 20.686 20.68652z" />
    </>,
  ],
  house: [
    512.003,
    512.003,
    <>
      <path
        d="M508.702,248.297L263.368,13.631c-4.117-3.947-10.624-3.947-14.741,0L3.294,248.297
      c-4.245,4.075-4.416,10.816-0.341,15.083c4.117,4.267,10.837,4.416,15.104,0.32l45.952-43.947v270.912
      c0,5.888,4.779,10.667,10.667,10.667h362.667c5.888,0,10.667-4.779,10.667-10.667V219.753l45.952,43.968
      c2.069,1.963,4.715,2.944,7.381,2.944c2.816,0,5.611-1.109,7.701-3.285C513.118,259.113,512.968,252.372,508.702,248.297z
       M298.675,479.999h-85.333v-128h85.333V479.999z M426.675,479.999H320.008V341.332c0-5.888-4.779-10.667-10.667-10.667H202.675
      c-5.888,0-10.667,4.779-10.667,10.667v138.667H85.342V199.338L256.008,36.095l170.667,163.243V479.999z"
      />
      <path
        d="M213.342,159.999c0,23.531,19.136,42.667,42.667,42.667s42.667-19.136,42.667-42.667s-19.136-42.667-42.667-42.667
      S213.342,136.468,213.342,159.999z M277.342,159.999c0,11.755-9.579,21.333-21.333,21.333s-21.333-9.579-21.333-21.333
      s9.579-21.333,21.333-21.333S277.342,148.244,277.342,159.999z"
      />
    </>,
  ],
  more: [
    495.36,
    495.36,
    <>
      <g>
        <g>
          <path
            d="M247.467,0C110.677,0.118-0.118,111.104,0,247.893c0.118,136.79,111.103,247.584,247.893,247.467
        C384.6,495.242,495.36,384.387,495.36,247.68C495.125,110.904,384.242,0.117,247.467,0z M247.467,474.027v0.213
        C122.459,474.122,21.216,372.688,21.334,247.68c0.118-125.008,101.552-226.251,226.56-226.133
        c124.841,0.118,226.015,101.292,226.133,226.133C473.792,372.674,372.46,473.909,247.467,474.027z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M170.881,230.188c-0.072-0.001-0.143-0.001-0.215-0.001c-9.661,0.001-17.493,7.833-17.492,17.495
        c0.001,9.661,7.833,17.493,17.495,17.492c9.578-0.001,17.374-7.703,17.491-17.28C188.278,238.233,180.542,230.306,170.881,230.188
        z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M248.113,230.183c-0.216-0.003-0.431-0.001-0.647,0.004c-9.658,0.236-17.296,8.258-17.06,17.916
        c0.236,9.658,8.258,17.296,17.916,17.06c9.407-0.23,16.946-7.861,17.064-17.27C265.507,238.233,257.774,230.304,248.113,230.183z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M324.48,230.187c-9.778-0.118-17.801,7.714-17.919,17.492c-0.001,0.072-0.001,0.143-0.001,0.215
        c0.001,9.779,7.929,17.706,17.708,17.705c9.779-0.001,17.706-7.929,17.705-17.708C341.973,238.195,334.175,230.304,324.48,230.187
        z"
          />
        </g>
      </g>
    </>,
  ],
  "new-document": [
    96,
    96,
    <>
      <g id="Background" display="none">
        <path d="m0 0h96v96h-96z" display="inline" fill="#fff" />
      </g>
      <g id="Outline_Expand">
        <path d="m74 56c0 1.104-.896 2-2 2h-3v3c0 2.575-4 2.58-4 0v-3h-3c-2.575 0-2.58-4 0-4h3v-3c0-2.575 4-2.58 4 0v3h3c1.104 0 2 .896 2 2zm10 0c0 7.26-4.583 13.453-11 15.886v18.114c0 1.104-.896 2-2 2h-57c-1.104 0-2-.896-2-2v-84c0-1.104.896-2 2-2h40c.53 0 1.039.211 1.414.586l17 17c.375.375.586.884.586 1.414v17.114c6.417 2.433 11 8.626 11 15.886zm-28-35h10.171l-10.171-10.171zm13 51.872c-.657.077-1.322.128-2 .128-9.374 0-17-7.626-17-17s7.626-17 17-17c.678 0 1.343.051 2 .128v-14.128h-15c-1.104 0-2-.896-2-2v-15h-36v80h53zm11-16.872c0-7.168-5.832-13-13-13s-13 5.832-13 13 5.832 13 13 13 13-5.832 13-13z" />
      </g>
      <g id="Primary" display="none">
        <g>
          <path d="m71 70.461v19.539h-57v-84h40l17 17v18.539" />
          <path d="m71 23h-17v-17z" />
          <g>
            <path d="m62 56h10" />
            <path d="m67 51v10" />
            <circle cx="67" cy="56" r="15" />
          </g>
        </g>
      </g>
      <g id="Glyph" display="none">
        <path
          d="m69 41c-8.271 0-15 6.729-15 15s6.729 15 15 15 15-6.729 15-15-6.729-15-15-15zm5 17h-3v3c0 2.575-4 2.58-4 0v-3h-3c-2.575 0-2.58-4 0-4h3v-3c0-2.575 4-2.58 4 0v3h3c2.575 0 2.58 4 0 4zm-5 17c3.671 0 7.091-1.064 10-2.875v17.875c0 1.104-.896 2-2 2h-58c-1.104 0-2-.896-2-2v-84c0-1.104.896-2 2-2h41c.53 0 1.039.211 1.414.586l16.414 16.414h-15.828v-11c0-2.575-4-2.58-4 0v13c0 1.104.896 2 2 2h19v14.875c-2.909-1.811-6.329-2.875-10-2.875-10.477 0-19 8.523-19 19s8.523 19 19 19z"
          display="inline"
        />
      </g>
      <g id="Filled_Outline" display="none">
        <path d="m70 23h-16v-16z" display="inline" fill="#d3dff9" />
        <circle cx="67" cy="56" display="inline" fill="#d3dff9" r="15" />
        <g display="inline">
          <g fill="#4e82e8">
            <path d="m72 54h-3v-3c0-1.104-.896-2-2-2s-2 .896-2 2v3h-3c-1.104 0-2 .896-2 2s.896 2 2 2h3v3c0 1.104.896 2 2 2s2-.896 2-2v-3h3c1.104 0 2-.896 2-2s-.896-2-2-2z" />
            <path d="m84 56c0-7.26-4.583-13.453-11-15.886v-17.114c0-.53-.211-1.039-.586-1.414l-17-17c-.375-.375-.884-.586-1.414-.586h-40c-1.104 0-2 .896-2 2v84c0 1.104.896 2 2 2h57c1.104 0 2-.896 2-2v-18.114c6.417-2.433 11-8.626 11-15.886zm-28-45.171 10.171 10.171h-10.171zm13 77.171h-53v-80h36v15c0 1.104.896 2 2 2h15v14.128c-.657-.077-1.322-.128-2-.128-9.374 0-17 7.626-17 17s7.626 17 17 17c.678 0 1.343-.051 2-.128zm-2-19c-7.168 0-13-5.832-13-13s5.832-13 13-13 13 5.832 13 13-5.832 13-13 13z" />
          </g>
        </g>
      </g>
      <g id="Sampel_u_x2F__Interface" display="none">
        <g>
          <path d="m71 70.461v19.539h-57v-84h40l17 17v18.539" />
          <path d="m71 23h-17v-17z" />
          <g>
            <path d="m62 56h10" />
            <path d="m67 51v10" />
            <circle cx="67" cy="56" r="15" />
          </g>
        </g>
      </g>
    </>,
  ],
  "floppy-disk": [
    64,
    64,
    <>
      <path d="M61.707,10.293l-8-8A1,1,0,0,0,53,2H7A5.006,5.006,0,0,0,2,7V57a5.006,5.006,0,0,0,5,5H57a5.006,5.006,0,0,0,5-5V11A1,1,0,0,0,61.707,10.293ZM48,4V20a1,1,0,0,1-1,1H17a1,1,0,0,1-1-1V4ZM10,60V35a3,3,0,0,1,3-3H51a3,3,0,0,1,3,3V60Zm50-3a3,3,0,0,1-3,3H56V35a5.006,5.006,0,0,0-5-5H13a5.006,5.006,0,0,0-5,5V60H7a3,3,0,0,1-3-3V7A3,3,0,0,1,7,4h7V20a3,3,0,0,0,3,3H47a3,3,0,0,0,3-3V4h2.586L60,11.414Z" />
      <path d="M39,19h6a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H39a1,1,0,0,0-1,1V18A1,1,0,0,0,39,19ZM40,8h4v9H40Z" />
      <path d="M47,45H17a1,1,0,0,0,0,2H47a1,1,0,0,0,0-2Z" />
      <path d="M47,39H17a1,1,0,0,0,0,2H47a1,1,0,0,0,0-2Z" />
      <path d="M47,51H17a1,1,0,0,0,0,2H47a1,1,0,0,0,0-2Z" />
    </>,
  ],
  visibility: [
    511.992,
    511.992,
    <>
      <g>
        <g>
          <path
            d="M510.096,249.937c-4.032-5.867-100.928-143.275-254.101-143.275C124.56,106.662,7.44,243.281,2.512,249.105
        c-3.349,3.968-3.349,9.792,0,13.781C7.44,268.71,124.56,405.329,255.995,405.329S504.549,268.71,509.477,262.886
        C512.571,259.217,512.848,253.905,510.096,249.937z M255.995,383.996c-105.365,0-205.547-100.48-230.997-128
        c25.408-27.541,125.483-128,230.997-128c123.285,0,210.304,100.331,231.552,127.424
        C463.013,282.065,362.256,383.996,255.995,383.996z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M255.995,170.662c-47.061,0-85.333,38.272-85.333,85.333s38.272,85.333,85.333,85.333s85.333-38.272,85.333-85.333
        S303.056,170.662,255.995,170.662z M255.995,319.996c-35.285,0-64-28.715-64-64s28.715-64,64-64s64,28.715,64,64
        S291.28,319.996,255.995,319.996z"
          />
        </g>
      </g>
    </>,
  ],
  add: [
    510,
    510,
    <>
      <path
        d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,490.667
      C126.604,490.667,21.333,385.396,21.333,256S126.604,21.333,256,21.333S490.667,126.604,490.667,256S385.396,490.667,256,490.667
      z"
      />
      <path
        d="M394.667,245.333h-128v-128c0-5.896-4.771-10.667-10.667-10.667s-10.667,4.771-10.667,10.667v128h-128
      c-5.896,0-10.667,4.771-10.667,10.667s4.771,10.667,10.667,10.667h128v128c0,5.896,4.771,10.667,10.667,10.667
      s10.667-4.771,10.667-10.667v-128h128c5.896,0,10.667-4.771,10.667-10.667S400.563,245.333,394.667,245.333z"
      />
    </>,
  ],
  delete: [
    340,
    427.00131,
    <>
      <path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
      <path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
      <path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0" />
      <path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0" />
    </>,
  ],
  file: [
    512,
    512,
    <>
      <path d="M32,120V456a40.045,40.045,0,0,0,40,40H288v-.135a8.016,8.016,0,0,0,1.454.135H446.546a8,8,0,0,0,7.967-7.275L471.305,304H472a8,8,0,0,0,8-8V264a8,8,0,0,0-8-8H432V104a8,8,0,0,0-2.343-5.657l-80-80A8,8,0,0,0,344,16H136A40.045,40.045,0,0,0,96,56V80H72A40.045,40.045,0,0,0,32,120ZM439.24,480H296.76l-16-176H455.24ZM464,272v16H272V272ZM352,43.313,404.687,96H376a24.028,24.028,0,0,1-24-24ZM112,56a24.027,24.027,0,0,1,24-24H336V72a40.045,40.045,0,0,0,40,40h40V256H368V168a8,8,0,0,0-2.343-5.657l-80-80A8,8,0,0,0,280,80H112ZM340.687,160H312a24.028,24.028,0,0,1-24-24V107.313ZM48,120A24.027,24.027,0,0,1,72,96H272v40a40.045,40.045,0,0,0,40,40h40v80H264a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8h.694l16,176H72a24.027,24.027,0,0,1-24-24Z" />
      <path d="M160,216a8,8,0,0,0,8,8H312a8,8,0,0,0,0-16H168A8,8,0,0,0,160,216Z" />
      <path d="M88,272H216a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M88,368H232a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M88,224h48a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M88,320H224a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M88,416h48a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M88,176h96a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M232,400H168a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" />
      <path d="M407.336,447.973q.339.027.673.027a8,8,0,0,0,7.964-7.336l8-96a8,8,0,0,0-15.946-1.328l-8,96A8,8,0,0,0,407.336,447.973Z" />
      <path d="M368,448a8,8,0,0,0,8-8V344a8,8,0,0,0-16,0v96A8,8,0,0,0,368,448Z" />
      <path d="M320.027,440.664A8,8,0,0,0,327.991,448q.335,0,.673-.027a8,8,0,0,0,7.309-8.637l-8-96a8,8,0,0,0-15.946,1.328Z" />
    </>,
  ],
  "file-1": [
    512,
    512,
    <>
      <path d="M376,16H168a40.045,40.045,0,0,0-40,40V80H104a40.045,40.045,0,0,0-40,40V456a40.045,40.045,0,0,0,40,40H360a40.045,40.045,0,0,0,40-40V432h24a40.045,40.045,0,0,0,40-40V104a8,8,0,0,0-2.343-5.657l-80-80A8,8,0,0,0,376,16Zm8,440a24.027,24.027,0,0,1-24,24H104a24.027,24.027,0,0,1-24-24V120a24.027,24.027,0,0,1,24-24H304v40a40.045,40.045,0,0,0,40,40h40ZM320,136V107.313L372.687,160H344A24.027,24.027,0,0,1,320,136ZM448,392a24.027,24.027,0,0,1-24,24H400V168a8,8,0,0,0-2.343-5.657l-80-80A8,8,0,0,0,312,80H144V56a24.027,24.027,0,0,1,24-24H368V72a40.045,40.045,0,0,0,40,40h40ZM384,43.313,436.687,96H408a24.027,24.027,0,0,1-24-24Z" />
      <path d="M200,208a8,8,0,0,0,0,16H344a8,8,0,0,0,0-16Z" />
      <path d="M120,272H248a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M344,304H248a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" />
      <path d="M120,368H264a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M120,224h48a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M344,256H280a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" />
      <path d="M120,320h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M344,352H296a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
      <path d="M168,400H120a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
      <path d="M120,176h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M280,400H200a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z" />
      <path d="M344,400H312a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z" />
    </>,
  ],
  "file-2": [
    512,
    512,
    <>
      <path d="M72,496H368a111.991,111.991,0,0,0,48-213.179V120a8,8,0,0,0-2.343-5.657l-96-96A8,8,0,0,0,312,16H72A40.045,40.045,0,0,0,32,56V456A40.045,40.045,0,0,0,72,496ZM464,384a96,96,0,1,1-96-96A96.108,96.108,0,0,1,464,384ZM320,43.313,388.687,112H344a24.027,24.027,0,0,1-24-24ZM48,56A24.028,24.028,0,0,1,72,32H304V88a40.045,40.045,0,0,0,40,40h56V276.666A111.983,111.983,0,0,0,310.369,480H72a24.028,24.028,0,0,1-24-24Z" />
      <path d="M160,168a8,8,0,0,0,8,8H360a8,8,0,0,0,0-16H168A8,8,0,0,0,160,168Z" />
      <path d="M88,224H248a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M280,256H216a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" />
      <path d="M88,320H232a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M88,176h48a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M360,208H280a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z" />
      <path d="M88,272h96a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M216,400H184a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z" />
      <path d="M88,416h64a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M88,368h48a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M88,128h96a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
      <path d="M216,352H168a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
      <path d="M360,328v48H312a8,8,0,0,0,0,16h48v48a8,8,0,0,0,16,0V392h48a8,8,0,0,0,0-16H376V328a8,8,0,0,0-16,0Z" />
    </>,
  ],
  document: [
    511,
    512,
    <>
      <path d="m482.480469 54h-34v-24c0-16.542969-13.457031-30-30-30h-310c-16.542969 0-30 13.457031-30 30v152.53125l-13.128907-13.132812c-7.179687-7.175782-16.71875-11.128907-26.871093-11.128907-10.148438 0-19.691407 3.953125-26.871094 11.128907-14.8125 14.816406-14.8125 38.925781 0 53.742187l66.871094 66.871094v137.988281c0 16.542969 13.457031 30 30 30h34v24c0 16.542969 13.457031 30 30 30h310c16.542969 0 30-13.457031 30-30v-398c0-16.542969-13.457031-30-30-30zm-374-34h310c5.515625 0 10 4.484375 10 10v398c0 5.515625-4.484375 10-10 10h-121.617188l-25.996093-62.03125c-.503907-1.199219-1.234376-2.289062-2.152344-3.207031l-66.589844-66.589844-103.644531-103.640625v-172.53125c0-5.515625 4.488281-10 10-10zm-62.042969 209.679688 25.453125-25.453126 175.609375 175.605469-25.457031 25.457031zm211.742188 167.757812 13.367187 31.898438-31.898437-13.367188zm-232.425782-213.894531c3.398438-3.402344 7.917969-5.273438 12.726563-5.273438 4.808593 0 9.328125 1.871094 12.730469 5.273438l6.539062 6.539062-25.453125 25.457031-6.542969-6.542968c-7.019531-7.015625-7.019531-18.433594 0-25.453125zm72.726563 244.457031v-117.988281l116.492187 116.488281c.917969.917969 2.007813 1.648438 3.207032 2.152344l22.300781 9.347656h-132c-5.511719 0-10-4.484375-10-10zm394 54c0 5.515625-4.484375 10-10 10h-310c-5.511719 0-10-4.484375-10-10v-24h256c16.542969 0 30-13.457031 30-30v-354h34c5.515625 0 10 4.484375 10 10zm0 0" />
      <path d="m161.480469 74h204c5.523437 0 10-4.476562 10-10s-4.476563-10-10-10h-204c-5.519531 0-10 4.476562-10 10s4.476562 10 10 10zm0 0" />
      <path d="m365.480469 103.007812h-70c-5.519531 0-10 4.476563-10 10 0 5.519532 4.480469 10 10 10h70c5.523437 0 10-4.480468 10-10 0-5.523437-4.476563-10-10-10zm0 0" />
      <path d="m365.480469 250.023438h-70c-5.519531 0-10 4.480468-10 10 0 5.523437 4.480469 10 10 10h70c5.523437 0 10-4.476563 10-10 0-5.519532-4.476563-10-10-10zm0 0" />
      <path d="m231.480469 250.023438h-29.332031c-5.523438 0-10 4.480468-10 10 0 5.523437 4.476562 10 10 10h29.332031c5.523437 0 10-4.476563 10-10 0-5.519532-4.476563-10-10-10zm0 0" />
      <path d="m365.480469 299.460938h-70c-5.519531 0-10 4.476562-10 10 0 5.523437 4.480469 10 10 10h70c5.523437 0 10-4.476563 10-10 0-5.523438-4.476563-10-10-10zm0 0" />
      <path d="m161.480469 123.007812h70c5.523437 0 10-4.480468 10-10 0-5.523437-4.476563-10-10-10h-70c-5.519531 0-10 4.476563-10 10 0 5.519532 4.476562 10 10 10zm0 0" />
      <path d="m161.480469 172.011719h164c5.523437 0 10-4.476563 10-10 0-5.523438-4.476563-10-10-10h-164c-5.519531 0-10 4.476562-10 10 0 5.523437 4.476562 10 10 10zm0 0" />
      <path d="m365.480469 152.011719c-2.628907 0-5.210938 1.066406-7.070313 2.929687-1.859375 1.859375-2.929687 4.4375-2.929687 7.070313 0 2.628906 1.070312 5.207031 2.929687 7.066406 1.859375 1.863281 4.441406 2.933594 7.070313 2.933594 2.628906 0 5.210937-1.070313 7.070312-2.933594 1.859375-1.859375 2.929688-4.4375 2.929688-7.066406 0-2.632813-1.070313-5.210938-2.929688-7.070313-1.859375-1.863281-4.441406-2.929687-7.070312-2.929687zm0 0" />
      <path d="m161.480469 221.019531h204c5.523437 0 10-4.476562 10-10 0-5.523437-4.476563-10-10-10h-204c-5.519531 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10zm0 0" />
    </>,
  ],
  "terms-of-use": [
    512,
    512,
    <>
      <path d="M280.757,170.927c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5H149.181c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5   H280.757z" />
      <path d="M451.521,195.197H408.04V101.18c0-15.948-11.6-29.237-26.806-31.874C378.597,54.1,365.308,42.5,349.36,42.5H165.186v-5.667   C165.186,16.523,148.663,0,128.353,0S91.521,16.523,91.521,36.833V42.5H80.58c-17.838,0-32.35,14.512-32.35,32.35v73.58   c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5V74.85c0-9.566,7.783-17.35,17.35-17.35h69.606v48.217   c0,6.195-5.04,11.235-11.235,11.235c-6.195,0-11.235-5.04-11.235-11.235V76.349c0-4.143-3.358-7.5-7.5-7.5s-7.5,3.357-7.5,7.5   v29.368c0,14.466,11.769,26.235,26.235,26.235c14.466,0,26.235-11.77,26.235-26.235V57.5H349.36c9.566,0,17.35,7.783,17.35,17.35   v120.348h-55.915c-6.755,0-12.25,5.495-12.25,12.25v19.373H110.82c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h187.725v18.419   c0,6.214,3.913,11.531,9.405,13.618v7.653H110.82c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h187.725l-32.614,39.69H110.82   c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h148.513c-0.081,0.846-0.123,1.7-0.123,2.56c0,6.937,2.718,13.634,7.452,18.37   c4.669,4.676,10.78,7.088,17.226,6.821c6.442-0.278,12.333-3.222,16.587-8.289c0.036-0.043,0.071-0.086,0.106-0.129l7.369-9.188   v75.314c0,6.343,2.633,12.492,7.224,16.87c4.378,4.176,10.044,6.438,16.057,6.438c0.38,0,0.76-0.009,1.142-0.027   c12.448-0.586,22.198-11.006,22.198-23.722v-31.618c2.579,0.987,5.378,1.528,8.3,1.528c6.013,0,11.599-2.285,15.803-6.164   c3.865,3.565,8.904,5.786,14.367,6.12v73.565c0,9.566-7.783,17.35-17.35,17.35H106.91c-7.452,0-13.822-4.723-16.274-11.332h258.723   c17.838,0,32.35-14.512,32.35-32.35v-23.892c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v23.892c0,9.566-7.783,17.35-17.35,17.35   H80.579c-9.567,0-17.35-7.783-17.35-17.35V178.427c0-4.143-3.358-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v274.892   c0,15.948,11.601,29.237,26.807,31.874C77.671,500.399,90.961,512,106.91,512h268.78c17.838,0,32.35-14.512,32.35-32.35v-77.853   c0.794-0.567,1.553-1.184,2.271-1.847c4.484,4.112,10.552,6.447,16.911,6.15c12.229-0.591,22.179-11.236,22.179-23.731v-36.61   c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v36.61c0,4.379-3.767,8.549-7.887,8.748c-3.746,0.157-7.154-2.169-8.318-5.695   c-1.101-3.42-4.234-5.73-7.827-5.761c-0.023-0.001-0.047-0.001-0.071-0.001c-3.606,0-6.78,2.297-7.915,5.745   c-2.46,7.512-13.307,7.612-15.798,0.01c-1.118-3.447-4.297-5.764-7.908-5.764c-3.612,0-6.791,2.316-7.902,5.743   c-1.124,3.43-4.3,5.734-7.903,5.734c-4.576,0-8.3-3.728-8.3-8.31c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v53.399   c0,4.613-3.546,8.533-7.905,8.739c-2.301,0.098-4.481-0.702-6.139-2.283c-1.661-1.585-2.576-3.721-2.576-6.016v-96.65   c0-3.184-2.01-6.02-5.013-7.075c-3.003-1.057-6.346-0.101-8.338,2.382l-20.66,25.756c-1.511,1.772-3.532,2.799-5.698,2.893   c-2.196,0.097-4.303-0.771-5.968-2.438c-1.946-1.947-3.063-4.778-3.063-7.768c0-2.622,0.859-5.091,2.465-7.008l44.57-54.24   c1.103-1.342,1.705-3.025,1.705-4.762V274.8H434.4v40.96c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-40.961   c7.942-0.102,14.371-6.594,14.371-14.559v-52.792C463.771,200.692,458.276,195.197,451.521,195.197z M106.521,42.5v-5.667   c0-12.039,9.794-21.833,21.833-21.833s21.833,9.794,21.833,21.833V42.5H106.521z M381.71,84.907   c6.608,2.452,11.33,8.821,11.33,16.272v94.018h-11.33V84.907z M448.771,210.197V259.8H313.545v-25.222   c0.003-0.086,0.005-0.171,0.005-0.258s-0.002-0.172-0.005-0.258v-23.865C331.173,210.198,427.638,210.199,448.771,210.197z" />
      <path d="M329.01,242.499h4.051c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5h-4.051c-4.143,0-7.5,3.357-7.5,7.5   S324.868,242.499,329.01,242.499z" />
    </>,
  ],
  calendar1: [
    512.00001,
    512,
    <>
      <path d="m7.5 364.832031c4.140625 0 7.5-3.355469 7.5-7.5v-218.441406h443.128906v82.441406c0 4.144531 3.359375 7.5 7.5 7.5 4.144532 0 7.5-3.355469 7.5-7.5v-148.222656c0-25.144531-20.457031-45.601563-45.597656-45.601563h-19.667969v-9.289062c0-10.046875-8.171875-18.21875-18.21875-18.21875h-13.933593c-10.042969 0-18.214844 8.171875-18.214844 18.21875v9.289062h-49.742188v-9.289062c0-10.046875-8.171875-18.21875-18.21875-18.21875h-13.933594c-10.042968 0-18.214843 8.171875-18.214843 18.21875v9.289062h-49.746094v-9.289062c0-10.046875-8.171875-18.21875-18.21875-18.21875h-13.929687c-10.046876 0-18.21875 8.171875-18.21875 18.21875v9.289062h-49.742188v-9.289062c0-10.046875-8.171875-18.21875-18.21875-18.21875h-13.929688c-10.046874 0-18.21875 8.171875-18.21875 18.21875v9.289062h-11.5625c-25.144531 0-45.601562 20.457032-45.601562 45.601563v284.222656c0 4.144531 3.359375 7.5 7.5 7.5zm364.996094-346.613281c0-1.773438 1.445312-3.21875 3.21875-3.21875h13.933594c1.773437 0 3.214843 1.445312 3.214843 3.21875v36.4375c0 1.773438-1.441406 3.21875-3.214843 3.21875h-13.933594c-1.773438 0-3.21875-1.441406-3.21875-3.21875zm-100.109375 0c0-1.773438 1.441406-3.21875 3.214843-3.21875h13.933594c1.773438 0 3.21875 1.445312 3.21875 3.21875v36.4375c0 1.773438-1.445312 3.21875-3.21875 3.21875h-13.933594c-1.773437 0-3.214843-1.441406-3.214843-3.21875zm-100.113281 0c0-1.773438 1.445312-3.21875 3.21875-3.21875h13.933593c1.773438 0 3.21875 1.445312 3.21875 3.21875v36.4375c0 1.773438-1.445312 3.21875-3.21875 3.21875h-13.933593c-1.773438 0-3.21875-1.441406-3.21875-3.21875zm-100.109376 0c0-1.773438 1.445313-3.21875 3.21875-3.21875h13.933594c1.773438 0 3.214844 1.445312 3.214844 3.21875v36.4375c0 1.773438-1.441406 3.21875-3.214844 3.21875h-13.933594c-1.773437 0-3.21875-1.441406-3.21875-3.21875zm-26.5625 24.289062h11.5625v12.148438c0 10.046875 8.171876 18.21875 18.21875 18.21875h13.933594c10.042969 0 18.214844-8.171875 18.214844-18.21875v-12.148438h49.746094v12.148438c0 10.046875 8.171875 18.21875 18.214844 18.21875h13.933593c10.046875 0 18.21875-8.171875 18.21875-18.21875v-12.148438h49.742188v12.148438c0 10.046875 8.171875 18.21875 18.21875 18.21875h13.933593c10.042969 0 18.214844-8.171875 18.214844-18.21875v-12.148438h49.742188v12.148438c0 10.046875 8.171875 18.21875 18.21875 18.21875h13.933594c10.042968 0 18.214843-8.171875 18.214843-18.21875v-12.148438h19.667969c16.875 0 30.601562 13.726563 30.601562 30.601563v50.78125h-443.132812v-50.78125c0-16.875 13.726562-30.601563 30.601562-30.601563zm0 0" />
      <path d="m84.910156 434.582031h-65.398437c-2.488281 0-4.511719-2.023437-4.511719-4.511719v-38.558593c0-4.144531-3.359375-7.5-7.5-7.5s-7.5 3.355469-7.5 7.5v38.558593c0 10.757813 8.753906 19.511719 19.511719 19.511719h65.398437c4.140625 0 7.5-3.359375 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5zm0 0" />
      <path d="m84.660156 160.761719h-26.070312c-4.140625 0-7.5 3.359375-7.5 7.5 0 4.144531 3.359375 7.5 7.5 7.5h26.070312c4.140625 0 7.5-3.355469 7.5-7.5 0-4.140625-3.359375-7.5-7.5-7.5zm0 0" />
      <path d="m138.707031 175.761719h26.070313c4.140625 0 7.5-3.355469 7.5-7.5 0-4.140625-3.359375-7.5-7.5-7.5h-26.070313c-4.140625 0-7.5 3.359375-7.5 7.5 0 4.144531 3.359375 7.5 7.5 7.5zm0 0" />
      <path d="m218.824219 175.761719h26.066406c4.140625 0 7.5-3.355469 7.5-7.5 0-4.140625-3.359375-7.5-7.5-7.5h-26.066406c-4.144531 0-7.5 3.359375-7.5 7.5 0 4.144531 3.355469 7.5 7.5 7.5zm0 0" />
      <path d="m298.9375 175.761719h26.070312c4.140626 0 7.5-3.355469 7.5-7.5 0-4.140625-3.359374-7.5-7.5-7.5h-26.070312c-4.140625 0-7.5 3.359375-7.5 7.5 0 4.144531 3.359375 7.5 7.5 7.5zm0 0" />
      <path d="m405.121094 160.761719h-26.066406c-4.144532 0-7.5 3.359375-7.5 7.5 0 4.144531 3.355468 7.5 7.5 7.5h26.066406c4.140625 0 7.5-3.355469 7.5-7.5 0-4.140625-3.359375-7.5-7.5-7.5zm0 0" />
      <path d="m84.660156 198.476562h-26.070312c-4.140625 0-7.5 3.355469-7.5 7.5 0 4.144532 3.359375 7.5 7.5 7.5h26.070312c4.140625 0 7.5-3.355468 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5zm0 0" />
      <path d="m138.707031 213.476562h26.070313c4.140625 0 7.5-3.355468 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5h-26.070313c-4.140625 0-7.5 3.355469-7.5 7.5 0 4.144532 3.359375 7.5 7.5 7.5zm0 0" />
      <path d="m218.824219 213.476562h26.066406c4.140625 0 7.5-3.355468 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5h-26.066406c-4.144531 0-7.5 3.355469-7.5 7.5 0 4.144532 3.355469 7.5 7.5 7.5zm0 0" />
      <path d="m298.9375 213.476562h26.070312c4.140626 0 7.5-3.355468 7.5-7.5 0-4.144531-3.359374-7.5-7.5-7.5h-26.070312c-4.140625 0-7.5 3.355469-7.5 7.5 0 4.144532 3.359375 7.5 7.5 7.5zm0 0" />
      <path d="m405.121094 198.476562h-26.066406c-4.144532 0-7.5 3.355469-7.5 7.5 0 4.144532 3.355468 7.5 7.5 7.5h26.066406c4.140625 0 7.5-3.355468 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5zm0 0" />
      <path d="m138.890625 360.714844 38.5625 38.5625c5.578125 5.578125 12.992187 8.648437 20.882813 8.648437 7.890624 0 15.308593-3.070312 20.882812-8.648437l105.605469-105.605469c11.515625-11.515625 11.515625-30.253906 0-41.769531s-30.253907-11.515625-41.769531 0l-84.71875 84.71875-17.679688-17.675782c-11.511719-11.515624-30.25-11.515624-41.769531 0-11.511719 11.515626-11.511719 30.253907.003906 41.769532zm10.605469-31.164063c2.832031-2.832031 6.554687-4.25 10.277344-4.25 3.722656 0 7.445312 1.417969 10.277343 4.25l22.980469 22.980469c2.929688 2.929688 7.675781 2.929688 10.605469 0l90.023437-90.019531c5.671875-5.667969 14.890625-5.667969 20.554688-.003907 5.667968 5.667969 5.667968 14.890626 0 20.558594l-105.601563 105.601563c-2.746093 2.746093-6.394531 4.257812-10.277343 4.257812-3.882813 0-7.53125-1.511719-10.277344-4.257812l-38.5625-38.5625c-5.667969-5.667969-5.667969-14.886719 0-20.554688zm0 0" />
      <path d="m473.128906 315.359375v-59.847656c0-4.144531-3.355468-7.5-7.5-7.5-4.140625 0-7.5 3.355469-7.5 7.5v50.28125c-13.675781-7.089844-29.195312-11.101563-45.632812-11.101563-54.867188 0-99.503906 44.636719-99.503906 99.503906 0 14.371094 3.066406 28.035157 8.570312 40.386719h-202.476562c-4.140626 0-7.5 3.355469-7.5 7.5 0 4.140625 3.359374 7.5 7.5 7.5h210.785156c17.878906 26.589844 48.242187 44.117188 82.625 44.117188 54.867187 0 99.503906-44.636719 99.503906-99.503907 0-32.0625-15.25-60.628906-38.871094-78.835937zm-60.632812 163.339844c-46.597656 0-84.503906-37.90625-84.503906-84.503907 0-46.597656 37.910156-84.503906 84.503906-84.503906s84.503906 37.90625 84.503906 84.503906c0 46.597657-37.910156 84.503907-84.503906 84.503907zm0 0" />
      <path d="m412.496094 320.527344c-40.621094 0-73.667969 33.050781-73.667969 73.667968 0 40.621094 33.046875 73.667969 73.667969 73.667969s73.664062-33.046875 73.664062-73.667969c0-40.617187-33.046875-73.667968-73.664062-73.667968zm6.714844 131.9375c.496093-1.003906.785156-2.128906.785156-3.324219v-9.136719c0-4.140625-3.359375-7.5-7.5-7.5s-7.5 3.359375-7.5 7.5v9.136719c0 1.195313.285156 2.320313.785156 3.324219-26.992188-3.089844-48.464844-24.5625-51.554688-51.554688 1 .5 2.128907.785156 3.324219.785156h9.132813c4.144531 0 7.5-3.355468 7.5-7.5 0-4.144531-3.355469-7.5-7.5-7.5h-9.132813c-1.195312 0-2.324219.289063-3.324219.785157 3.089844-26.992188 24.5625-48.464844 51.554688-51.554688-.5 1.003907-.785156 2.128907-.785156 3.324219v9.136719c0 4.144531 3.359375 7.5 7.5 7.5s7.5-3.355469 7.5-7.5v-9.136719c0-1.195312-.289063-2.320312-.785156-3.324219 26.992187 3.089844 48.464843 24.5625 51.554687 51.554688-1.003906-.496094-2.128906-.785157-3.324219-.785157h-9.136718c-4.140626 0-7.5 3.355469-7.5 7.5 0 4.144532 3.359374 7.5 7.5 7.5h9.136718c1.195313 0 2.320313-.285156 3.324219-.785156-3.09375 26.992188-24.5625 48.464844-51.554687 51.554688zm0 0" />
      <path d="m429.027344 386.695312h-9.03125v-7.691406c0-4.140625-3.359375-7.5-7.5-7.5-4.144532 0-7.5 3.359375-7.5 7.5v15.191406c0 4.144532 3.355468 7.5 7.5 7.5h16.53125c4.140625 0 7.5-3.355468 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5zm0 0" />
    </>,
  ],
  memories: [
    64,
    64,
    <>
      <path d="m31.978 48.97c-3.785 0-7.581-1.241-10.697-3.769-6.104-4.947-8.01-13.66-4.531-20.719.244-.494.843-.699 1.339-.454.495.244.699.844.455 1.339-3.07 6.228-1.39 13.916 3.996 18.28 6.034 4.894 14.958 4.325 20.316-1.293.38-.4 1.014-.414 1.414-.033.399.381.415 1.015.033 1.414-3.305 3.464-7.807 5.234-12.325 5.235z" />
      <path d="m46.352 40.075c-.148 0-.299-.033-.441-.104-.495-.244-.699-.844-.455-1.339 3.07-6.228 1.39-13.916-3.996-18.28-6.032-4.892-14.957-4.324-20.315 1.293-.383.4-1.015.413-1.414.033-.399-.381-.415-1.015-.033-1.414 6.074-6.365 16.185-7.01 23.022-1.466 6.104 4.947 8.01 13.661 4.53 20.719-.174.353-.529.558-.898.558z" />
      <path d="m32 31c-.552 0-1-.447-1-1v-9.002c0-.553.448-1 1-1s1 .447 1 1v9.002c0 .553-.448 1-1 1z" />
      <path d="m43.002 33h-9.002c-.552 0-1-.447-1-1s.448-1 1-1h9.002c.552 0 1 .447 1 1s-.447 1-1 1z" />
      <path d="m34 32c0-2.579-4-2.579-4 0s4 2.579 4 0z" />
      <path d="m28.845 59c-.128 0-.258-.024-.383-.076-6.511-2.707-11.668-8.336-13.795-15.057-2.052-6.476-1.281-13.562 2.114-19.442.276-.479.886-.644 1.366-.366.479.276.642.888.366 1.366-3.115 5.396-3.822 11.897-1.94 17.839 1.952 6.166 6.684 11.329 12.657 13.813.51.213.751.798.54 1.308-.161.384-.533.615-.925.615z" />
      <path d="m46.352 40.075c-.169 0-.341-.043-.499-.134-.479-.276-.642-.888-.366-1.366 3.115-5.395 3.822-11.896 1.94-17.839-1.952-6.167-6.684-11.331-12.657-13.812-.51-.212-.751-.798-.54-1.308s.796-.75 1.307-.54c6.51 2.706 11.668 8.335 13.796 15.057 2.051 6.477 1.281 13.563-2.114 19.442-.185.321-.521.5-.867.5z" />
      <path d="m20.784 27.736c-.169 0-.341-.043-.499-.134l-3.138-1.812c-.478-.276-.642-.888-.366-1.366.276-.479.886-.644 1.366-.366l3.138 1.812c.478.276.642.888.366 1.366-.186.321-.522.5-.867.5z" />
      <path d="m9.39 21.158c-.169 0-.341-.043-.499-.134l-3.138-1.812c-.478-.276-.642-.888-.366-1.366s.886-.644 1.366-.366l3.138 1.812c.478.276.642.888.366 1.366-.186.321-.522.5-.867.5z" />
      <path d="m28.847 59c-.032 0-.065-.002-.099-.005-9.428-.923-17.663-6.868-21.49-15.516-3.393-7.665-2.919-16.57 1.267-23.821.276-.478.886-.644 1.366-.366.479.276.642.888.366 1.366-3.868 6.7-4.306 14.929-1.17 22.012 3.482 7.868 11.277 13.495 19.856 14.335.549.054.951.543.897 1.093-.049.516-.485.902-.993.902z" />
      <path d="m20.784 27.736c-.523 0-.964-.407-.997-.938l-.952-15.131c-.035-.551.384-1.025.935-1.061.564-.021 1.027.384 1.061.936l.952 15.131c.035.551-.384 1.025-.935 1.061-.022.001-.043.002-.064.002z" />
      <path d="m6.253 19.347c-.368 0-.722-.203-.896-.556-.246-.494-.044-1.095.451-1.34l13.58-6.741c.496-.248 1.096-.044 1.34.451.246.494.044 1.095-.451 1.34l-13.58 6.741c-.143.071-.295.105-.444.105z" />
      <path d="m46.352 40.075c-.169 0-.341-.043-.499-.134l-3.138-1.812c-.479-.276-.642-.888-.366-1.366s.885-.643 1.366-.366l3.138 1.812c.479.276.642.888.366 1.366-.185.321-.521.5-.867.5z" />
      <path d="m57.746 46.653c-.169 0-.341-.043-.499-.134l-3.138-1.812c-.479-.276-.642-.888-.366-1.366.277-.478.885-.643 1.366-.366l3.138 1.812c.479.276.642.888.366 1.366-.185.321-.521.5-.867.5z" />
      <path d="m54.608 44.842c-.169 0-.341-.043-.499-.134-.479-.276-.642-.888-.366-1.366 3.869-6.7 4.306-14.929 1.169-22.012-3.481-7.868-11.276-13.495-19.856-14.335-.549-.054-.951-.543-.897-1.093.054-.549.539-.944 1.093-.897 9.428.923 17.663 6.868 21.49 15.516 3.394 7.665 2.92 16.57-1.266 23.821-.186.32-.522.5-.868.5z" />
      <path d="m44.167 53.395c-.523 0-.964-.407-.997-.938l-.952-15.131c-.035-.551.384-1.025.935-1.061.567-.016 1.027.384 1.061.936l.952 15.131c.035.551-.384 1.025-.935 1.061-.022.001-.043.002-.064.002z" />
      <path d="m44.168 53.395c-.368 0-.722-.203-.896-.556-.246-.494-.044-1.095.451-1.34l13.58-6.741c.497-.247 1.095-.044 1.34.451.246.494.044 1.095-.451 1.34l-13.58 6.741c-.143.071-.295.105-.444.105z" />
    </>,
  ],
  analysis: [
    512,
    512,
    <>
      <g>
        <g>
          <path
            d="M505.418,34.829c-1.288-1.529-3.131-2.484-5.123-2.654l-111.428-9.517L386.847,6.6c-0.52-4.131-4.299-7.059-8.42-6.54
        L275.06,13.056c-0.407-0.106-0.824-0.186-1.258-0.223L131.726,0.697c-4.091-0.36-7.805,2.786-8.153,6.869l-2.118,24.8
        L11.406,46.202c-4.072,0.512-7.051,4.345-6.54,8.42L61.04,501.43c0.255,2.038-0.182,3.996,0.651,5.967
        c1.168,2.761,3.948,4.604,6.947,4.604h369.909c4.165,0,7.539-3.374,7.539-7.539v-9.819l14.601,1.247
        c4.091,0.355,7.805-2.784,8.153-6.869L507.163,40.33C507.334,38.337,506.707,36.359,505.418,34.829z M61.099,381.023
        L20.768,60.221l40.331-5.07V381.023z M137.955,16.362l65.98,5.635l-67.182,8.447L137.955,16.362z M372.828,15.961l3.852,30.637
        H129.129L372.828,15.961z M454.459,480.225l-8.373-0.715V259.195c0-4.164-3.374-7.539-7.539-7.539s-7.539,3.374-7.539,7.539
        v237.727H76.177V61.676h354.832v162.338c0,4.165,3.374,7.539,7.539,7.539s7.539-3.374,7.539-7.539V54.137
        c0-4.164-3.374-7.539-7.539-7.539h-46.671l-1.087-8.643l100.709,8.602L454.459,480.225z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M398.34,86.806h-40.208c-2.521,0-4.875,1.259-6.272,3.357l-17.064,25.596c-18.367-13.157-40.854-20.912-65.12-20.912
        c-4.164,0-7.539,3.374-7.539,7.539v104.54c0,4.164,3.374,7.539,7.539,7.539h104.54c4.165,0,7.539-3.374,7.539-7.539
        c0-32.097-13.566-61.081-35.26-81.533l15.673-23.509h36.173c4.164,0,7.539-3.374,7.539-7.539S402.504,86.806,398.34,86.806z
         M366.387,199.387h-89.172v-89.172c18.283,1.412,35.15,7.932,49.206,18.107l-6.727,10.091c-2.101,3.15-1.485,7.513,1.417,9.95
        c3.398,2.854,8.669,2.101,11.128-1.586l5.757-8.636C354.025,154.063,364.543,175.527,366.387,199.387z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M398.34,336.092h-68.195l-12.016-19.225c19.465-20.17,31.459-47.598,31.459-77.775c0-4.165-3.374-7.539-7.539-7.539
        h-97.001v-97.001c0-4.164-3.375-7.539-7.539-7.539c-61.8,0-112.079,50.279-112.079,112.079c0,61.8,50.279,112.079,112.079,112.079
        c26.123,0,50.185-8.984,69.264-24.023l12.8,20.48c1.378,2.204,3.794,3.543,6.393,3.543h72.374c4.164,0,7.539-3.374,7.539-7.539
        S402.504,336.092,398.34,336.092z M292.153,275.304c-2.206-3.533-6.859-4.605-10.389-2.398c-3.531,2.206-4.605,6.858-2.398,10.389
        l19.364,30.982c-16.709,13.631-38.026,21.817-61.22,21.817c-53.486,0-97.001-43.515-97.001-97.001
        c0-50.95,39.485-92.851,89.462-96.711v96.711c0,4.164,3.375,7.539,7.539,7.539h96.711c-1.684,21.801-10.608,41.604-24.362,57.004
        L292.153,275.304z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M173.177,376.3h-64.332c-4.163,0-7.539,3.374-7.539,7.539s3.375,7.539,7.539,7.539h64.332
        c4.164,0,7.539-3.374,7.539-7.539S177.341,376.3,173.177,376.3z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M269.676,376.3h-64.332c-4.164,0-7.539,3.374-7.539,7.539s3.375,7.539,7.539,7.539h64.332
        c4.164,0,7.539-3.374,7.539-7.539S273.84,376.3,269.676,376.3z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M213.385,416.508h-104.54c-4.163,0-7.539,3.374-7.539,7.539c0,4.165,3.375,7.539,7.539,7.539h104.54
        c4.164,0,7.539-3.374,7.539-7.539C220.924,419.882,217.548,416.508,213.385,416.508z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M269.676,416.508h-24.125c-4.163,0-7.539,3.374-7.539,7.539c0,4.165,3.375,7.539,7.539,7.539h24.125
        c4.164,0,7.539-3.374,7.539-7.539C277.214,419.882,273.84,416.508,269.676,416.508z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M141.011,456.715h-32.166c-4.163,0-7.539,3.374-7.539,7.539s3.375,7.539,7.539,7.539h32.166
        c4.164,0,7.539-3.374,7.539-7.539S145.175,456.715,141.011,456.715z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M269.676,456.715h-96.498c-4.163,0-7.539,3.374-7.539,7.539s3.375,7.539,7.539,7.539h96.498
        c4.164,0,7.539-3.374,7.539-7.539S273.84,456.715,269.676,456.715z"
          />
        </g>
      </g>
    </>,
  ],
  "notice-warning": [
    21.09,
    20,
    <>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Open_application" data-name="Open application">
          <g id="Layer_12" data-name="Layer 12" fill="#000">
            <path d="M10.54,1a1.47,1.47,0,0,1,.7.19,1.34,1.34,0,0,1,.5.53l8.17,15a1.4,1.4,0,0,1,0,1.4,1.49,1.49,0,0,1-.5.58,1.46,1.46,0,0,1-.67.33H2.37c-.24,0-.46-.21-.67-.33A1.72,1.72,0,0,1,1.2,18a1.27,1.27,0,0,1,0-1.33l8.17-15a1.34,1.34,0,0,1,.5-.53A1.46,1.46,0,0,1,10.54,1m0-1A2.4,2.4,0,0,0,9.37.32a2.29,2.29,0,0,0-.89.91L.3,16.21a2.24,2.24,0,0,0,0,2.33,2.32,2.32,0,0,0,.86,1l.11.07A1.8,1.8,0,0,0,2.37,20H18.72a2,2,0,0,0,1.11-.42l.08-.06a2.32,2.32,0,0,0,.85-.94,2.36,2.36,0,0,0,0-2.36l-8.19-15a2.26,2.26,0,0,0-.89-.92A2.41,2.41,0,0,0,10.54,0Z" />
            <path
              fill="#f7ca0f"
              d="M19.91,16.69l-8.17-15a1.34,1.34,0,0,0-.5-.53,1.37,1.37,0,0,0-1.39,0,1.34,1.34,0,0,0-.5.53l-8.17,15A1.27,1.27,0,0,0,1.2,18a1.72,1.72,0,0,0,.5.65c.21.12.43.33.67.33H18.72a1.46,1.46,0,0,0,.67-.33,1.49,1.49,0,0,0,.5-.58A1.4,1.4,0,0,0,19.91,16.69ZM9.09,7.77a1.31,1.31,0,1,1,2.62,0v4a1.31,1.31,0,1,1-2.62,0Zm1.48,8.73a1.34,1.34,0,1,1,0-2.67,1.34,1.34,0,0,1,0,2.67Z"
            />
            <path
              fill="#f7ca0f"
              d="M19.91,16.69l-8.17-15a1.34,1.34,0,0,0-.5-.53,1.37,1.37,0,0,0-1.39,0,1.34,1.34,0,0,0-.5.53l-8.17,15A1.27,1.27,0,0,0,1.2,18a1.72,1.72,0,0,0,.5.65c.21.12.43.33.67.33H18.72a1.46,1.46,0,0,0,.67-.33,1.49,1.49,0,0,0,.5-.58A1.4,1.4,0,0,0,19.91,16.69ZM9.09,7.77a1.31,1.31,0,1,1,2.62,0v4a1.31,1.31,0,1,1-2.62,0Zm1.48,8.73a1.34,1.34,0,1,1,0-2.67,1.34,1.34,0,0,1,0,2.67Z"
            />
            <path d="M9,7.77a1.31,1.31,0,1,1,2.62,0v4a1.31,1.31,0,1,1-2.62,0Z" />
            <circle cx="10.47" cy="15.16" r="1.34" />
          </g>
        </g>
      </g>
    </>,
  ],
  "up-arrow": [
    490.656,
    490.656,
    <>
      <path
        d="M487.536,355.12L252.869,120.453c-4.16-4.16-10.923-4.16-15.083,0L3.12,355.12c-4.16,4.16-4.16,10.923,0,15.083
  c4.16,4.16,10.923,4.16,15.083,0l227.115-227.136l227.115,227.136c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.552-3.115
  C491.696,366.043,491.696,359.28,487.536,355.12z"
      />
    </>,
  ],
  "down-arrow": [
    490.656,
    490.656,
    <>
      <path
        d="M487.536,120.445c-4.16-4.16-10.923-4.16-15.083,0L245.339,347.581L18.203,120.467c-4.16-4.16-10.923-4.16-15.083,0
  c-4.16,4.16-4.16,10.923,0,15.083l234.667,234.667c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.136l234.667-234.667
  C491.696,131.368,491.696,124.605,487.536,120.445z"
      />
    </>,
  ],
  "left-arrow": [
    490.651,
    490.651,
    <>
      <path
        d="M143.085,245.317L370.2,18.203c4.16-4.16,4.16-10.923,0-15.083s-10.923-4.16-15.083,0L120.451,237.787
  c-4.16,4.16-4.16,10.923,0,15.083l234.667,234.667c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.531-3.136
  c4.16-4.16,4.16-10.923,0-15.083L143.085,245.317z"
      />
    </>,
  ],
  "right-arrow": [
    490.651,
    490.651,
    <>
      <path
        d="M370.2,237.787L135.533,3.12c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.16-4.16,10.923,0,15.083l227.136,227.115
  L120.451,472.453c-4.16,4.16-4.16,10.923,0,15.083c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.115L370.2,252.869
  C374.36,248.709,374.36,241.947,370.2,237.787z"
      />
    </>,
  ],
  addSQR: [
    64,
    64,
    <>
      <g id="_23" data-name="23">
        <path d="m39.47 28.64-7.12-7.11a1 1 0 0 0 -1.41 1.41l7.77 7.77a1 1 0 0 0 1.35.05l12.94-11a1 1 0 0 0 .11-1.41 1 1 0 0 0 -1.4-.11z" />
        <path d="m21 30a1 1 0 0 0 0-2h-4v-2a1 1 0 0 0 -2 0v2a5 5 0 0 0 -5 5v1a5 5 0 0 0 5 5v7h-4a1 1 0 0 0 0 2h4v2a1 1 0 0 0 2 0v-2a5 5 0 0 0 5-5v-1a5 5 0 0 0 -5-5v-7zm-1 12v1a3 3 0 0 1 -3 3v-7a3 3 0 0 1 3 3zm-5-5a3 3 0 0 1 -3-3v-1a3 3 0 0 1 3-3z" />
        <path d="m61 21h-3.29a16 16 0 1 0 .29 3c0-.34 0-.67 0-1h2v30h-56v-30h18.76a1 1 0 1 0 0-2h-19.76a1 1 0 0 0 -1 1v32a1 1 0 0 0 1 1h58a1 1 0 0 0 1-1v-32a1 1 0 0 0 -1-1zm-19 17a14 14 0 1 1 14-14 14 14 0 0 1 -14 14z" />
      </g>
    </>,
  ],
  approve: [
    448,
    448.55357,
    <>
      <path d="m224.550781 0c-123.667969 0-224.273437 100.605469-224.273437 224.277344 0 123.667968 100.605468 224.277344 224.273437 224.277344 123.664063 0 224.269531-100.609376 224.269531-224.277344 0-123.671875-100.605468-224.277344-224.269531-224.277344zm0 430.269531c-113.582031 0-205.988281-92.414062-205.988281-205.992187 0-113.582032 92.40625-205.992188 205.988281-205.992188 113.578125 0 205.984375 92.410156 205.984375 205.992188 0 113.578125-92.40625 205.992187-205.984375 205.992187zm0 0" />
      <path d="m340.378906 134.847656-159.46875 159.464844-72.191406-72.1875c-3.570312-3.570312-9.355469-3.570312-12.929688 0-3.570312 3.570312-3.570312 9.355469 0 12.929688l78.65625 78.652343c1.785157 1.785157 4.125 2.675781 6.464844 2.675781s4.679688-.890624 6.464844-2.675781l165.933594-165.929687c3.570312-3.570313 3.570312-9.359375 0-12.929688-3.570313-3.570312-9.359375-3.570312-12.929688 0zm0 0" />
    </>,
  ],
  cancel: [
    512,
    512,
    <>
      <path
        d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,490.667
				C126.604,490.667,21.333,385.396,21.333,256S126.604,21.333,256,21.333S490.667,126.604,490.667,256S385.396,490.667,256,490.667
				z"
      />
      <path
        d="M359.542,152.458c-4.167-4.167-10.917-4.167-15.083,0L256,240.917l-88.458-88.458c-4.167-4.167-10.917-4.167-15.083,0
				c-4.167,4.167-4.167,10.917,0,15.083L240.917,256l-88.458,88.458c-4.167,4.167-4.167,10.917,0,15.083
				c2.083,2.083,4.813,3.125,7.542,3.125s5.458-1.042,7.542-3.125L256,271.083l88.458,88.458c2.083,2.083,4.813,3.125,7.542,3.125
				c2.729,0,5.458-1.042,7.542-3.125c4.167-4.167,4.167-10.917,0-15.083L271.083,256l88.458-88.458
				C363.708,163.375,363.708,156.625,359.542,152.458z"
      />
    </>,
  ],
  change: [
    64,
    64,
    <>
      <path d="m42 37h-3v-1c0-.553-.447-1-1-1h-14c-.771 0-1.468.301-2 .78-.532-.48-1.229-.78-2-.78h-14c-.553 0-1 .447-1 1v1h-3c-.553 0-1 .447-1 1v24c0 .553.447 1 1 1h40c.553 0 1-.447 1-1v-24c0-.553-.447-1-1-1zm-35 0h13c.552 0 1 .448 1 1v17h2v-17c0-.552.448-1 1-1h13v20h-13c-.771 0-1.468.301-2 .78-.532-.48-1.229-.78-2-.78h-13zm34 24h-38v-22h2v19c0 .553.447 1 1 1h14c.552 0 1 .448 1 1h2c0-.552.448-1 1-1h14c.553 0 1-.447 1-1v-19h2z" />
      <path d="m25 39h10v2h-10z" />
      <path d="m25 43h10v2h-10z" />
      <path d="m25 47h10v2h-10z" />
      <path d="m25 51h10v2h-10z" />
      <path d="m9 39h10v2h-10z" />
      <path d="m9 43h10v2h-10z" />
      <path d="m9 47h10v2h-10z" />
      <path d="m9 51h10v2h-10z" />
      <path d="m62 3h-3v-1c0-.553-.447-1-1-1h-14c-.771 0-1.468.301-2 .78-.532-.479-1.229-.78-2-.78h-14c-.553 0-1 .447-1 1v1h-3c-.553 0-1 .447-1 1v24c0 .553.447 1 1 1h40c.553 0 1-.447 1-1v-24c0-.553-.447-1-1-1zm-35 0h13c.552 0 1 .448 1 1v17h2v-17c0-.552.448-1 1-1h13v20h-13c-.771 0-1.468.301-2 .78-.532-.48-1.229-.78-2-.78h-13zm34 24h-38v-22h2v19c0 .553.447 1 1 1h14c.552 0 1 .448 1 1h2c0-.552.448-1 1-1h14c.553 0 1-.447 1-1v-19h2z" />
      <path d="m45 5h10v2h-10z" />
      <path d="m45 9h10v2h-10z" />
      <path d="m45 13h10v2h-10z" />
      <path d="m45 17h10v2h-10z" />
      <path d="m29 5h10v2h-10z" />
      <path d="m29 9h10v2h-10z" />
      <path d="m29 13h10v2h-10z" />
      <path d="m29 17h10v2h-10z" />
      <path d="m62 30c-.553 0-1 .447-1 1 0 4.625-3.506 8.445-8 8.944v-2.944c0-.404-.243-.77-.617-.924-.373-.156-.804-.069-1.09.217l-6 6c-.391.391-.391 1.023 0 1.414l6 6c.191.191.447.293.707.293.129 0 .259-.024.383-.076.374-.154.617-.52.617-.924v-3.045c5.599-.507 10-5.226 10-10.955v-4c0-.553-.447-1-1-1zm-10 14c-.553 0-1 .447-1 1v1.586l-3.586-3.586 3.586-3.586v1.586c0 .553.447 1 1 1 3.415 0 6.472-1.564 8.491-4.015-1.234 3.5-4.575 6.015-8.491 6.015z" />
      <path d="m2 34c.553 0 1-.447 1-1 0-4.625 3.506-8.445 8-8.944v2.944c0 .404.243.77.617.924.374.156.803.07 1.09-.217l6-6c.391-.391.391-1.023 0-1.414l-6-6c-.286-.285-.715-.372-1.09-.217-.374.154-.617.52-.617.924v3.045c-5.599.507-10 5.226-10 10.955v4c0 .553.447 1 1 1zm10-14c.553 0 1-.447 1-1v-1.586l3.586 3.586-3.586 3.586v-1.586c0-.553-.447-1-1-1-3.415 0-6.472 1.564-8.491 4.015 1.234-3.5 4.575-6.015 8.491-6.015z" />
    </>,
  ],
  clear: [
    512,
    512,
    <>
      <path
        d="M413.351,500.234c-0.127-0.629-0.326-1.25-0.572-1.851c-0.246-0.592-0.542-1.162-0.906-1.694
			c-0.354-0.543-0.767-1.045-1.221-1.498c-0.453-0.453-0.955-0.866-1.497-1.231c-0.532-0.354-1.103-0.65-1.703-0.896
			c-0.591-0.246-1.21-0.443-1.84-0.571c-1.27-0.256-2.58-0.256-3.84,0c-0.63,0.128-1.25,0.325-1.851,0.571
			c-0.592,0.246-1.162,0.542-1.694,0.896c-0.543,0.364-1.045,0.778-1.498,1.231c-0.453,0.453-0.866,0.955-1.221,1.498
			c-0.364,0.532-0.66,1.102-0.906,1.694c-0.246,0.601-0.443,1.221-0.571,1.851c-0.128,0.63-0.186,1.279-0.186,1.92
			c0,0.639,0.059,1.29,0.186,1.92c0.128,0.63,0.325,1.25,0.571,1.84c0.246,0.601,0.542,1.172,0.906,1.703
			c0.354,0.542,0.768,1.044,1.221,1.497c0.453,0.454,0.955,0.867,1.498,1.221c0.532,0.354,1.102,0.66,1.694,0.906
			c0.601,0.246,1.221,0.443,1.851,0.561c0.63,0.128,1.28,0.197,1.92,0.197c0.639,0,1.29-0.069,1.92-0.197
			c0.63-0.118,1.25-0.315,1.84-0.561c0.601-0.246,1.172-0.551,1.703-0.906c0.542-0.353,1.044-0.767,1.497-1.221
			c1.832-1.83,2.886-4.371,2.886-6.96C413.538,501.514,413.478,500.863,413.351,500.234z"
      />

      <path
        d="M509.116,202.12L309.88,2.884c-3.846-3.844-10.079-3.844-13.925,0L15.778,283.059C5.603,293.234,0,306.764,0,321.153
			c0,14.39,5.603,27.918,15.778,38.093L152.753,496.22C162.929,506.395,176.457,512,190.847,512h183.307
			c5.437,0,9.846-4.409,9.846-9.846c0-5.437-4.409-9.846-9.846-9.846h-141.3l276.262-276.262
			C512.962,212.2,512.962,205.965,509.116,202.12z M215.015,482.296c-6.456,6.456-15.038,10.012-24.168,10.012
			c-9.13,0-17.713-3.555-24.168-10.012L29.704,345.321c-6.456-6.455-10.012-15.039-10.012-24.168
			c0-9.129,3.555-17.712,10.012-24.168l30.394-30.394l185.312,185.312L215.015,482.296z M259.335,437.976L74.023,252.665
			l23.432-23.432l185.312,185.312L259.335,437.976z M296.691,400.62L111.38,215.309l35.883-35.883l185.312,185.312L296.691,400.62z
			 M371.405,325.906l-30.394-30.394c-3.846-3.844-10.079-3.844-13.925,0c-3.845,3.845-3.845,10.079,0,13.925l30.394,30.394
			L346.5,350.811L161.188,165.5L302.917,23.77l185.312,185.312L371.405,325.906z"
      />

      <path
        d="M315.706,270.209c-3.846-3.844-10.078-3.844-13.925,0l-0.071,0.072c-3.845,3.845-3.845,10.079,0,13.925
			c1.923,1.922,4.443,2.884,6.962,2.884s5.039-0.962,6.962-2.884l0.072-0.072C319.551,280.289,319.551,274.055,315.706,270.209z"
      />
    </>,
  ],
  compare: [
    508,
    508,
    <>
      <g>
        <path d="m196.356 237.47-39.587-104.9c-.035-.092-.071-.183-.108-.273-1.922-4.673-6.426-7.69-11.478-7.69h-.013c-5.057.005-9.561 3.033-11.476 7.713-.031.075-.061.15-.089.227l-39.95 104.895c-1.966 5.161.627 10.934 5.786 12.904 4.753 1.815 10.72-.185 12.904-5.786l7.83-20.559h49.721l7.748 20.531c1.95 5.167 7.719 7.773 12.887 5.825 5.167-1.95 7.775-7.72 5.825-12.887zm-68.563-33.469 17.357-45.573 17.198 45.573zm210.207 47c-5.258 0-10-4.324-10-10v-106.394c0-5.523 4.477-10 10-10h30.905c19.013 0 34.481 15.468 34.481 34.481 0 7.998-2.735 15.37-7.318 21.227 10.18 6.968 16.873 18.678 16.873 31.921 0 21.305-17.333 38.638-38.638 38.638-7.733.001-36.288.127-36.303.127zm10-57.417v37.375c9.01-.037 21.525-.084 26.302-.084 10.277 0 18.638-8.361 18.638-18.638 0-10.285-8.361-18.652-18.638-18.652h-26.302zm0-20h20.905c7.985 0 14.481-6.503 14.481-14.496 0-7.985-6.496-14.481-14.481-14.481h-20.905zm97 126.416h-164c-5.523 0-10-4.477-10-10v-204c0-5.523 4.477-10 10-10h164c5.523 0 10 4.477 10 10v204c0 5.523-4.477 10-10 10zm-154-20h144v-184h-144zm-64 20h-164c-5.523 0-10-4.477-10-10v-204c0-5.523 4.477-10 10-10h164c5.523 0 10 4.477 10 10v204c0 5.523-4.477 10-10 10zm-154-20h144v-184h-144zm190.979 182c0 5.51-4.489 10-10 10-5.52 0-10-4.49-10-10s4.48-10 10-10c5.511 0 10 4.49 10 10zm244.021-386v264c0 22.056-17.944 40-40 40h-149.358l4.897 39.17c.279 2.096 1.61 3.587 2.98 3.99 6.976 2.05 14.964 6.679 20.77 14.4 5.332 7.091 8.21 15.52 8.21 24.44 0 5.839-4.839 10-10 10h-46.52c-5.52 0-10-4.49-10-10s4.48-10 10-10h33.92c-2.6-4.63-7.009-8.089-12.06-9.66-10.324-3.211-15.888-11.678-17.15-20.68l-5.207-41.66h-88.965l-5.207 41.66c-1.439 10.34-8.084 17.856-17.15 20.68-5.051 1.573-9.46 5.03-12.06 9.66h33.88c5.51 0 10 4.49 10 10s-4.49 10-10 10h-46.48c-5.5 0-10-4.484-10-10 0-8.92 2.847-17.372 8.21-24.44 6.129-8.076 14.064-12.431 20.77-14.4 1.497-.439 2.706-2.015 2.98-3.98l4.897-39.18h-149.357c-22.056 0-40-17.944-40-40v-264c0-22.056 17.944-40 40-40h428c22.056 0 40 17.944 40 40zm-20 264h-468c0 11.028 8.972 20 20 20h428c11.028 0 20-8.972 20-20zm0-264c0-11.028-8.972-20-20-20h-428c-11.028 0-20 8.972-20 20v244h468z" />
      </g>
    </>,
  ],
  copy: [
    512,
    512,
    <>
      <path d="M376,16H168a40.045,40.045,0,0,0-40,40V80H104a40.045,40.045,0,0,0-40,40V456a40.045,40.045,0,0,0,40,40H360a40.045,40.045,0,0,0,40-40V432h24a40.045,40.045,0,0,0,40-40V104a8,8,0,0,0-2.343-5.657l-80-80A8,8,0,0,0,376,16Zm8,440a24.027,24.027,0,0,1-24,24H104a24.027,24.027,0,0,1-24-24V120a24.027,24.027,0,0,1,24-24H304v40a40.045,40.045,0,0,0,40,40h40ZM320,136V107.313L372.687,160H344A24.027,24.027,0,0,1,320,136ZM448,392a24.027,24.027,0,0,1-24,24H400V168a8,8,0,0,0-2.343-5.657l-80-80A8,8,0,0,0,312,80H144V56a24.027,24.027,0,0,1,24-24H368V72a40.045,40.045,0,0,0,40,40h40ZM384,43.313,436.687,96H408a24.027,24.027,0,0,1-24-24Z" />
      <path d="M200,208a8,8,0,0,0,0,16H344a8,8,0,0,0,0-16Z" />
      <path d="M120,272H248a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M344,304H248a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" />
      <path d="M120,368H264a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M120,224h48a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M344,256H280a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" />
      <path d="M120,320h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M344,352H296a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
      <path d="M168,400H120a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
      <path d="M120,176h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z" />
      <path d="M280,400H200a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z" />
      <path d="M344,400H312a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z" />
    </>,
  ],
  hierarchy: [
    414.4,
    414.4,
    <>
      <path
        d="M397.6,249.2h-32.8v-42.4c0-4.8-3.2-8-8-8H215.2v-34.4H248c9.6,0,16.8-7.2,16.8-16.8V66.8c0-9.6-7.2-16.8-16.8-16.8h-81.6
			c-9.6,0-16.8,7.2-16.8,16.8v81.6c0,9.6,7.2,16.8,16.8,16.8h32.8v33.6H57.6c-4.8,0-8,3.2-8,8v42.4H16.8C7.2,249.2,0,256.4,0,266
			v81.6c0,9.6,7.2,16.8,16.8,16.8h81.6c9.6,0,16.8-7.2,16.8-16.8V266c0-9.6-7.2-16.8-16.8-16.8H65.6v-34.4h133.6v34.4h-32.8
			c-9.6,0-16.8,7.2-16.8,16.8v81.6c0,9.6,7.2,16.8,16.8,16.8H248c9.6,0,16.8-7.2,16.8-16.8V266c0-9.6-7.2-16.8-16.8-16.8h-32.8
			v-34.4h133.6v34.4H316c-9.6,0-16.8,7.2-16.8,16.8v81.6c0,9.6,7.2,16.8,16.8,16.8h81.6c9.6,0,16.8-7.2,16.8-16.8V266
			C414.4,256.4,406.4,249.2,397.6,249.2z M99.2,266C98.4,265.2,99.2,265.2,99.2,266v81.6c0,0.8,0,0.8-0.8,0.8H16.8
			c-0.8,0-0.8,0-0.8-0.8V266c0-0.8,0-0.8,0.8-0.8L99.2,266z M248.8,266C248,265.2,248.8,265.2,248.8,266v81.6c0,0.8,0,0.8-0.8,0.8
			h-81.6c-0.8,0-0.8,0-0.8-0.8V266c0-0.8,0-0.8,0.8-0.8L248.8,266z M165.6,147.6C166.4,148.4,165.6,148.4,165.6,147.6V66.8
			c0-0.8,0-0.8,0.8-0.8H248c0.8,0,0.8,0,0.8,0.8v81.6c0,0.8,0,0.8-0.8,0.8L165.6,147.6z M398.4,346.8
			C398.4,347.6,397.6,347.6,398.4,346.8l-82.4,0.8c-0.8,0-0.8,0-0.8-0.8V266c0-0.8,0-0.8,0.8-0.8h81.6c0.8,0,0.8,0,0.8,0.8V346.8z"
      />
    </>,
  ],
  history: [
    512,
    512,
    <>
      <path d="m32 456c.025 22.081 17.919 39.975 40 40h296c61.851.006 111.996-50.129 112.002-111.98.004-43.264-24.912-82.66-64.002-101.199v-162.821c0-2.122-.843-4.157-2.343-5.657l-96-96c-1.5-1.5-3.535-2.343-5.657-2.343h-240c-22.081.025-39.975 17.919-40 40zm432-72c0 53.019-42.981 96-96 96s-96-42.981-96-96 42.981-96 96-96c52.995.06 95.94 43.005 96 96zm-144-340.687 68.687 68.687h-44.687c-13.249-.015-23.985-10.751-24-24zm-272 12.687c.015-13.248 10.752-23.985 24-24h232v56c.025 22.081 17.919 39.975 40 40h56v148.666c-59.265-17.683-121.643 16.025-139.327 75.289-14.627 49.023 5.828 101.725 49.696 128.045h-238.369c-13.248-.015-23.985-10.752-24-24z" />
      <path d="m160 168c0 4.418 3.582 8 8 8h192c4.418 0 8-3.582 8-8s-3.582-8-8-8h-192c-4.418 0-8 3.582-8 8z" />
      <path d="m88 224h160c4.418 0 8-3.582 8-8s-3.582-8-8-8h-160c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
      <path d="m280 256h-64c-4.418 0-8 3.582-8 8s3.582 8 8 8h64c4.418 0 8-3.582 8-8s-3.582-8-8-8z" />
      <path d="m88 320h144c4.418 0 8-3.582 8-8s-3.582-8-8-8h-144c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
      <path d="m88 176h48c4.418 0 8-3.582 8-8s-3.582-8-8-8h-48c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
      <path d="m360 208h-80c-4.418 0-8 3.582-8 8s3.582 8 8 8h80c4.418 0 8-3.582 8-8s-3.582-8-8-8z" />
      <path d="m88 272h96c4.418 0 8-3.582 8-8s-3.582-8-8-8h-96c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
      <path d="m216 400h-32c-4.418 0-8 3.582-8 8s3.582 8 8 8h32c4.418 0 8-3.582 8-8s-3.582-8-8-8z" />
      <path d="m88 416h64c4.418 0 8-3.582 8-8s-3.582-8-8-8h-64c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
      <path d="m88 368h48c4.418 0 8-3.582 8-8s-3.582-8-8-8h-48c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
      <path d="m88 128h96c4.418 0 8-3.582 8-8s-3.582-8-8-8h-96c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
      <path d="m216 352h-48c-4.418 0-8 3.582-8 8s3.582 8 8 8h48c4.418 0 8-3.582 8-8s-3.582-8-8-8z" />
      <path d="m322.879 329.854c-3.395 2.828-3.854 7.873-1.026 11.267 0 0 0 .001.001.001 0 0 30.333 36.449 39.97 47.964.971 1.161 2.556 2.512 5.331 2.87.28.036.563.044.845.044h56c4.418 0 8-3.582 8-8s-3.582-8-8-8h-52.253l-37.6-45.122c-2.828-3.394-7.873-3.853-11.268-1.024z" />
    </>,
  ],
  edit: [
    401.52289,
    401,
    <>
      <path d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0" />
      <path d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0" />
    </>,
  ],
  filter: [
    48,
    48,
    <>
      <path d="m19 28.3v15.7c0 .35.18.67.47.85.16.1.35.15.53.15.15 0 .31-.04.45-.11l8-4c.34-.16.55-.51.55-.89v-11.7l15.83-23.75c.2-.31.22-.7.05-1.03-.17-.32-.51-.52-.88-.52h-40c-.37 0-.71.2-.88.53-.18.32-.16.72.05 1.02zm23.13-23.3-14.96 22.45c-.11.16-.17.35-.17.55v11.38l-6 3v-14.38c0-.2-.06-.39-.17-.55l-14.96-22.45z" />
    </>,
  ],
  folder: [
    512,
    512,
    <>
      <path
        d="M469.333,170.667H448v-21.333c0-23.531-19.135-42.667-42.667-42.667h-198.25l-39.542-39.542c-2-2-4.708-3.125-7.542-3.125
			H42.667C19.135,64,0,83.135,0,106.667v298.667c0,5.333,1.031,10.635,3.073,15.75l9.81-3.897l0.099,0.029l-9.878,3.962
			C9.646,437.469,25.167,448,42.667,448h362.667c19.346,0,36.083-13.005,41.069-31.685l0.119,0.039l63.375-189.833
			c0.208-0.604,0.344-1.229,0.438-1.854C511.448,220.719,512,217,512,213.333C512,189.802,492.865,170.667,469.333,170.667z
			 M21.333,106.667c0-11.76,9.573-21.333,21.333-21.333h112.917l39.542,39.542c2,2,4.708,3.125,7.542,3.125h202.667
			c11.76,0,21.333,9.573,21.333,21.333v21.333h-320c-19.792,0-36.667,13.292-41.375,32.427c-0.021,0.073-0.052,0.156-0.073,0.229
			L21.333,351.402V106.667z M489.521,219.771c-0.146,0.479-0.26,0.958-0.344,1.448l-62.885,188.385l-0.333,0.823
			c-2.354,9.563-10.833,16.24-20.625,16.24H42.667c-7.673,0-14.408-4.221-18.199-10.746l60.991-205.796
			c0.177-0.479,0.323-0.969,0.438-1.469C88.094,198.844,96.635,192,106.667,192h362.667c11.76,0,21.333,9.573,21.333,21.333
			C490.667,215.281,490.302,217.323,489.521,219.771z"
      />
    </>,
  ],
  "folder-collapse": [
    512,
    512,
    <>
      <path
        d="M469.333,85.333H249.75l-39.542-39.542c-2-2-4.708-3.125-7.542-3.125h-160C19.135,42.667,0,61.802,0,85.333v341.333
    c0,23.531,19.135,42.667,42.667,42.667h426.667c23.531,0,42.667-19.135,42.667-42.667V128
    C512,104.469,492.865,85.333,469.333,85.333z M490.667,426.667c0,11.76-9.573,21.333-21.333,21.333H42.667
    c-11.76,0-21.333-9.573-21.333-21.333V85.333C21.333,73.573,30.906,64,42.667,64H198.25l39.542,39.542
    c2,2,4.708,3.125,7.542,3.125h224c11.76,0,21.333,9.573,21.333,21.333V426.667z"
      />
    </>,
  ],
  forward_1: [
    512,
    512,
    <>
      <path
        d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,490.667
				C126.604,490.667,21.333,385.396,21.333,256S126.604,21.333,256,21.333S490.667,126.604,490.667,256S385.396,490.667,256,490.667
				z"
      />
      <path
        d="M306.208,152.458c-4.167-4.167-10.917-4.167-15.083,0c-4.167,4.167-4.167,10.917,0,15.083l77.792,77.792H117.333
				c-5.896,0-10.667,4.771-10.667,10.667s4.771,10.667,10.667,10.667h251.583l-77.792,77.792c-4.167,4.167-4.167,10.917,0,15.083
				c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125l96-96c4.167-4.167,4.167-10.917,0-15.083L306.208,152.458
				z"
      />
    </>,
  ],
  price: [
    512,
    512,
    <>
      <path
        d="M437.02,74.98C388.668,26.628,324.38,0,256,0S123.332,26.628,74.98,74.98C26.629,123.332,0,187.62,0,256
			s26.629,132.668,74.98,181.02C123.332,485.372,187.62,512,256,512s132.668-26.628,181.02-74.98
			C485.371,388.668,512,324.38,512,256S485.371,123.332,437.02,74.98z M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30
			s226,101.383,226,226S380.617,482,256,482z"
      />
      <path
        d="M272.067,241h-32.134c-18.307,0-33.2-14.893-33.2-33.199c0-18.307,14.894-33.2,33.2-33.2H304.2c8.284,0,15-6.716,15-15
			s-6.716-15-15-15H271v-33.2c0-8.284-6.716-15-15-15s-15,6.716-15,15v33.2h-1.066c-34.849,0-63.2,28.352-63.2,63.2
			c0,34.848,28.352,63.199,63.2,63.199h32.134c18.306,0,33.199,14.894,33.199,33.2c0,18.306-14.893,33.2-33.199,33.2h-64.267
			c-8.284,0-15,6.716-15,15s6.716,15,15,15H241v33.201c0,8.284,6.716,15,15,15s15-6.716,15-15V367.4h1.067
			c34.848,0,63.199-28.352,63.199-63.2S306.915,241,272.067,241z"
      />
    </>,
  ],
  info1: [
    512,
    512,
    <>
      <path
        d="M256,85.333c-23.531,0-42.667,19.135-42.667,42.667s19.135,42.667,42.667,42.667s42.667-19.135,42.667-42.667
				S279.531,85.333,256,85.333z M256,149.333c-11.76,0-21.333-9.573-21.333-21.333s9.573-21.333,21.333-21.333
				s21.333,9.573,21.333,21.333S267.76,149.333,256,149.333z"
      />
      <path
        d="M288,192h-85.333c-5.896,0-10.667,4.771-10.667,10.667v42.667c0,5.896,4.771,10.667,10.667,10.667h10.667v160
				c0,5.896,4.771,10.667,10.667,10.667h64c5.896,0,10.667-4.771,10.667-10.667V202.667C298.667,196.771,293.896,192,288,192z
				 M277.333,405.333h-42.667v-160c0-5.896-4.771-10.667-10.667-10.667h-10.667v-21.333h64V405.333z"
      />
      <path
        d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,490.667
				C126.604,490.667,21.333,385.396,21.333,256S126.604,21.333,256,21.333S490.667,126.604,490.667,256S385.396,490.667,256,490.667
				z"
      />
    </>,
  ],
  info: [
    512,
    512,
    <>
      <path
        d="M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98C26.629,123.333,0,187.62,0,256
			s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512s132.667-26.629,181.02-74.98
			C485.371,388.667,512,324.38,512,256S485.371,123.333,437.02,74.98z M256,70c30.327,0,55,24.673,55,55c0,30.327-24.673,55-55,55
			c-30.327,0-55-24.673-55-55C201,94.673,225.673,70,256,70z M326,420H186v-30h30V240h-30v-30h110v180h30V420z"
      />
    </>,
  ],
  obsolete: [
    469,
    469.33333,
    <>
      <path d="m155.429688 329.644531c-4.09375 0-8.191407-1.558593-11.304688-4.695312-6.25-6.25-6.25-16.382813 0-22.632813l158.378906-158.402344c6.25-6.25 16.382813-6.25 22.632813 0s6.25 16.382813 0 22.636719l-158.378907 158.398438c-3.136718 3.136719-7.230468 4.695312-11.328124 4.695312zm0 0" />
      <path d="m313.808594 329.644531c-4.09375 0-8.191406-1.558593-11.304688-4.695312l-158.378906-158.378907c-6.25-6.25-6.25-16.382812 0-22.632812 6.25-6.253906 16.382812-6.253906 22.632812 0l158.378907 158.398438c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.230469 4.675781-11.328125 4.675781zm0 0" />
      <path d="m325.414062 469.332031h-181.140624c-4.246094 0-8.320313-1.683593-11.308594-4.691406l-128.105469-128.085937c-3.007813-3.007813-4.691406-7.082032-4.691406-11.308594v-181.140625c0-4.242188 1.683593-8.320313 4.691406-11.304688l128.085937-128.109375c3.007813-3.007812 7.0625-4.691406 11.308594-4.691406h181.140625c4.242188 0 8.320313 1.683594 11.304688 4.691406l128.085937 128.085938c3.007813 3.007812 4.695313 7.085937 4.695313 11.308594v181.140624c0 4.246094-1.6875 8.320313-4.695313 11.308594l-128.085937 128.082032c-2.964844 3.03125-7.039063 4.714843-11.285157 4.714843zm-174.527343-32h167.894531l118.699219-118.71875v-167.894531l-118.699219-118.71875h-167.894531l-118.71875 118.71875v167.894531zm0 0" />
    </>,
  ],
  skipSQR: [
    64,
    64,
    <>
      <g id="_24" data-name="24">
        <path d="m21 30a1 1 0 0 0 0-2h-4v-2a1 1 0 0 0 -2 0v2a5 5 0 0 0 -5 5v1a5 5 0 0 0 5 5v7h-4a1 1 0 0 0 0 2h4v2a1 1 0 0 0 2 0v-2a5 5 0 0 0 5-5v-1a5 5 0 0 0 -5-5v-7zm-1 12v1a3 3 0 0 1 -3 3v-7a3 3 0 0 1 3 3zm-5-5a3 3 0 0 1 -3-3v-1a3 3 0 0 1 3-3z" />
        <path d="m61 21h-3.29a16 16 0 1 0 .29 3c0-.34 0-.67 0-1h2v30h-56v-30h18.76a1 1 0 1 0 0-2h-19.76a1 1 0 0 0 -1 1v32a1 1 0 0 0 1 1h58a1 1 0 0 0 1-1v-32a1 1 0 0 0 -1-1zm-19 17a14 14 0 1 1 14-14 14 14 0 0 1 -14 14z" />
        <path d="m50.71 15.29a1 1 0 0 0 -1.42 0l-7.29 7.3-7.29-7.3a1 1 0 0 0 -1.42 1.42l7.3 7.29-7.3 7.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l7.29-7.3 7.29 7.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-7.3-7.29 7.3-7.29a1 1 0 0 0 0-1.42z" />
      </g>
    </>,
  ],
  refresh_1: [
    512,
    512,
    <>
      <path
        d="M256,42.667c76.075,0,146.283,41.536,184.149,106.667H309.333c-5.888,0-10.667,4.779-10.667,10.667
				s4.779,10.667,10.667,10.667h149.184c1.109,0,2.197-0.277,3.264-0.64c0.363-0.107,0.768-0.128,1.131-0.277
				c0.043-0.021,0.085-0.021,0.107-0.021c0.277-0.128,0.427-0.363,0.683-0.512c3.307-1.813,5.632-5.184,5.632-9.216V10.667
				C469.333,4.779,464.555,0,458.667,0S448,4.779,448,10.667v110.656c-43.499-61.696-115.179-99.989-192-99.989
				C126.613,21.333,21.333,126.613,21.333,256c0,5.888,4.779,10.667,10.667,10.667S42.667,261.888,42.667,256
				C42.667,138.368,138.368,42.667,256,42.667z"
      />
      <path
        d="M480,245.333c-5.888,0-10.667,4.779-10.667,10.667c0,117.632-95.701,213.333-213.333,213.333
				c-76.928,0-146.091-40.747-184.213-106.667h130.88c5.888,0,10.667-4.779,10.667-10.667c0-5.888-4.779-10.667-10.667-10.667
				H53.333c-5.888,0-10.667,4.779-10.667,10.667v149.333c0,5.888,4.779,10.667,10.667,10.667S64,507.221,64,501.333V390.848
				c43.541,62.251,114.304,99.819,192,99.819c129.387,0,234.667-105.28,234.667-234.667
				C490.667,250.112,485.888,245.333,480,245.333z"
      />
    </>,
  ],
  reject: [
    512,
    512,
    <>
      <path
        d="M444.117,82.965l43.435-43.413c4.16-4.16,4.16-10.923,0-15.083c-4.16-4.16-10.923-4.16-15.083,0l-43.413,43.413
			C383.424,25.877,322.752,0,256,0C114.837,0,0,114.837,0,256c0,66.752,25.877,127.424,67.883,173.035l-43.413,43.413
			c-4.16,4.16-4.16,10.923,0,15.083c2.069,2.091,4.8,3.136,7.531,3.136s5.461-1.045,7.552-3.115l43.413-43.413
			C128.576,486.123,189.248,512,256,512c141.163,0,256-114.837,256-256C512,189.248,486.123,128.576,444.117,82.965z M21.333,256
			c0-129.387,105.28-234.667,234.667-234.667c60.864,0,116.203,23.488,157.952,61.632L82.965,413.952
			C44.821,372.203,21.333,316.864,21.333,256z M256,490.667c-60.864,0-116.203-23.488-157.952-61.632L429.035,98.048
			c38.144,41.749,61.632,97.088,61.632,157.952C490.667,385.387,385.387,490.667,256,490.667z"
      />
    </>,
  ],
  report: [
    512,
    512,
    <>
      <path
        d="M502,208.749h-64c-5.523,0-10,4.478-10,10v50.5c0,5.522,4.477,10,10,10s10-4.478,10-10v-40.5h44V492h-22h-22V344.249
			c0-5.522-4.477-10-10-10s-10,4.478-10,10V492h-20V285c0-5.522-4.477-10-10-10h-64c-5.523,0-10,4.478-10,10v207h-20V355
			c0-5.522-4.477-10-10-10h-64c-5.523,0-10,4.478-10,10v137h-20v-79.625c0-5.522-4.477-10-10-10h-64c-5.523,0-10,4.478-10,10V492H30
			c-5.514,0-10-4.486-10-10V30c0-5.514,4.486-10,10-10h257.975v66.003c0,16.542,13.458,30,30,30h66V239c0,5.522,4.477,10,10,10
			s10-4.478,10-10V106.003c0-2.652-1.054-5.195-2.929-7.071l-96-96.003C303.17,1.054,300.627,0,297.975,0H30C13.458,0,0,13.458,0,30
			v452c0,16.542,13.458,30,30,30h472c5.523,0,10-4.478,10-10V218.749C512,213.227,507.523,208.749,502,208.749z M307.975,34.143
			l61.859,61.86h-51.859c-5.515,0-10-4.486-10-10V34.143z M180,492h-44v-69.625h44V492z M284,492h-44V365h44V492z M388,492h-44V295
			h44V492z"
      />
      <path
        d="M445.07,297.82c-1.86-1.869-4.44-2.93-7.07-2.93s-5.21,1.061-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
			s1.07,5.21,2.93,7.07c1.86,1.859,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93s2.93-4.44,2.93-7.07S446.93,299.68,445.07,297.82z"
      />
      <path
        d="M145.577,54.729c-5.523,0-10,4.478-10,10v17.989c-46.031,4.997-81.975,44.097-81.975,91.435
			c0,50.715,41.26,91.975,91.975,91.975c47.338,0,86.438-35.943,91.435-81.975H255c5.523,0,10-4.478,10-10
			C265,108.302,211.427,54.729,145.577,54.729z M145.577,246.127c-39.687,0-71.975-32.288-71.975-71.975
			c0-36.293,27.005-66.399,61.975-71.282v71.282c0,5.522,4.477,10,10,10h71.282C211.976,219.122,181.87,246.127,145.577,246.127z
			 M155.577,164.153v-0.001V75.228c46.852,4.702,84.222,42.073,88.924,88.925H155.577z"
      />
      <path
        d="M255,294.25H64c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h191c5.523,0,10-4.478,10-10
			C265,298.728,260.523,294.25,255,294.25z"
      />
      <path
        d="M128,342.5H64c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h64c5.523,0,10-4.478,10-10
			C138,346.978,133.523,342.5,128,342.5z"
      />
      <path
        d="M185.15,345.43c-1.86-1.86-4.44-2.93-7.07-2.93c-2.64,0-5.21,1.069-7.07,2.93c-1.87,1.86-2.93,4.44-2.93,7.07
			s1.06,5.21,2.93,7.069c1.86,1.86,4.43,2.931,7.07,2.931c2.63,0,5.21-1.07,7.07-2.931c1.86-1.859,2.93-4.439,2.93-7.069
			S187.01,347.29,185.15,345.43z"
      />
    </>,
  ],
  upload1: [
    512,
    512,
    <>
      <path
        d="M402.048,149.824C387.221,75.968,321.387,21.333,245.333,21.333c-88.235,0-160,71.765-160,160
			c0,3.605,0.149,7.296,0.469,11.2C37.653,197.653,0,238.507,0,288c0,52.928,43.072,96,96,96h106.667
			c5.888,0,10.667-4.779,10.667-10.667c0-5.888-4.779-10.667-10.667-10.667H96c-41.173,0-74.667-33.493-74.667-74.667
			s33.493-74.667,73.963-74.688c0.469,0.085,1.771,0.213,2.24,0.213c2.731-0.469,6.101-1.28,8.192-3.605
			c2.069-2.347,3.008-5.483,2.56-8.576c-1.109-7.68-1.621-14.037-1.621-20.011c0-76.459,62.208-138.667,138.667-138.667
			c68.501,0,127.445,51.157,137.109,118.997c0.747,5.269,6.677,9.003,12.011,9.003c52.395-0.747,96.213,42.987,96.213,96
			c0,52.928-43.072,96-96,96H288c-5.888,0-10.667,4.779-10.667,10.667c0,5.888,4.779,10.667,10.667,10.667h106.667
			C459.371,384,512,331.371,512,266.667C512,204.992,464.171,154.283,402.048,149.824z"
      />
      <path
        d="M249.429,256.811c-4.011-1.685-8.555-0.747-11.627,2.304l-42.667,42.667c-4.16,4.16-4.16,10.923,0,15.083
			c4.16,4.16,10.923,4.16,15.083,0l24.448-24.448V480c0,5.888,4.779,10.667,10.667,10.667S256,485.888,256,480V266.667
			C256,262.357,253.397,258.453,249.429,256.811z"
      />
      <path
        d="M295.531,301.803l-42.667-42.667c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.16-4.16,10.923,0,15.083l42.667,42.667
			c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.115C299.691,312.725,299.691,305.963,295.531,301.803z"
      />
    </>,
  ],
  upload2: [
    512.395,
    512.395,
    <>
      <path
        d="M426.635,172.393C402.969,78.116,307.358,20.874,213.08,44.54C139.404,63.034,85.907,126.711,80.395,202.473
				C28.082,211.1-7.333,260.501,1.294,312.814c7.669,46.507,47.967,80.566,95.101,80.379h176v-32h-176c-35.346,0-64-28.654-64-64
				c0-35.346,28.654-64,64-64c8.837,0,16-7.163,16-16c-0.08-79.529,64.327-144.065,143.856-144.144
				c68.844-0.069,128.107,48.601,141.424,116.144c1.315,6.744,6.788,11.896,13.6,12.8c39.586,5.434,69.092,39.243,69.12,79.2h32
				C512.357,229.476,476.913,184.51,426.635,172.393z"
      />
      <path
        d="M373.035,269.833l-64,64l22.56,22.56l36.8-36.64v153.44h32v-153.44l36.64,36.64l22.56-22.56l-64-64
				C389.354,263.629,379.276,263.629,373.035,269.833z"
      />
    </>,
  ],
  spec: [
    128,
    128,
    <>
      <path d="m123.705 106.046-48.858-42.566 7.5-8.6a16.7 16.7 0 0 0 21.368-3.595l17.281-20.636a16.989 16.989 0 0 0 -.277-22.46 16.708 16.708 0 0 0 -22.949-1.429l-21 17.583a16.7 16.7 0 0 0 -3.595 21.369l-9.363 8.157-6.074-5.293a16.7 16.7 0 0 0 -3.6-21.368l-9.418-7.893-17.842-17.842a5.029 5.029 0 1 0 -7.112 7.112l15.513 15.515a1.578 1.578 0 0 1 .233 2.048 1.439 1.439 0 0 1 -2.138.116l-15.643-15.644a5.028 5.028 0 1 0 -7.111 7.111l15.513 15.514a1.577 1.577 0 0 1 .232 2.048 1.438 1.438 0 0 1 -2.138.115l-15.642-15.642a5.029 5.029 0 1 0 -7.112 7.112l17.842 17.842 7.893 9.425a16.7 16.7 0 0 0 21.368 3.6l4.658 5.346-46.02 40.1a12.516 12.516 0 0 0 8.226 21.954c.142 0 .284 0 .426-.008a12.558 12.558 0 0 0 9.007-4.287l39.339-45.163 41.834 48.018a12.555 12.555 0 0 0 9.006 4.288c.142.005.284.007.426.007a12.517 12.517 0 0 0 8.227-21.954zm-67.832-45.258-5.668-6.506a1.75 1.75 0 0 0 -2.362-.257 13.193 13.193 0 0 1 -17.952-2.125l-7.942-9.483a1.418 1.418 0 0 0 -.105-.114l-17.896-17.903a1.528 1.528 0 0 1 0-2.162 1.566 1.566 0 0 1 2.162 0l15.642 15.645a4.939 4.939 0 0 0 7.322-.374 5.081 5.081 0 0 0 -.467-6.739l-15.513-15.513a1.528 1.528 0 0 1 0-2.163 1.567 1.567 0 0 1 2.162 0l15.644 15.642a4.938 4.938 0 0 0 7.322-.373 5.081 5.081 0 0 0 -.467-6.739l-15.514-15.514a1.528 1.528 0 0 1 0-2.162 1.565 1.565 0 0 1 2.162 0l17.9 17.9a1.418 1.418 0 0 0 .114.105l9.483 7.938a13.193 13.193 0 0 1 2.128 17.952 1.75 1.75 0 0 0 .257 2.362l6.869 5.985-3.139 2.735zm-33.639 57.754a9.017 9.017 0 1 1 -12.721-12.722l50.709-44.178 4.743-4.133 11.672-10.169a1.751 1.751 0 0 0 .257-2.361 13.2 13.2 0 0 1 2.127-17.952l21-17.583a13.2 13.2 0 0 1 18.137 1.127 13.485 13.485 0 0 1 .155 17.827l-17.286 20.636a13.19 13.19 0 0 1 -17.951 2.127 1.749 1.749 0 0 0 -2.361.256l-9.654 11.083-8.166 9.374zm99.625 3.317a9.015 9.015 0 0 1 -13.174-.453l-42.152-48.383 5.643-6.477.372-.427 48.858 42.566a9.015 9.015 0 0 1 .453 13.174z" />
    </>,
  ],
  timeline: [
    459.785,
    459.785,
    <>
      <path
        d="M173.322,114.954c-0.019,0.358-0.019,0.716,0,1.074c0.297,5.474,4.975,9.672,10.449,9.375h175.02
				c0.358,0.019,0.716,0.019,1.074,0c5.474-0.297,9.672-4.975,9.375-10.449V10.464c0.019-0.358,0.019-0.716,0-1.074
				c-0.297-5.474-4.975-9.672-10.449-9.375h-175.02c-0.358-0.019-0.716-0.019-1.074,0c-5.474,0.297-9.672,4.975-9.375,10.449
				V114.954z M194.22,20.913h154.122v83.592H194.22V20.913z"
      />
      <path
        d="M421.486,282.137v-104.49c0.019-0.358,0.019-0.716,0-1.074c-0.297-5.474-4.975-9.672-10.449-9.375H183.771
				c-0.358-0.019-0.716-0.019-1.074,0c-5.474,0.297-9.672,4.975-9.375,10.449v104.49c-0.019,0.358-0.019,0.716,0,1.074
				c0.297,5.474,4.975,9.672,10.449,9.375h227.265c0.358,0.019,0.716,0.019,1.074,0C417.585,292.29,421.782,287.611,421.486,282.137
				z M400.588,271.688H194.22v-83.592h206.367V271.688z"
      />
      <path
        d="M369.241,344.831c0.019-0.358,0.019-0.716,0-1.074c-0.297-5.474-4.975-9.672-10.449-9.375h-175.02
				c-0.358-0.019-0.716-0.019-1.074,0c-5.474,0.297-9.672,4.975-9.375,10.449v104.49c-0.019,0.358-0.019,0.716,0,1.074
				c0.297,5.474,4.975,9.672,10.449,9.375h175.02c0.358,0.019,0.716,0.019,1.074,0c5.474-0.297,9.672-4.975,9.375-10.449V344.831z
				 M348.343,438.872H194.22V355.28h154.122V438.872z"
      />
      <path
        d="M129.384,46.565c-5.482-24.497-29.785-39.912-54.282-34.429C54.356,16.778,39.6,35.181,39.575,56.439
				c-0.533,21.12,13.888,39.692,34.482,44.408v84.637c-24.526,5.352-40.07,29.572-34.718,54.098
				c3.789,17.365,17.353,30.929,34.718,34.718v84.637c-20.594,4.716-35.015,23.288-34.482,44.408
				c0.029,25.103,20.402,45.43,45.505,45.401c25.103-0.029,45.43-20.402,45.401-45.505c-0.024-21.259-14.781-39.661-35.526-44.304
				V274.3c20.688-4.684,35.281-23.199,35.004-44.408c0.277-21.21-14.316-39.724-35.004-44.408v-84.637
				C119.452,95.365,134.867,71.062,129.384,46.565z M110.106,403.345c-0.284,13.645-11.429,24.558-25.078,24.555
				c-13.561,0-24.555-10.994-24.555-24.555c0-13.561,10.994-24.555,24.555-24.555C98.677,378.787,109.822,389.7,110.106,403.345z
				 M109.599,229.877c0.009,13.561-10.978,24.562-24.539,24.571c-0.01,0-0.021,0-0.031,0c-13.357-0.284-24.036-11.195-24.033-24.555
				c-0.003-13.36,10.676-24.271,24.033-24.555C98.59,205.329,109.591,216.315,109.599,229.877z M85.028,80.994
				C71.671,80.71,60.993,69.799,60.996,56.439c-0.003-13.36,10.676-24.271,24.033-24.555c13.648-0.003,24.793,10.91,25.078,24.555
				C109.822,70.085,98.677,80.997,85.028,80.994z"
      />
      <path
        d="M215.118,57.484H275.2c5.771,0,10.449-4.678,10.449-10.449s-4.678-10.449-10.449-10.449h-60.082
				c-5.771,0-10.449,4.678-10.449,10.449S209.347,57.484,215.118,57.484z"
      />
      <path
        d="M327.445,67.933H215.118c-5.771,0-10.449,4.678-10.449,10.449s4.678,10.449,10.449,10.449h112.327
				c5.771,0,10.449-4.678,10.449-10.449S333.216,67.933,327.445,67.933z"
      />
      <path
        d="M215.118,224.668H275.2c5.771,0,10.449-4.678,10.449-10.449s-4.678-10.449-10.449-10.449h-60.082
				c-5.771,0-10.449,4.678-10.449,10.449S209.347,224.668,215.118,224.668z"
      />
      <path
        d="M215.118,256.015h112.327c5.771,0,10.449-4.678,10.449-10.449s-4.678-10.449-10.449-10.449H215.118
				c-5.771,0-10.449,4.678-10.449,10.449S209.347,256.015,215.118,256.015z"
      />
      <path
        d="M215.118,391.852H275.2c5.771,0,10.449-4.678,10.449-10.449s-4.678-10.449-10.449-10.449h-60.082
				c-5.771,0-10.449,4.678-10.449,10.449S209.347,391.852,215.118,391.852z"
      />
      <path
        d="M215.118,423.198h112.327c5.771,0,10.449-4.678,10.449-10.449s-4.678-10.449-10.449-10.449H215.118
				c-5.771,0-10.449,4.678-10.449,10.449S209.347,423.198,215.118,423.198z"
      />
    </>,
  ],
  whereused: [
    682.66799,
    682,
    <>
      <path d="m626.074219 489.339844-94.222657-94.21875c11.484376-21.945313 17.992188-46.878906 17.992188-73.316406 0-43.375-17.503906-82.734376-45.816406-111.40625.367187-1.171876.558594-2.417969.558594-3.707032v-152.390625c0-30.996093-25.214844-56.214843-56.21875-56.214843h-367.601563c-31 0-56.21875 25.21875-56.21875 56.214843v243.808594h-12.046875c-6.90625 0-12.5 5.601563-12.5 12.5 0 39.980469 32.523438 72.507813 72.503906 72.507813h172.371094c24.023438 57.125 80.558594 97.339843 146.316406 97.339843 26.433594 0 51.371094-6.507812 73.316406-17.992187l40.742188 40.746094c.003906.003906.007812.011718.015625.015624.003906.003907.007813.007813.011719.015626l53.453125 53.445312c8.988281 8.996094 20.953125 13.945312 33.671875 13.945312 12.714844 0 24.675781-4.949218 33.671875-13.945312 18.570312-18.570312 18.570312-48.777344 0-67.347656zm-576.523438-435.039063c0-17.210937 14.003907-31.214843 31.214844-31.214843h367.609375c17.210938 0 31.210938 14.003906 31.210938 31.214843v135.824219c-25.273438-17.019531-55.695313-26.96875-88.390626-26.96875-79.429687 0-145.40625 58.671875-156.878906 134.953125h-184.765625zm22.953125 303.8125c-21.871094 0-40.332031-14.851562-45.832031-35h205.886719c.097656 12.027344 1.539062 23.746094 4.183594 35zm193.6875 10.976563c-.230468-1.871094-.871094-3.609375-1.832031-5.132813-4.414063-13.253906-6.816406-27.425781-6.816406-42.152343 0-73.691407 59.957031-133.648438 133.648437-133.648438 73.695313 0 133.648438 59.957031 133.648438 133.648438 0 73.695312-59.953125 133.648437-133.648438 133.648437-57.050781.003906-105.863281-35.9375-125-86.363281zm251.988282 47.714844 27.914062 27.914062-31.988281 31.988281-27.914063-27.914062c12.121094-9.085938 22.902344-19.867188 31.988282-31.988281zm90.21875 122.203124c-4.277344 4.273438-9.957032 6.625-15.996094 6.625-6.042969 0-11.722656-2.351562-15.996094-6.625l-44.625-44.621093 31.992188-31.992188 44.621093 44.625c8.816407 8.820313 8.816407 23.167969.003907 31.988281zm0 0" />
      <path d="m391.191406 237.570312c-29.085937 0-52.753906 23.667969-52.753906 52.753907 0 6.90625 5.59375 12.5 12.5 12.5s12.503906-5.59375 12.503906-12.5c0-15.300781 12.449219-27.753907 27.75-27.753907 15.300782 0 27.753906 12.453126 27.753906 27.753907 0 15.304687-12.453124 27.75-27.753906 27.75-6.902344 0-12.5 5.601562-12.5 12.503906v26.523437c0 6.90625 5.597656 12.5 12.5 12.5s12.503906-5.59375 12.503906-12.5v-15.519531c23.070313-5.625 40.25-26.472656 40.25-51.257812 0-29.089844-23.664062-52.753907-52.753906-52.753907zm0 0" />
      <path d="m391.191406 393.65625c-3.292968 0-6.511718 1.328125-8.839844 3.660156-2.320312 2.324219-3.660156 5.542969-3.660156 8.839844 0 3.289062 1.339844 6.511719 3.660156 8.835938 2.328126 2.324218 5.546876 3.667968 8.839844 3.667968 3.300782 0 6.511719-1.335937 8.839844-3.667968 2.335938-2.324219 3.660156-5.546876 3.660156-8.835938 0-3.300781-1.324218-6.515625-3.660156-8.839844-2.328125-2.332031-5.539062-3.660156-8.839844-3.660156zm0 0" />
      <path d="m100.109375 102.972656h158.917969c6.90625 0 12.5-5.597656 12.5-12.5 0-6.90625-5.59375-12.5-12.5-12.5h-158.917969c-6.90625 0-12.5 5.59375-12.5 12.5 0 6.902344 5.59375 12.5 12.5 12.5zm0 0" />
      <path d="m309.03125 102.96875c3.289062 0 6.515625-1.335938 8.839844-3.664062 2.324218-2.324219 3.660156-5.546876 3.660156-8.835938s-1.335938-6.515625-3.660156-8.839844c-2.324219-2.324218-5.550782-3.660156-8.839844-3.660156-3.285156 0-6.511719 1.335938-8.835938 3.660156-2.324218 2.324219-3.664062 5.550782-3.664062 8.839844s1.339844 6.511719 3.664062 8.835938c2.324219 2.328124 5.550782 3.664062 8.835938 3.664062zm0 0" />
      <path d="m204.492188 218.226562h-104.382813c-6.90625 0-12.5 5.601563-12.5 12.5 0 6.902344 5.59375 12.503907 12.5 12.503907h104.382813c6.90625 0 12.5-5.601563 12.5-12.503907 0-6.898437-5.59375-12.5-12.5-12.5zm0 0" />
      <path d="m100.109375 173.097656h54.535156c6.902344 0 12.503907-5.59375 12.503907-12.5 0-6.902344-5.601563-12.5-12.503907-12.5h-54.535156c-6.90625 0-12.5 5.597656-12.5 12.5 0 6.90625 5.59375 12.5 12.5 12.5zm0 0" />
      <path d="m259.027344 148.097656h-54.535156c-6.90625 0-12.5 5.597656-12.5 12.5 0 6.90625 5.59375 12.5 12.5 12.5h54.535156c6.90625 0 12.5-5.59375 12.5-12.5 0-6.902344-5.59375-12.5-12.5-12.5zm0 0" />
    </>,
  ],
  question_default: [
    512,
    512,
    <>
      <path
        d="M290.559,257.372c-15.216,8.396-24.309,22.527-24.309,37.805v22.261
	c0,5.652-4.587,10.24-10.24,10.24c-5.673,0-10.26-4.587-10.26-10.24v-20.479c0-24.657,13.066-45.484,34.937-57.526
	c19.496-10.752,29.572-32.05,25.681-54.249c-3.604-20.52-20.479-37.395-40.999-40.999c-15.462-2.703-30.473,1.229-42.269,11.141
	c-11.632,9.769-18.288,24.063-18.288,39.238c0,5.652-4.587,10.24-10.24,10.24c-5.673,0-10.24-4.587-10.24-10.24
	c0-21.237,9.339-41.266,25.578-54.925c16.26-13.66,37.723-19.332,59.001-15.626c28.876,5.079,52.57,28.773,57.628,57.628
	C331.886,212.134,317.427,242.545,290.559,257.372 M256.01,389.115c-11.305,0-20.5-9.195-20.5-20.479
	c0-11.305,9.195-20.479,20.5-20.479c11.284,0,20.479,9.175,20.479,20.479C276.489,379.92,267.294,389.115,256.01,389.115
	 M256.01,0.01C114.847,0.01,0,114.837,0,256c0,141.143,114.847,255.99,256.01,255.99C397.153,511.99,512,397.143,512,256
	C512,114.837,397.153,0.01,256.01,0.01"
      />
    </>,
  ],
  download: [
    512,
    512,
    <>
      <path
        d="M402.048,149.824C387.221,75.968,321.387,21.333,245.333,21.333c-88.235,0-160,71.765-160,160
			c0,3.605,0.149,7.296,0.469,11.2C37.653,197.653,0,238.507,0,288c0,52.928,43.072,96,96,96h106.667
			c5.888,0,10.667-4.779,10.667-10.667c0-5.888-4.779-10.667-10.667-10.667H96c-41.173,0-74.667-33.493-74.667-74.667
			s33.493-74.667,73.963-74.688c0.469,0.085,1.771,0.213,2.24,0.213c2.901-0.469,6.123-1.28,8.192-3.605
			c2.069-2.347,3.008-5.483,2.56-8.576c-1.109-7.68-1.621-14.037-1.621-20.011c0-76.459,62.208-138.667,138.667-138.667
			c68.501,0,127.445,51.157,137.109,118.997c0.747,5.355,6.4,9.088,12.224,9.003c52.928,0,96,43.072,96,96c0,52.928-43.072,96-96,96
			H288c-5.888,0-10.667,4.779-10.667,10.667c0,5.888,4.779,10.667,10.667,10.667h106.667C459.371,384,512,331.371,512,266.667
			C512,204.992,464.171,154.283,402.048,149.824z"
      />

      <path
        d="M245.333,256c-5.888,0-10.667,4.779-10.667,10.667v187.584l-24.469-24.448c-4.16-4.16-10.923-4.16-15.083,0
			c-4.16,4.16-4.16,10.923,0,15.083l42.667,42.667c2.048,2.027,4.779,3.115,7.552,3.115c1.365,0,2.752-0.256,4.075-0.811
			c3.989-1.643,6.592-5.547,6.592-9.856V266.667C256,260.779,251.221,256,245.333,256z"
      />

      <path
        d="M295.531,429.803c-4.16-4.16-10.923-4.16-15.083,0l-42.667,42.667c-4.16,4.16-4.16,10.923,0,15.083
			c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.531-3.115l42.667-42.667
			C299.691,440.725,299.691,433.963,295.531,429.803z"
      />
    </>,
  ],
  back: [
    512,
    512,
    <>
      <path
        d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,490.667
				C126.604,490.667,21.333,385.396,21.333,256S126.604,21.333,256,21.333S490.667,126.604,490.667,256S385.396,490.667,256,490.667
				z"
      />
      <path
        d="M394.667,245.333H143.083l77.792-77.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-96,96
				c-4.167,4.167-4.167,10.917,0,15.083l96,96c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125
				c4.167-4.167,4.167-10.917,0-15.083l-77.792-77.792h251.583c5.896,0,10.667-4.771,10.667-10.667S400.563,245.333,394.667,245.333
				z"
      />
    </>,
  ],
  calendar: [
    64,
    64,
    <>
      <path d="M57,8H52V6a4,4,0,0,0-8,0V8H36V6a4,4,0,0,0-8,0V8H20V6a4,4,0,0,0-8,0V8H7a5,5,0,0,0-5,5V53a5,5,0,0,0,5,5H35a1,1,0,0,0,0-2H7a3.009,3.009,0,0,1-3-3V22H60V39a1,1,0,0,0,2,0V13A5,5,0,0,0,57,8ZM46,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM30,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM14,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM60,20H4V13a3.009,3.009,0,0,1,3-3h5v2a4,4,0,0,0,8,0V10h8v2a4,4,0,0,0,8,0V10h8v2a4,4,0,0,0,8,0V10h5a3.009,3.009,0,0,1,3,3Z" />
      <path d="M30,29a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V29h4v3Z" />
      <path d="M18,29a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V29h4v3Z" />
      <path d="M52,34a2,2,0,0,0,2-2V29a2,2,0,0,0-2-2H48a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2Zm-4-5h4v3H48Z" />
      <path d="M30,38a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V38h4v3Z" />
      <path d="M18,38a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V38h4v3Z" />
      <path d="M28,45H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V47A2,2,0,0,0,28,45Zm-4,5V47h4v3Z" />
      <path d="M36,34h4a2,2,0,0,0,2-2V29a2,2,0,0,0-2-2H36a2,2,0,0,0-2,2v3A2,2,0,0,0,36,34Zm0-5h4v3H36Z" />
      <path d="M34,41a2,2,0,0,0,2,2,1,1,0,0,0,0-2V38h4a1,1,0,0,0,0-2H36a2,2,0,0,0-2,2Z" />
      <path d="M16,45H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V47A2,2,0,0,0,16,45Zm-4,5V47h4v3Z" />
      <path d="M49,36A13,13,0,1,0,62,49,13.015,13.015,0,0,0,49,36Zm0,24A11,11,0,1,1,60,49,11.013,11.013,0,0,1,49,60Z" />
      <path d="M54.778,44.808,47,52.586,43.465,49.05a1,1,0,0,0-1.414,1.414l4.242,4.243a1,1,0,0,0,1.414,0l8.485-8.485a1,1,0,0,0-1.414-1.414Z" />
    </>,
  ],
  propose: [
    480,
    480,
    <>
      <path d="m240 0c-132.546875 0-240 107.453125-240 240s107.453125 240 240 240 240-107.453125 240-240c-.148438-132.484375-107.515625-239.851562-240-240zm0 464c-123.710938 0-224-100.289062-224-224s100.289062-224 224-224 224 100.289062 224 224c-.140625 123.652344-100.347656 223.859375-224 224zm0 0" />
      <path d="m245.121094 121.855469c-.242188-.148438-.496094-.285157-.753906-.40625-.316407-.242188-.648438-.457031-1-.648438-.222657-.097656-.449219-.183593-.679688-.257812-.378906-.121094-.765625-.214844-1.160156-.277344-.386719-.097656-.777344-.160156-1.175782-.195313-.128906 0-.222656-.070312-.351562-.070312s-.230469.0625-.359375.070312c-.386719.035157-.769531.097657-1.144531.1875-.40625.0625-.804688.160157-1.191406.285157-.234376.089843-.457032.152343-.679688.257812-.34375.191407-.671875.40625-.984375.640625-.242187.167969-.527344.222656-.761719.414063l-96 80c-2.273437 1.804687-3.390625 4.703125-2.921875 7.566406.472657 2.867187 2.460938 5.25 5.195313 6.230469 2.730468.980468 5.78125.402344 7.96875-1.507813l82.878906-69.066406v206.921875c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-206.921875l82.878906 69.066406c2.1875 1.910157 5.238282 2.488281 7.96875 1.507813 2.734375-.980469 4.722656-3.363282 5.195313-6.230469.46875-2.863281-.648438-5.761719-2.921875-7.566406zm0 0" />
    </>,
  ],
  archive: [
    551.13,
    551.13,
    <>
      <path d="m275.531 172.228-.05 120.493c0 4.575 1.816 8.948 5.046 12.177l86.198 86.181 24.354-24.354-81.153-81.136.05-113.361z" />
      <path d="m310.011 34.445c-121.23 0-221.563 90.033-238.367 206.674h-71.644l86.114 86.114 86.114-86.114h-65.78c16.477-97.589 101.355-172.228 203.563-172.228 113.966 0 206.674 92.707 206.674 206.674s-92.707 206.674-206.674 206.674c-64.064 0-123.469-28.996-162.978-79.555l-27.146 21.192c46.084 58.968 115.379 92.808 190.124 92.808 132.955 0 241.119-108.181 241.119-241.119s-108.164-241.119-241.119-241.12z" />
    </>,
  ],
  hypothetical: [
    512,
    512,
    <>
      <path
        d="M346,319c-5.522,0-10,4.477-10,10v69c0,27.57-22.43,50-50,50H178.032c-5.521,0-9.996,4.473-10,9.993l-0.014,19.882
			l-23.868-23.867c-1.545-3.547-5.081-6.008-9.171-6.008H70c-27.57,0-50-22.43-50-50V244c0-27.57,22.43-50,50-50h101
			c5.522,0,10-4.477,10-10s-4.478-10-10-10H70c-38.598,0-70,31.402-70,70v154c0,38.598,31.402,70,70,70h59.858l41.071,41.071
			c1.913,1.913,4.47,2.929,7.073,2.929c1.287,0,2.586-0.249,3.821-0.76c3.737-1.546,6.174-5.19,6.177-9.233L188.024,468H286
			c38.598,0,70-31.402,70-70v-69C356,323.477,351.522,319,346,319z"
      />

      <path
        d="M366.655,0h-25.309C261.202,0,196,65.202,196,145.346s65.202,145.345,145.345,145.345h25.309
			c12.509,0,24.89-1.589,36.89-4.729l37.387,37.366c1.913,1.911,4.469,2.927,7.071,2.927c1.289,0,2.589-0.249,3.826-0.762
			c3.736-1.548,6.172-5.194,6.172-9.238v-57.856c15.829-12.819,28.978-29.012,38.206-47.102
			C506.687,190.751,512,168.562,512,145.346C512,65.202,446.798,0,366.655,0z M441.983,245.535
			c-2.507,1.889-3.983,4.847-3.983,7.988v38.6l-24.471-24.458c-1.904-1.902-4.458-2.927-7.07-2.927c-0.98,0-1.97,0.145-2.936,0.442
			c-11.903,3.658-24.307,5.512-36.868,5.512h-25.309c-69.117,0-125.346-56.23-125.346-125.346S272.23,20,341.346,20h25.309
			C435.771,20,492,76.23,492,145.346C492,185.077,473.77,221.595,441.983,245.535z"
      />

      <path
        d="M399.033,109.421c-1.443-20.935-18.319-37.811-39.255-39.254c-11.868-0.815-23.194,3.188-31.863,11.281
			c-8.55,7.981-13.453,19.263-13.453,30.954c0,5.523,4.478,10,10,10c5.522,0,10-4.477,10-10c0-6.259,2.522-12.06,7.1-16.333
			c4.574-4.269,10.552-6.382,16.842-5.948c11.028,0.76,19.917,9.649,20.677,20.676c0.768,11.137-6.539,20.979-17.373,23.403
			c-8.778,1.964-14.908,9.592-14.908,18.549v24.025c0,5.523,4.478,10,10,10c5.523,0,10-4.477,9.999-10v-23.226
			C386.949,148.68,400.468,130.242,399.033,109.421z"
      />

      <path
        d="M363.87,209.26c-1.86-1.86-4.44-2.93-7.07-2.93s-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
			c0,2.64,1.071,5.22,2.93,7.08c1.86,1.86,4.44,2.92,7.07,2.92s5.21-1.06,7.07-2.92c1.86-1.87,2.93-4.44,2.93-7.08
			C366.8,213.7,365.729,211.12,363.87,209.26z"
      />

      <path d="M275,310H64c-5.522,0-10,4.477-10,10s4.478,10,10,10h211c5.523,0,10-4.477,10-10S280.522,310,275,310z" />

      <path
        d="M282.069,368.93C280.21,367.07,277.63,366,275,366s-5.21,1.07-7.07,2.93c-1.861,1.86-2.93,4.44-2.93,7.07
			s1.07,5.21,2.93,7.07c1.86,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.069-2.93c1.861-1.86,2.931-4.43,2.931-7.07
			C285,373.37,283.929,370.79,282.069,368.93z"
      />

      <path d="M235.667,366H64c-5.522,0-10,4.477-10,10s4.478,10,10,10h171.667c5.523,0,10-4.477,10-10S241.189,366,235.667,366z" />

      <path d="M210,254H64c-5.522,0-10,4.477-10,10s4.478,10,10,10h146c5.523,0,10-4.477,10-10S215.522,254,210,254z" />
    </>,
  ],
  processing: [
    60,
    60,
    <>
      <path d="M2.245,29H4a1,1,0,0,1,1,1A24.943,24.943,0,0,0,17.2,51.465a6.144,6.144,0,0,1,1.976-3.195l.188-.163A20.9,20.9,0,0,1,9,30a1,1,0,0,1,1-1h1.755a.229.229,0,0,0,.222-.141.218.218,0,0,0-.037-.25L7.186,23.084a.247.247,0,0,0-.371,0L2.06,28.609a.218.218,0,0,0-.037.25A.229.229,0,0,0,2.245,29Z" />
      <path d="M11.738,19.167l.163.19A20.869,20.869,0,0,1,30,9a1,1,0,0,1,1,1v1.755a.229.229,0,0,0,.141.222.219.219,0,0,0,.25-.037l5.524-4.754a.247.247,0,0,0,0-.372L31.391,2.06a.221.221,0,0,0-.25-.037A.229.229,0,0,0,31,2.245V4a1,1,0,0,1-1,1A24.94,24.94,0,0,0,8.535,17.2a6.2,6.2,0,0,1,3.2,1.971Z" />
      <path d="M28.859,48.023a.252.252,0,0,0-.1-.023.223.223,0,0,0-.147.06l-5.526,4.754a.248.248,0,0,0,0,.372l5.525,4.754a.221.221,0,0,0,.25.037A.229.229,0,0,0,29,57.755V56a1,1,0,0,1,1-1A24.943,24.943,0,0,0,51.466,42.8a6.246,6.246,0,0,1-3.2-1.98v0l-.155-.179A20.9,20.9,0,0,1,30,51a1,1,0,0,1-1-1V48.245A.229.229,0,0,0,28.859,48.023Z" />
      <path d="M51,30a1,1,0,0,1-1,1H48.245a.229.229,0,0,0-.222.141.218.218,0,0,0,.037.25l4.754,5.524a.216.216,0,0,0,.371,0l4.755-5.525a.218.218,0,0,0,.037-.25A.229.229,0,0,0,57.755,31H56a1,1,0,0,1-1-1A24.941,24.941,0,0,0,42.8,8.534a6.239,6.239,0,0,1-1.98,3.2l-.181.156A20.9,20.9,0,0,1,51,30Z" />
    </>,
  ],
  release: [
    511.784,
    511.784,
    <>
      <path
        d="M459.67,196.968l-176-192c-6.048-6.624-17.504-6.624-23.552,0l-176,192c-4.32,4.672-5.408,11.456-2.88,17.248
			c2.56,5.824,8.32,9.568,14.656,9.568h80v87.36c0,36.96-11.2,72.64-32.352,103.2c-21.12,30.464-50.624,53.44-85.28,66.464
			c-7.264,2.72-11.488,10.24-10.112,17.856c1.376,7.616,8,13.12,15.744,13.12h90.88c117.536,0,213.12-95.616,213.12-213.12v-74.88
			h80c6.336,0,12.096-3.744,14.656-9.568C465.078,208.424,463.99,201.64,459.67,196.968z M351.894,191.784c-8.832,0-16,7.168-16,16
			v90.88c0,99.872-81.248,181.12-181.12,181.12h-29.632c17.088-13.248,32.16-29.088,44.704-47.2
			c24.896-35.968,38.048-77.952,38.048-121.44v-103.36c0-8.832-7.168-16-16-16h-59.616l139.616-152.32l139.616,152.32H351.894z"
      />
    </>,
  ],
  to_be_deleted: [
    512,
    512,
    <>
      <path d="M173.657,18.343A8,8,0,0,0,168,16H56A40.045,40.045,0,0,0,16,56V248a40.045,40.045,0,0,0,40,40H200a40.045,40.045,0,0,0,40-40V88a8,8,0,0,0-2.343-5.657ZM176,43.313,212.687,80H200a24.028,24.028,0,0,1-24-24ZM224,248a24.028,24.028,0,0,1-24,24H56a24.028,24.028,0,0,1-24-24V56A24.028,24.028,0,0,1,56,32H160V56a40.045,40.045,0,0,0,40,40h24Z" />
      <path d="M184,128H120a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" />
      <path d="M72,192h64a8,8,0,0,0,0-16H72a8,8,0,0,0,0,16Z" />
      <path d="M184,224H136a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
      <path d="M72,144H88a8,8,0,0,0,0-16H72a8,8,0,0,0,0,16Z" />
      <path d="M184,176H168a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z" />
      <path d="M104,224H72a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z" />
      <path d="M72,96h32a8,8,0,0,0,0-16H72a8,8,0,0,0,0,16Z" />
      <path d="M423.336,447.973q.339.027.673.027a8,8,0,0,0,7.964-7.336l8-96a8,8,0,0,0-15.946-1.328l-8,96A8,8,0,0,0,423.336,447.973Z" />
      <path d="M384,448a8,8,0,0,0,8-8V344a8,8,0,0,0-16,0v96A8,8,0,0,0,384,448Z" />
      <path d="M336.027,440.664A8,8,0,0,0,343.991,448q.335,0,.673-.027a8,8,0,0,0,7.309-8.637l-8-96a8,8,0,0,0-15.946,1.328Z" />
      <path d="M488,256H280a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8h.695l16.792,184.725A8,8,0,0,0,305.454,496H462.546a8,8,0,0,0,7.967-7.275L487.305,304H488a8,8,0,0,0,8-8V264A8,8,0,0,0,488,256ZM455.24,480H312.76l-16-176H471.24ZM480,288H288V272H480Z" />
      <path d="M477.657,178.343a8,8,0,0,0-11.314,0L448,196.686V184a72.081,72.081,0,0,0-72-72H280a8,8,0,0,0,0,16h96a56.063,56.063,0,0,1,56,56v12.686l-18.343-18.343a8,8,0,0,0-11.314,11.314l32,32a8,8,0,0,0,11.314,0l32-32A8,8,0,0,0,477.657,178.343Z" />
    </>,
  ],
  view_page: [
    520,
    520,
    <>
      <path d="m507.785 353.724c-2.051-2.543-49.599-60.856-117.785-88.974-.015-175.935.089-165.254-.188-166.667-.079-.557-.459-1.767-.95-2.708-.456-.879-1.141-1.793-1.78-2.436-.1-.1-80.033-80.179-81.266-81.063-1.644-1.18-3.676-1.876-5.816-1.876h-280c-5.523 0-10 4.477-10 10v480c0 5.522 4.477 10 10 10h360c5.522 0 10-4.478 10-10v-44.749c68.186-28.118 115.734-86.432 117.785-88.975 2.953-3.663 2.953-8.889 0-12.552zm-197.785-309.582 45.857 45.858h-45.857zm60 445.858h-340v-460h260v70c0 5.523 4.478 10 10 10h70v147.625c-16.277-4.87-33.21-7.625-50-7.625-42.868 0-88.986 18.005-133.368 52.067-33.141 25.435-53.565 50.599-54.418 51.658-2.952 3.662-2.952 8.887 0 12.549.853 1.06 21.278 26.224 54.418 51.658 39.493 30.311 87.827 53.459 138.003 51.991 15.509-.455 30.854-3.198 45.364-7.549v27.626zm6.479-50.912c-19.243 7.241-38.245 10.912-56.479 10.912-79.209 0-147.424-68.617-166.753-90 19.332-21.385 87.544-90 166.753-90 19.483 0 38.602 4.185 56.478 10.912 53.608 20.174 95.762 63.003 110.281 79.088-14.525 16.09-56.677 58.916-110.28 79.088z" />
      <path d="m320 300c-33.084 0-60 26.916-60 60s26.916 60 60 60 60-26.916 60-60-26.916-60-60-60zm0 100c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z" />
      <path d="m200 450h-140c-5.523 0-10 4.478-10 10s4.477 10 10 10h140c5.523 0 10-4.478 10-10s-4.477-10-10-10z" />
      <path d="m60 430h90c5.523 0 10-4.478 10-10s-4.477-10-10-10h-90c-5.523 0-10 4.478-10 10s4.477 10 10 10z" />
      <path d="m60 390h50c5.523 0 10-4.478 10-10s-4.477-10-10-10h-50c-5.523 0-10 4.478-10 10s4.477 10 10 10z" />
      <path d="m60 350h50c5.523 0 10-4.478 10-10s-4.477-10-10-10h-50c-5.523 0-10 4.478-10 10s4.477 10 10 10z" />
      <path d="m60 310h90c5.523 0 10-4.478 10-10s-4.477-10-10-10h-90c-5.523 0-10 4.478-10 10s4.477 10 10 10z" />
      <path d="m60 270h140c5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10h-140c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10z" />
      <path d="m60 230h280c5.522 0 10-4.477 10-10s-4.478-10-10-10h-280c-5.523 0-10 4.477-10 10s4.477 10 10 10z" />
      <path d="m60 190h280c5.522 0 10-4.477 10-10s-4.478-10-10-10h-280c-5.523 0-10 4.477-10 10s4.477 10 10 10z" />
      <path d="m60 150h280c5.522 0 10-4.477 10-10s-4.478-10-10-10h-280c-5.523 0-10 4.477-10 10s4.477 10 10 10z" />
      <path d="m60 110h200c5.522 0 10-4.477 10-10s-4.478-10-10-10h-200c-5.523 0-10 4.477-10 10s4.477 10 10 10z" />
      <path d="m60 70h200c5.522 0 10-4.477 10-10s-4.478-10-10-10h-200c-5.523 0-10 4.477-10 10s4.477 10 10 10z" />
    </>,
  ],
  preIconU: [
    512,
    512,
    <>
      <g style={{ fill: "#c47f00" }}>
        <path
          d="M246.613,0C110.295,0.118-0.118,110.721,0,247.04c0.118,136.319,110.721,246.731,247.04,246.613
			c136.235-0.118,246.613-110.591,246.613-246.826C493.418,110.522,382.918,0.117,246.613,0z M309.333,333.867
			c0.119,5.536-4.272,10.121-9.809,10.24c-0.144,0.003-0.288,0.003-0.431,0h-70.4c-24.576-0.117-44.47-20.011-44.587-44.587V150.187
			h21.333V299.52c-0.001,13.231,10.663,23.99,23.893,24.107h59.947v-174.08h21.333L309.333,333.867z"
        />
      </g>
    </>,
  ],
  iconU: [
    512,
    512,
    <>
      <g style={{ fill: "#068894" }}>
        <path
          d="M246.613,0C110.295,0.118-0.118,110.721,0,247.04c0.118,136.319,110.721,246.731,247.04,246.613
			c136.235-0.118,246.613-110.591,246.613-246.826C493.418,110.522,382.918,0.117,246.613,0z M309.333,333.867
			c0.119,5.536-4.272,10.121-9.809,10.24c-0.144,0.003-0.288,0.003-0.431,0h-70.4c-24.576-0.117-44.47-20.011-44.587-44.587V150.187
			h21.333V299.52c-0.001,13.231,10.663,23.99,23.893,24.107h59.947v-174.08h21.333L309.333,333.867z"
        />
      </g>
    </>,
  ],
  preIconP: [
    512,
    512,
    <>
      <g style={{ fill: "#c47f00" }}>
        <path
          d="M246.827,0C110.508,0,0,110.508,0,246.827s110.508,246.827,246.827,246.827s246.827-110.508,246.827-246.827
  C493.418,110.605,383.048,0.235,246.827,0z M264.961,257.28c-0.143,0.001-0.285,0.001-0.428,0H204.16v86.827h-21.333v-184.32
  c0-5.655,4.585-10.24,10.24-10.24h70.187c24.742-0.118,44.895,19.844,45.013,44.586c0,0,0,0.001,0,0.001l1.28,18.133
  C309.665,237.009,289.703,257.162,264.961,257.28z"
        />
        <path
          d="M264.759,170.235c-0.075,0.001-0.15,0.003-0.225,0.005H204.16v66.347h59.947c13.419,0.589,24.774-9.811,25.363-23.23
  c0.016-0.363,0.024-0.727,0.023-1.09v-18.133C289.262,180.704,278.188,170.004,264.759,170.235z"
        />
      </g>
    </>,
  ],
  iconP: [
    512,
    512,
    <>
      <g style={{ fill: "#068894" }}>
        <path
          d="M246.827,0C110.508,0,0,110.508,0,246.827s110.508,246.827,246.827,246.827s246.827-110.508,246.827-246.827
			C493.418,110.605,383.048,0.235,246.827,0z M264.961,257.28c-0.143,0.001-0.285,0.001-0.428,0H204.16v86.827h-21.333v-184.32
			c0-5.655,4.585-10.24,10.24-10.24h70.187c24.742-0.118,44.895,19.844,45.013,44.586c0,0,0,0.001,0,0.001l1.28,18.133
			C309.665,237.009,289.703,257.162,264.961,257.28z"
        />
        <path
          d="M264.759,170.235c-0.075,0.001-0.15,0.003-0.225,0.005H204.16v66.347h59.947c13.419,0.589,24.774-9.811,25.363-23.23
			c0.016-0.363,0.024-0.727,0.023-1.09v-18.133C289.262,180.704,278.188,170.004,264.759,170.235z"
        />
      </g>
    </>,
  ],
  preIconE: [
    512,
    512,
    <>
      <g style={{ fill: "#c47f00" }}>
        <path
          d="M246.613,0C110.295,0.118-0.118,110.721,0,247.04c0.118,136.319,110.721,246.731,247.04,246.613
			c136.235-0.118,246.613-110.591,246.613-246.826C493.418,110.522,382.918,0.117,246.613,0z M308.693,237.013v21.333H203.947
			v42.667c0,13.314,10.793,24.107,24.107,24.107h80.427v21.333h-79.787c-24.576-0.117-44.47-20.011-44.587-44.587v-142.08
			c-0.118-5.536,4.275-10.12,9.811-10.238c0.072-0.002,0.144-0.002,0.216-0.002H309.12l0.213,21.12H203.947v66.347H308.693z"
        />
      </g>
    </>,
  ],
  iconE: [
    512,
    512,
    <>
      <g style={{ fill: "#068894" }}>
        <path
          d="M246.613,0C110.295,0.118-0.118,110.721,0,247.04c0.118,136.319,110.721,246.731,247.04,246.613
			c136.235-0.118,246.613-110.591,246.613-246.826C493.418,110.522,382.918,0.117,246.613,0z M308.693,237.013v21.333H203.947
			v42.667c0,13.314,10.793,24.107,24.107,24.107h80.427v21.333h-79.787c-24.576-0.117-44.47-20.011-44.587-44.587v-142.08
			c-0.118-5.536,4.275-10.12,9.811-10.238c0.072-0.002,0.144-0.002,0.216-0.002H309.12l0.213,21.12H203.947v66.347H308.693z"
        />
      </g>
    </>,
  ],
  preIconC: [
    512,
    512,
    <>
      <g style={{ fill: "#c47f00" }}>
        <path
          d="M246.827,0C110.508,0,0,110.508,0,246.827s110.508,246.827,246.827,246.827s246.827-110.508,246.827-246.827
			C493.418,110.605,383.048,0.235,246.827,0z M310.827,299.733c-0.118,24.742-20.27,44.704-45.012,44.587c0,0-0.001,0-0.001,0
			H229.12c-24.742,0.118-44.895-19.844-45.013-44.586c0,0,0-0.001,0-0.001v-105.6c0.117-24.742,20.27-44.704,45.012-44.587
			c0,0,0.001,0,0.001,0h35.627c24.742-0.118,44.895,19.844,45.013,44.586c0,0,0,0.001,0,0.001l-0.213,10.027h-20.053v-10.027
			c-0.117-13.348-10.971-24.107-24.32-24.107H229.12c-13.427-0.354-24.598,10.244-24.952,23.671
			c-0.004,0.145-0.006,0.291-0.008,0.436V299.52c0.117,13.348,10.971,24.107,24.32,24.107h35.627
			c13.419,0.59,24.774-9.811,25.364-23.229c0.013-0.292,0.02-0.585,0.023-0.877v-10.027h21.333V299.733z"
        />
      </g>
    </>,
  ],
  iconC: [
    512,
    512,
    <>
      <g style={{ fill: "#068894" }}>
        <path
          d="M246.827,0C110.508,0,0,110.508,0,246.827s110.508,246.827,246.827,246.827s246.827-110.508,246.827-246.827
			C493.418,110.605,383.048,0.235,246.827,0z M310.827,299.733c-0.118,24.742-20.27,44.704-45.012,44.587c0,0-0.001,0-0.001,0
			H229.12c-24.742,0.118-44.895-19.844-45.013-44.586c0,0,0-0.001,0-0.001v-105.6c0.117-24.742,20.27-44.704,45.012-44.587
			c0,0,0.001,0,0.001,0h35.627c24.742-0.118,44.895,19.844,45.013,44.586c0,0,0,0.001,0,0.001l-0.213,10.027h-20.053v-10.027
			c-0.117-13.348-10.971-24.107-24.32-24.107H229.12c-13.427-0.354-24.598,10.244-24.952,23.671
			c-0.004,0.145-0.006,0.291-0.008,0.436V299.52c0.117,13.348,10.971,24.107,24.32,24.107h35.627
			c13.419,0.59,24.774-9.811,25.364-23.229c0.013-0.292,0.02-0.585,0.023-0.877v-10.027h21.333V299.733z"
        />
      </g>
    </>,
  ],
  preIconB: [
    512,
    512,
    <>
      <g style={{ fill: "#c47f00" }}>
        <path
          d="M265.173,252.373H204.16v47.147c0.117,13.348,10.971,24.107,24.32,24.107h35.627c13.419,0.59,24.774-9.811,25.364-23.229
			c0.013-0.292,0.02-0.585,0.023-0.878v-22.827C289.493,263.262,278.605,252.373,265.173,252.373z"
        />
        <path
          d="M265.173,170.027H204.16v61.867h59.947c13.295,0.707,24.646-9.498,25.353-22.793c0.023-0.438,0.035-0.876,0.034-1.314
			v-13.653C289.376,180.785,278.522,170.026,265.173,170.027z"
        />
        <path
          d="M246.827,0C110.508,0,0,110.508,0,246.827s110.508,246.827,246.827,246.827s246.827-110.508,246.827-246.827
			C493.418,110.605,383.048,0.235,246.827,0z M309.547,276.907v22.827c-0.118,24.742-20.27,44.704-45.012,44.587
			c0,0-0.001,0-0.001,0H229.12c-24.742,0.118-44.895-19.844-45.013-44.586c0,0,0-0.001,0-0.001V150.4h80.427
			c24.742-0.118,44.895,19.844,45.013,44.586c0,0,0,0.001,0,0.001l0,12.8c-0.036,13.336-6.068,25.948-16.427,34.347
			C303.472,250.722,309.488,263.456,309.547,276.907z"
        />
      </g>
    </>,
  ],
  iconB: [
    512,
    512,
    <>
      <g style={{ fill: "#068894" }}>
        <path
          d="M265.173,252.373H204.16v47.147c0.117,13.348,10.971,24.107,24.32,24.107h35.627c13.419,0.59,24.774-9.811,25.364-23.229
			c0.013-0.292,0.02-0.585,0.023-0.878v-22.827C289.493,263.262,278.605,252.373,265.173,252.373z"
        />
        <path
          d="M265.173,170.027H204.16v61.867h59.947c13.295,0.707,24.646-9.498,25.353-22.793c0.023-0.438,0.035-0.876,0.034-1.314
			v-13.653C289.376,180.785,278.522,170.026,265.173,170.027z"
        />
        <path
          d="M246.827,0C110.508,0,0,110.508,0,246.827s110.508,246.827,246.827,246.827s246.827-110.508,246.827-246.827
			C493.418,110.605,383.048,0.235,246.827,0z M309.547,276.907v22.827c-0.118,24.742-20.27,44.704-45.012,44.587
			c0,0-0.001,0-0.001,0H229.12c-24.742,0.118-44.895-19.844-45.013-44.586c0,0,0-0.001,0-0.001V150.4h80.427
			c24.742-0.118,44.895,19.844,45.013,44.586c0,0,0,0.001,0,0.001l0,12.8c-0.036,13.336-6.068,25.948-16.427,34.347
			C303.472,250.722,309.488,263.456,309.547,276.907z"
        />
      </g>
    </>,
  ],
  preIconA: [
    512,
    512,
    <>
      <g style={{ fill: "#c47f00" }}>
        <path
          d="M249.33 5.21C271.79 3.43 295.74 7.36 317.4 12.78C436.99 42.71 517.49 157.29 505.79 280.2C497.63 365.93 442.54 446.73 363.54 482.76C331.31 497.45 297.33 505.69 261.75 506.87C237.03 507.69 211.08 504.58 187.5 497.27C153.3 486.67 124.77 471.96 96.54 449.72C85.27 440.84 75.18 430.24 65.79 419.45C9.79 355.1 -8.86 263.41 16.18 181.87C38.94 107.78 97.28 46.95 169.93 20.23C196.83 10.34 220.98 7.45 249.33 5.21ZM245.25 151.01C220.92 213.62 196.58 276.22 172.25 338.83C177.81 339.46 183.65 339 189.25 339C191.34 339 194.67 339.64 196.61 338.83C198.44 338.06 201.05 327.63 202.17 325.39C205.97 317.79 208.07 309.31 211.17 301.39C213.8 294.68 217.53 288.08 219.25 281C243.42 281 267.58 281 291.75 281C299.25 300.33 306.75 319.66 314.25 338.99C322.44 338.99 330.64 338.99 338.83 338.99C339.26 334.29 334.9 327.03 333.17 322.61C328.47 310.61 323.86 298.59 319.17 286.61C312.13 268.62 305.21 250.59 298.17 232.61C297.51 230.92 297.49 229.08 296.83 227.39C292.78 217.06 288.22 206.94 284.17 196.61C283.51 194.92 283.49 193.08 282.83 191.39C279.44 182.74 275.56 174.27 272.17 165.61C271.51 163.92 271.49 162.08 270.83 160.39C269.61 157.27 267.57 154.35 266.75 151.01C259.58 151.01 252.42 151.01 245.25 151.01ZM255.25 179.17C257.54 181.14 260.61 195.63 262.17 199.61C267.19 212.44 271.79 225.53 276.83 238.39C277.49 240.08 277.51 241.92 278.17 243.61C279.68 247.47 284.18 256.15 283.83 259.99C264.97 259.99 246.11 259.99 227.25 259.99C227.84 256.19 230.42 252.21 231.83 248.61C233.91 243.3 235.75 237.91 237.83 232.61C239.52 228.3 240.48 223.7 242.17 219.39C247.38 206.1 252.15 193.18 255.25 179.17Z"
          fill-rule="evenodd"
          stroke-linejoin="round"
        />
      </g>
    </>,
  ],
  iconA: [
    512,
    512,
    <>
      <g style={{ fill: "#068894" }}>
        <path
          d="M249.33 5.21C271.79 3.43 295.74 7.36 317.4 12.78C436.99 42.71 517.49 157.29 505.79 280.2C497.63 365.93 442.54 446.73 363.54 482.76C331.31 497.45 297.33 505.69 261.75 506.87C237.03 507.69 211.08 504.58 187.5 497.27C153.3 486.67 124.77 471.96 96.54 449.72C85.27 440.84 75.18 430.24 65.79 419.45C9.79 355.1 -8.86 263.41 16.18 181.87C38.94 107.78 97.28 46.95 169.93 20.23C196.83 10.34 220.98 7.45 249.33 5.21ZM245.25 151.01C220.92 213.62 196.58 276.22 172.25 338.83C177.81 339.46 183.65 339 189.25 339C191.34 339 194.67 339.64 196.61 338.83C198.44 338.06 201.05 327.63 202.17 325.39C205.97 317.79 208.07 309.31 211.17 301.39C213.8 294.68 217.53 288.08 219.25 281C243.42 281 267.58 281 291.75 281C299.25 300.33 306.75 319.66 314.25 338.99C322.44 338.99 330.64 338.99 338.83 338.99C339.26 334.29 334.9 327.03 333.17 322.61C328.47 310.61 323.86 298.59 319.17 286.61C312.13 268.62 305.21 250.59 298.17 232.61C297.51 230.92 297.49 229.08 296.83 227.39C292.78 217.06 288.22 206.94 284.17 196.61C283.51 194.92 283.49 193.08 282.83 191.39C279.44 182.74 275.56 174.27 272.17 165.61C271.51 163.92 271.49 162.08 270.83 160.39C269.61 157.27 267.57 154.35 266.75 151.01C259.58 151.01 252.42 151.01 245.25 151.01ZM255.25 179.17C257.54 181.14 260.61 195.63 262.17 199.61C267.19 212.44 271.79 225.53 276.83 238.39C277.49 240.08 277.51 241.92 278.17 243.61C279.68 247.47 284.18 256.15 283.83 259.99C264.97 259.99 246.11 259.99 227.25 259.99C227.84 256.19 230.42 252.21 231.83 248.61C233.91 243.3 235.75 237.91 237.83 232.61C239.52 228.3 240.48 223.7 242.17 219.39C247.38 206.1 252.15 193.18 255.25 179.17Z"
          fill-rule="evenodd"
          stroke-linejoin="round"
        />
      </g>
    </>,
  ],
  iconBuffer: [
    50,
    50,
    <>
      <path
        d="M23.054,0C10.342,0,0,10.342,0,23.055C0,35.768,10.342,46.11,23.055,46.11S46.11,35.768,46.11,23.055
    C46.11,10.342,35.768,0,23.054,0z M23.054,39.11C14.201,39.11,7,31.908,7,23.055C7,14.202,14.201,7,23.054,7
    c8.853,0,16.056,7.202,16.056,16.055C39.11,31.908,31.907,39.11,23.054,39.11z"
      />
      <circle cx="23.054" cy="23.055" r="7.555" />
    </>,
  ],
  seat: [
    512,
    512,
    <>
      <path d="M502,492c-5.51,0-10,4.49-10,10c0,5.51,4.49,10,10,10c5.51,0,10-4.49,10-10C512,496.49,507.51,492,502,492z" />
      <path d="M423.036,0c-28.102,0-50.964,22.862-50.964,50.964v45.744l-61.547,84.956H168c-16.542,0-30,13.458-30,30s13.458,30,30,30   h99.058L245.081,272H108c-38.598,0-70,31.402-70,70s31.402,70,70,70h128.176l14.559,40H128c-16.542,0-30,13.458-30,30   c0,3.506,0.61,6.87,1.72,10H10c-5.51,0-10,4.49-10,10c0,5.51,4.49,10,10,10h452c5.51,0,10-4.49,10-10c0-5.51-4.49-10-10-10H316.28   c1.11-3.13,1.72-6.494,1.72-10v-20c0-1.18-0.209-2.35-0.617-3.458L300.234,412H308l0,0l0.001,0c3.71,0,7.135-2.06,8.865-5.376   l156.012-301.022c0.737-1.422,1.122-3,1.122-4.602c0-0.202-0.003-0.4-0.008-0.598c0.005-0.134,0.008-0.268,0.008-0.402V50.964   C474,22.862,451.138,0,423.036,0z M168,221.663c-5.514,0-10-4.486-10-10s4.486-10,10-10h180.464l-13.722,20H168z M129.72,392H108   c-27.57,0-50-22.43-50-50s22.43-50,50-50h142.185c3.206,0,6.217-1.537,8.098-4.133l33.472-46.203h29.264L272.76,312H178   c-27.57,0-50,22.43-50,50v20C128,385.506,128.61,388.87,129.72,392z M158,392c-5.514,0-10-4.486-10-10v-20   c0-16.542,13.458-30,30-30h92.27l7.718,20H218c-5.51,0-10,4.49-10,10c0,5.51,4.49,10,10,10h67.705l7.718,20H158z M128,492   c-5.514,0-10-4.486-10-10s4.486-10,10-10h137.017c3.263,0,6.32-1.592,8.191-4.264c1.872-2.673,2.321-6.09,1.206-9.156L257.46,412   h21.46L298,463.784V482c0,5.514-4.486,10-10,10H128z M309.364,377.758l-20.687-53.607l81.509-118.797l21.739,14.09L309.364,377.758   z M454,98.563l-52.895,102.997l-28.214-18.287c-1.485-0.963-3.133-1.474-4.785-1.58c-0.034-0.017-0.069-0.029-0.106-0.029h-32.778   l54.904-75.787c0.154-0.212,0.299-0.431,0.436-0.655c0.054-0.086,0.115-0.188,0.16-0.267c0.884-1.524,1.35-3.255,1.35-5.017V50.964   c0-17.074,13.89-30.964,30.964-30.964S454,33.89,454,50.964V98.563z" />
      <path d="M178,352c-5.51,0-10,4.49-10,10c0,5.51,4.49,10,10,10c5.51,0,10-4.49,10-10C188,356.49,183.51,352,178,352z" />
    </>,
  ],
  aircraft_ship: [
    512.00013,
    512,
    <>
      <path d="m7.257812 377.296875c4.550782 3.191406 10.367188 3.96875 15.59375 2.082031l190.480469-68.566406.011719 103.324219-45.085938 37.566406c-3.882812 3.242187-6.128906 8.042969-6.125 13.101563v27.199218c0 5.394532 2.550782 10.472656 6.875 13.691406 4.328126 3.222657 9.925782 4.207032 15.09375 2.660157l71.898438-21.578125 71.898438 21.578125c1.605468.484375 3.273437.730469 4.949218.730469 9.40625-.042969 17.011719-7.675782 17.019532-17.082032v-27.199218c0-5.066407-2.25-9.875-6.144532-13.117188l-45.054687-37.546875v-103.328125l190.472656 68.566406c5.230469 1.890625 11.050781 1.109375 15.601563-2.082031 4.550781-3.195313 7.257812-8.410156 7.257812-13.96875v-42.921875c.015625-5.820312-2.953125-11.246094-7.867188-14.367188l-205.464843-131.5v-131.867187c.003906-12.039063-5.078125-23.523437-13.996094-31.609375-8.917969-8.089844-20.839844-12.035156-32.820313-10.859375-22.160156 2.679687-38.753906 21.605469-38.519531 43.925781v130.410156l-205.464843 131.488282c-4.914063 3.128906-7.882813 8.554687-7.867188 14.378906v42.921875c.00390625 5.558594 2.710938 10.769531 7.257812 13.96875zm9.808594-56.890625 209.402344-134.019531c2.449219-1.566407 3.929688-4.273438 3.929688-7.183594v-135.074219c-.289063-13.542968 9.640624-25.140625 23.066406-26.941406 7.199218-.71875 14.363281 1.644531 19.722656 6.5s8.417969 11.75 8.414062 18.984375v136.53125c0 2.910156 1.480469 5.617187 3.929688 7.183594l209.402344 134.019531v42.921875l-201.910156-72.679687c-2.613282-.945313-5.523438-.554688-7.796876 1.039062-2.273437 1.597656-3.628906 4.203125-3.625 6.984375v115.464844c-.003906 5.066406 2.25 9.875 6.140626 13.117187l45.058593 37.546875v27.199219l-71.925781-21.578125c-3.191406-.949219-6.585938-.945313-9.773438.007813l-71.902343 21.574218-.007813-27.199218 45.082032-37.566407c3.886718-3.242187 6.128906-8.042969 6.125-13.101562v-115.464844c.003906-2.78125-1.351563-5.386719-3.625-6.984375-2.273438-1.59375-5.183594-1.984375-7.796876-1.039062l-201.910156 72.679687zm0 0" />
    </>,
  ],
  bulb: [
    700,
    700,
    <>
      <defs>
        <path
          d="M271.68 503.96C260.66 503.96 251.73 495.02 251.73 484C251.73 441.36 235.41 400.49 205.78 368.92C169.75 330.53 149.48 280.36 148.7 227.66C147.86 171.15 169.49 117.56 209.61 76.76C249.51 36.18 302.33 13.77 358.35 13.67C358.39 13.67 358.72 13.67 358.76 13.67C414.67 13.67 467.27 35.44 506.91 75.01C546.84 114.87 568.84 167.94 568.84 224.45C568.84 278.64 548.38 330.13 511.24 369.44C481.92 400.46 465.79 441.15 465.79 484C465.79 495.02 456.85 503.96 445.83 503.96C411 503.96 289.09 503.96 271.68 503.96Z"
          id="b2GqAsFBIg"
        ></path>
        <linearGradient
          id="gradientd8v0Oqouu"
          gradientUnits="userSpaceOnUse"
          x1="358.75"
          y1="13.67"
          x2="358.75"
          y2="600.96"
        >
          <stop
            style={{ stopColor: "#000000", stopOpacity: 0.9 }}
            offset="65%"
          ></stop>
          <stop
            style={{ stopColor: "#FFFFFF", stopOpacity: 0.7 }}
            offset="100%"
          ></stop>
        </linearGradient>
        <mask
          id="maskaiChqewY5"
          x="134.67"
          y="-0.33"
          width="448.16"
          height="518.29"
          maskUnits="userSpaceOnUse"
        >
          <rect
            x="134.67"
            y="-0.33"
            width="448.16"
            height="518.29"
            fill="white"
          ></rect>
          <use href="#b2GqAsFBIg" opacity="1" fill="black"></use>
        </mask>
        <mask
          id="maskaiChqewY52"
          x="134.67"
          y="-0.33"
          width="448.16"
          height="518.29"
          maskUnits="userSpaceOnUse"
        >
          <rect
            x="134.67"
            y="-0.33"
            width="448.16"
            height="518.29"
            fill="black"
          ></rect>
          <use
            href="#b2GqAsFBIg"
            opacity="1"
            fill="url(#gradientd8v0Oqouu)"
          ></use>
        </mask>
        <path
          d="M274.28 566.53C263.26 566.53 254.33 557.6 254.33 546.58C254.33 535.56 263.26 526.63 274.28 526.63C291.18 526.63 426.33 526.63 443.23 526.63C454.25 526.63 463.18 535.56 463.18 546.58C463.18 557.6 454.25 566.53 443.23 566.53C409.44 566.53 291.18 566.53 274.28 566.53Z"
          id="c2WqCeX1vU"
        ></path>
        <path
          d="M274.28 630.1C263.26 630.1 254.33 621.17 254.33 610.15C254.33 599.13 263.26 590.2 274.28 590.2C291.18 590.2 426.33 590.2 443.23 590.2C454.25 590.2 463.18 599.13 463.18 610.15C463.18 621.17 454.25 630.1 443.23 630.1C409.44 630.1 291.18 630.1 274.28 630.1Z"
          id="g2HRb6FBDG"
        ></path>
        <path
          d="M305.37 693.67C294.35 693.67 285.42 684.73 285.42 673.72C285.42 662.7 294.35 653.77 305.37 653.77C316.04 653.77 401.46 653.77 412.14 653.77C423.16 653.77 432.09 662.7 432.09 673.72C432.09 684.73 423.16 693.67 412.14 693.67C390.79 693.67 316.04 693.67 305.37 693.67Z"
          id="blz317UXN"
        ></path>
        <path
          d="M241.48 215.3C241.48 266.35 278.65 356.8 270.65 356.8C262.65 356.8 198.15 262.35 198.15 211.3C198.15 160.25 269.65 71.8 277.65 71.8C285.65 71.8 241.48 164.25 241.48 215.3Z"
          id="fEWkmfNQb"
        ></path>
        <linearGradient
          id="gradientaeXFe3Odr"
          gradientUnits="userSpaceOnUse"
          x1="238.39"
          y1="71.8"
          x2="238.39"
          y2="356.8"
        >
          <stop
            style={{ stopColor: "#ffffff", stopOpacity: 0.7 }}
            offset="0%"
          ></stop>
          <stop
            style={{ stopColor: "#464646", stopOpacity: 0.2 }}
            offset="100%"
          ></stop>
        </linearGradient>
      </defs>
      <g>
        <g>
          <use href="#b2GqAsFBIg" opacity="1"></use>
          <g mask="url(#maskaiChqewY5)">
            <use
              href="#b2GqAsFBIg"
              opacity="1"
              fillOpacity="0"
              stroke="#000000"
              strokeWidth="14"
              strokeOpacity="1"
            ></use>
          </g>
          <g mask="url(#maskaiChqewY52)">
            <use
              href="#b2GqAsFBIg"
              fillOpacity="1"
              opacity="1"
              fill="black"
            ></use>
          </g>
        </g>
        <g>
          <use
            href="#c2WqCeX1vU"
            opacity="1"
            fill="#000000"
            fillOpacity="1"
          ></use>
          <g>
            <use
              href="#c2WqCeX1vU"
              opacity="1"
              fillOpacity="0"
              stroke="#000000"
              strokeWidth="1"
              strokeOpacity="0"
            ></use>
          </g>
        </g>
        <g>
          <use
            href="#g2HRb6FBDG"
            opacity="1"
            fill="#000000"
            fillOpacity="1"
          ></use>
          <g>
            <use
              href="#g2HRb6FBDG"
              opacity="1"
              fillOpacity="0"
              stroke="#000000"
              strokeWidth="1"
              strokeOpacity="0"
            ></use>
          </g>
        </g>
        <g>
          <use
            href="#blz317UXN"
            opacity="1"
            fill="#000000"
            fillOpacity="1"
          ></use>
          <g>
            <use
              href="#blz317UXN"
              opacity="1"
              fillOpacity="0"
              stroke="#000000"
              strokeWidth="1"
              strokeOpacity="0"
            ></use>
          </g>
        </g>
        <g>
          <use
            href="#fEWkmfNQb"
            opacity="1"
            fill="url(#gradientaeXFe3Odr)"
          ></use>
        </g>
      </g>
    </>,
  ],
  pin: [
    512,
    512,
    <>
      <path d="m505.41 144.476-137.886-137.886c-4.25-4.25-9.9-6.59-15.91-6.59s-11.66 2.341-15.909 6.59c-4.25 4.25-6.591 9.9-6.591 15.91s2.341 11.66 6.59 15.91l15.58 15.58-119.957 106.281c-24.641-5.338-50.396-4.701-74.742 1.879-26.421 7.14-50.674 21.201-70.135 40.663-1.407 1.406-2.197 3.314-2.197 5.303s.79 3.897 2.197 5.303l90.156 90.156-159.409 159.408c-11.09 11.09-17.197 25.834-17.197 41.517 0 4.142 3.358 7.5 7.5 7.5 15.683 0 30.427-6.107 41.517-17.197l159.409-159.409 90.156 90.156c1.465 1.464 3.385 2.197 5.304 2.197s3.839-.732 5.304-2.197c19.461-19.461 33.521-43.713 40.662-70.135 6.58-24.348 7.217-50.102 1.879-74.742l106.281-119.958 15.579 15.579c4.25 4.25 9.9 6.59 15.91 6.59s11.661-2.341 15.909-6.59c4.25-4.25 6.591-9.9 6.591-15.91-.001-6.008-2.342-11.658-6.591-15.908zm-467 339.721c-6.27 6.27-14.109 10.4-22.632 12.025 1.625-8.523 5.756-16.362 12.025-22.632l159.409-159.409 10.607 10.607zm265.339-74.692-201.254-201.254c34.561-31.19 81.416-43.425 127.142-32.974l107.087 107.088c10.448 45.726-1.786 92.58-32.975 127.14zm191.054-243.816c-1.416 1.417-3.3 2.196-5.303 2.196s-3.887-.78-5.303-2.197l-95.459-95.458c-2.93-2.928-7.678-2.93-10.607 0-2.929 2.929-2.929 7.678 0 10.606l69.254 69.254-104.159 117.563-98.878-98.878 122.846-108.841c1.548-1.372 2.461-3.321 2.522-5.387.063-2.067-.73-4.068-2.192-5.53l-21.214-21.214c-1.416-1.417-2.196-3.3-2.196-5.303s.78-3.886 2.197-5.303c1.416-1.417 3.3-2.197 5.303-2.197s3.887.78 5.303 2.197l137.887 137.886c1.416 1.417 2.196 3.3 2.196 5.303s-.78 3.886-2.197 5.303z" />
    </>,
  ],
  invoice: [
    512,
    512,
    <>
      <g>
        <g>
          <path
            d="M413.539,0H98.462c-8.157,0-14.769,6.613-14.769,14.769v482.462c0,5.595,3.161,10.708,8.164,13.211
			c5.003,2.502,10.99,1.962,15.466-1.395l49.362-37.022l40.205,36.184c5.615,5.055,14.144,5.055,19.759,0L256,472.794l39.351,35.416
			c5.615,5.055,14.144,5.055,19.759,0l40.205-36.184l49.362,37.021c2.605,1.954,5.724,2.954,8.864,2.954
			c2.251,0,4.513-0.514,6.603-1.559c5.004-2.503,8.164-7.616,8.164-13.211V14.769C428.308,6.613,421.695,0,413.539,0z
			 M398.77,467.692l-35.446-26.585c-5.645-4.233-13.496-3.883-18.741,0.838l-39.351,35.415l-39.351-35.416
			c-2.807-2.527-6.344-3.791-9.88-3.791s-7.073,1.264-9.88,3.792L206.77,477.36l-39.351-35.416
			c-5.244-4.72-13.095-5.071-18.741-0.838l-35.446,26.585V29.538H398.77V467.692z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M275.693,211.692h-39.385c-13.573,0-24.615-11.042-24.615-24.615v-19.692c0-13.573,11.042-24.615,24.615-24.615h39.385
			c13.573,0,24.615,11.042,24.615,24.615c0,8.156,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			c0-29.86-24.293-54.154-54.154-54.154h-4.923V88.615c0-8.156-6.613-14.769-14.769-14.769s-14.769,6.613-14.769,14.769v24.615
			h-4.923c-29.86,0-54.154,24.293-54.154,54.154v19.692c0,29.86,24.293,54.154,54.154,54.154h39.385
			c13.573,0,24.615,11.042,24.615,24.615v19.692c0,13.573-11.042,24.615-24.615,24.615h-39.385
			c-13.573,0-24.615-11.042-24.615-24.615c0-8.157-6.613-14.769-14.769-14.769s-14.769,6.613-14.769,14.769
			c0,29.86,24.293,54.154,54.154,54.154h4.923v24.615c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769v-24.615h4.923
			c29.86,0,54.154-24.293,54.154-54.154v-19.692C329.847,235.986,305.553,211.692,275.693,211.692z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </>,
  ],
  bom: [
    64,
    64,
    <>
      <path d="m11.102 29.922 1.99.197c.063-.637.159-1.276.285-1.903l-1.961-.395c-.139.692-.245 1.399-.314 2.101z" />
      <path d="m51.305 40.278-1.838-.789c-.251.584-.536 1.166-.848 1.728l1.749.971c.345-.622.66-1.264.937-1.91z" />
      <path d="m15.399 41.249c-.312-.56-.599-1.14-.851-1.725l-1.836.793c.279.646.596 1.288.941 1.906z" />
      <path d="m11.943 25.758 1.91.594c.188-.604.412-1.213.664-1.807l-1.841-.783c-.278.656-.525 1.327-.733 1.996z" />
      <path d="m11.11 34.166 1.989-.205c-.065-.634-.099-1.279-.1-1.921l-2 .004c.002.708.039 1.422.111 2.122z" />
      <path d="m13.877 37.724c-.192-.608-.354-1.235-.484-1.861l-1.959.404c.143.692.323 1.385.536 2.059z" />
      <path d="m32.904 13.021.093-1.998c-.33-.015-.662-.023-.994-.023-.391.002-.756.009-1.13.028l.104 1.998c.323-.017.647-.026.976-.026.322.007.636.008.951.021z" />
      <path d="m46.422 44.371 1.52 1.301c.461-.539.899-1.104 1.3-1.68l-1.641-1.145c-.364.523-.76 1.035-1.179 1.524z" />
      <path d="m28.759 11.249c-.699.107-1.4.253-2.083.432l.507 1.936c.617-.162 1.25-.293 1.881-.391z" />
      <path d="m38.541 14.155c.601.221 1.196.475 1.77.753l.876-1.797c-.634-.31-1.292-.59-1.957-.833z" />
      <path d="m40.381 49.057.882 1.795c.634-.312 1.259-.66 1.859-1.035l-1.062-1.695c-.541.338-1.106.653-1.679.935z" />
      <path d="m44.796 15.348c-.561-.431-1.149-.838-1.748-1.209l-1.054 1.699c.542.337 1.075.705 1.583 1.096z" />
      <path d="m18.874 18.263-1.382-1.445c-.51.487-1.001 1.007-1.461 1.545l1.521 1.299c.416-.487.861-.958 1.322-1.399z" />
      <path d="m22.775 50.87.88-1.797c-.571-.279-1.137-.593-1.683-.933l-1.056 1.699c.603.376 1.229.723 1.859 1.031z" />
      <path d="m44.864 48.6c.558-.434 1.101-.899 1.611-1.386l-1.378-1.449c-.463.44-.954.862-1.46 1.255z" />
      <path d="m35.112 11.229-.293 1.979c.629.093 1.263.221 1.885.378l.492-1.938c-.687-.174-1.388-.316-2.084-.419z" />
      <path d="m24.649 12.323c-.664.248-1.321.532-1.952.845l.888 1.793c.57-.283 1.164-.54 1.765-.765z" />
      <path d="m45.041 18.183c.466.439.914.907 1.331 1.39l1.513-1.309c-.461-.533-.956-1.05-1.471-1.536z" />
      <path d="m21.906 15.899-1.065-1.693c-.599.377-1.185.788-1.739 1.22l1.229 1.578c.502-.392 1.032-.763 1.575-1.105z" />
      <path d="m47.557 21.087c.37.527.715 1.075 1.024 1.629l1.745-.979c-.343-.611-.724-1.217-1.133-1.799z" />
      <path d="m13.611 21.852 1.75.967c.31-.559.651-1.108 1.015-1.633l-1.643-1.141c-.402.58-.78 1.187-1.122 1.807z" />
      <path d="m28.844 52.765c.698.104 1.409.176 2.115.21l.098-1.998c-.639-.031-1.284-.095-1.915-.19z" />
      <path d="m17.602 44.397c-.418-.485-.816-.996-1.181-1.519l-1.64 1.146c.404.577.843 1.142 1.306 1.679z" />
      <path d="m32.983 50.975.101 1.998c.709-.036 1.421-.108 2.116-.215l-.304-1.977c-.628.097-1.271.161-1.913.194z" />
      <path d="m24.732 51.709c.668.246 1.351.459 2.029.633l.497-1.938c-.613-.157-1.231-.35-1.837-.572z" />
      <path d="m20.392 47.043c-.506-.392-.998-.812-1.461-1.252l-1.376 1.451c.512.485 1.055.951 1.615 1.383z" />
      <path d="m36.781 50.394.5 1.936c.681-.176 1.364-.39 2.029-.637l-.695-1.875c-.602.222-1.219.416-1.834.576z" />
      <path d="m52.574 36.224-1.959-.4c-.128.624-.29 1.251-.481 1.863l1.909.596c.211-.677.39-1.369.531-2.059z" />
      <path d="m53 31.982-.61-.039-1.39.057c0 .643-.032 1.289-.096 1.921l1.99.201c.07-.699.106-1.413.106-2.14z" />
      <path d="m49.436 24.438c.255.587.482 1.193.675 1.801l1.906-.605c-.213-.672-.465-1.343-.747-1.992z" />
      <path d="m50.599 28.1c.13.624.23 1.263.296 1.899l1.989-.207c-.074-.704-.184-1.411-.328-2.101z" />
      <path d="m3.983 25.185c1.415-7.548 6.215-14.155 12.929-17.9l.677 2.032c.11.329.382.577.719.657.076.017.153.026.23.026.262 0 .518-.104.707-.293l5-5c.268-.268.361-.664.242-1.023s-.432-.62-.807-.674l-7-1c-.345-.053-.687.083-.909.35-.222.266-.291.628-.181.957l.681 2.043c-7.402 3.997-12.707 11.203-14.254 19.455zm17.434-20.478-2.442 2.441-.977-2.93z" />
      <path d="m7.282 47.086 2.034-.678c.329-.109.577-.381.657-.719.08-.337-.021-.691-.266-.937l-5-5c-.269-.268-.665-.364-1.023-.241-.359.119-.62.432-.673.807l-1 7c-.049.344.083.688.349.909.182.153.409.233.64.233.106 0 .213-.017.316-.052l2.042-.681c3.986 7.407 11.192 12.712 19.458 14.256l.367-1.967c-7.559-1.411-14.167-6.212-17.901-12.93zm-2.575-4.505 2.442 2.441-2.93.978z" />
      <path d="m47.086 56.716-.678-2.033c-.11-.329-.382-.577-.719-.657-.339-.077-.692.021-.937.267l-5 5c-.268.268-.361.664-.242 1.023s.432.62.807.674l7 1c.049.007.096.01.143.01.294 0 .576-.13.768-.359.222-.266.291-.628.181-.957l-.681-2.043c7.4-3.993 12.705-11.198 14.255-19.456l-1.966-.369c-1.417 7.553-6.218 14.161-12.931 17.9zm-4.505 2.577 2.442-2.441.977 2.929z" />
      <path d="m60.684 15.592-2.042.681c-3.982-7.397-11.187-12.702-19.457-14.255l-.369 1.965c7.565 1.422 14.173 6.223 17.903 12.931l-2.034.678c-.329.109-.577.381-.657.719-.08.337.021.691.266.937l5 5c.19.19.446.293.707.293.106 0 .212-.017.316-.052.359-.119.62-.432.673-.807l1-7c.049-.344-.083-.688-.349-.909-.266-.222-.628-.294-.957-.181zm-1.391 5.827-2.442-2.441 2.93-.978z" />
      <path d="m26 40v-15c0-.553-.448-1-1-1h-4c-.552 0-1 .447-1 1v15c0 .553.448 1 1 1h4c.552 0 1-.447 1-1zm-2-1h-2v-13h2z" />
      <path d="m30 41h4c.552 0 1-.447 1-1v-8c0-.553-.448-1-1-1h-4c-.552 0-1 .447-1 1v8c0 .553.448 1 1 1zm1-8h2v6h-2z" />
      <path d="m38 26v14c0 .553.448 1 1 1h4c.552 0 1-.447 1-1v-14c0-.553-.448-1-1-1h-4c-.552 0-1 .447-1 1zm2 1h2v12h-2z" />
    </>,
  ],
  auditTrail: [
    512,
    512,
    <>
      <g>
        <path d="m32 456c.025 22.081 17.919 39.975 40 40h296c61.851.006 111.996-50.129 112.002-111.98.004-43.264-24.912-82.66-64.002-101.199v-162.821c0-2.122-.843-4.157-2.343-5.657l-96-96c-1.5-1.5-3.535-2.343-5.657-2.343h-240c-22.081.025-39.975 17.919-40 40zm432-72c0 53.019-42.981 96-96 96s-96-42.981-96-96 42.981-96 96-96c52.995.06 95.94 43.005 96 96zm-144-340.687 68.687 68.687h-44.687c-13.249-.015-23.985-10.751-24-24zm-272 12.687c.015-13.248 10.752-23.985 24-24h232v56c.025 22.081 17.919 39.975 40 40h56v148.666c-59.265-17.683-121.643 16.025-139.327 75.289-14.627 49.023 5.828 101.725 49.696 128.045h-238.369c-13.248-.015-23.985-10.752-24-24z" />
        <path d="m160 168c0 4.418 3.582 8 8 8h192c4.418 0 8-3.582 8-8s-3.582-8-8-8h-192c-4.418 0-8 3.582-8 8z" />
        <path d="m88 224h160c4.418 0 8-3.582 8-8s-3.582-8-8-8h-160c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
        <path d="m280 256h-64c-4.418 0-8 3.582-8 8s3.582 8 8 8h64c4.418 0 8-3.582 8-8s-3.582-8-8-8z" />
        <path d="m88 320h144c4.418 0 8-3.582 8-8s-3.582-8-8-8h-144c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
        <path d="m88 176h48c4.418 0 8-3.582 8-8s-3.582-8-8-8h-48c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
        <path d="m360 208h-80c-4.418 0-8 3.582-8 8s3.582 8 8 8h80c4.418 0 8-3.582 8-8s-3.582-8-8-8z" />
        <path d="m88 272h96c4.418 0 8-3.582 8-8s-3.582-8-8-8h-96c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
        <path d="m216 400h-32c-4.418 0-8 3.582-8 8s3.582 8 8 8h32c4.418 0 8-3.582 8-8s-3.582-8-8-8z" />
        <path d="m88 416h64c4.418 0 8-3.582 8-8s-3.582-8-8-8h-64c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
        <path d="m88 368h48c4.418 0 8-3.582 8-8s-3.582-8-8-8h-48c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
        <path d="m88 128h96c4.418 0 8-3.582 8-8s-3.582-8-8-8h-96c-4.418 0-8 3.582-8 8s3.582 8 8 8z" />
        <path d="m216 352h-48c-4.418 0-8 3.582-8 8s3.582 8 8 8h48c4.418 0 8-3.582 8-8s-3.582-8-8-8z" />
        <path d="m322.879 329.854c-3.395 2.828-3.854 7.873-1.026 11.267 0 0 0 .001.001.001 0 0 30.333 36.449 39.97 47.964.971 1.161 2.556 2.512 5.331 2.87.28.036.563.044.845.044h56c4.418 0 8-3.582 8-8s-3.582-8-8-8h-52.253l-37.6-45.122c-2.828-3.394-7.873-3.853-11.268-1.024z" />
      </g>
    </>,
  ],
  unfilter: [
    512,
    512,
    <>
      <path d="M478.72,37.55A10.59,10.59,0,0,0,469.33,32H42.67a10.49,10.49,0,0,0-9.39,5.65,10.28,10.28,0,0,0,.53,10.88L195.42,291H221L62.61,53.33H449.39L291,291h25.57L478.19,48.53A11,11,0,0,0,478.72,37.55ZM288,420.05l-64,32V321H202.67V469.33a10.66,10.66,0,0,0,5,9.07,10.78,10.78,0,0,0,5.65,1.6,11.06,11.06,0,0,0,4.8-1.17l85.34-42.67a10.43,10.43,0,0,0,5.86-9.49V321H288Z"></path>
      <path d="M416,306a15,15,0,0,1-15,15H110a15,15,0,1,1,0-30H401A15,15,0,0,1,416,306Z"></path>
    </>,
  ],
  reset: [
    448,
    448,
    <>
      <path d="m106.667969 149.332031h-106.667969v-106.664062h21.332031v85.332031h85.335938zm0 0" />
      <path d="m224 448c-123.464844 0-224-100.535156-224-224h21.332031c0 111.734375 90.933594 202.667969 202.667969 202.667969s202.667969-90.933594 202.667969-202.667969-90.933594-202.667969-202.667969-202.667969c-55.199219 0-106.933594 21.867188-145.332031 61.46875l-60.269531 63.199219-15.464844-14.667969 60.265625-63.332031c42.667969-43.867188 99.734375-68 160.800781-68 123.464844 0 224 100.535156 224 224s-100.535156 224-224 224zm0 0" />
      <path d="m224 298.667969c-41.199219 0-74.667969-33.46875-74.667969-74.667969s33.46875-74.667969 74.667969-74.667969 74.667969 33.46875 74.667969 74.667969-33.46875 74.667969-74.667969 74.667969zm0-128c-29.464844 0-53.332031 23.867187-53.332031 53.332031s23.867187 53.332031 53.332031 53.332031 53.332031-23.867187 53.332031-53.332031-23.867187-53.332031-53.332031-53.332031zm0 0" />
    </>,
  ],
  pricerollup: [
    16.933333,
    16.933333,
    <>
      <g transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 16.9333 16.9333)">
        <g id="layer1" transform="translate(0 -280.067)">
          <path
            id="path13331"
            d="m4.2333028 281.12491a.26460979.26460979 0 0 0 -.2645834.26458v6.87917h-2.6458333a.26460979.26460979 0 0 0 -.1870683.45165l7.14375 7.14375a.26460979.26460979 0 0 0 .3741367 0l7.1437495-7.14375a.26460979.26460979 0 0 0 -.187068-.45165h-2.645834v-6.87917a.26460979.26460979 0 0 0 -.264583-.26458zm.2645833.52916h7.9374999v6.87917a.26460979.26460979 0 0 0 .264583.26458h2.271697l-6.5050299 6.50503-6.5050299-6.50503h2.2716966a.26460979.26460979 0 0 0 .2645833-.26458zm3.9656491 1.05524a.26460982.26460982 0 0 0 -.2614824.26768v.817c-.7481464.12736-1.3224007.78064-1.3224007 1.56373 0 .87362.7144067 1.58801 1.5880186 1.58802.5876395 0 1.0562647.4707 1.0562647 1.05833 0 .57912-.4558035 1.04289-1.0314601 1.05627a.26460982.26460982 0 0 0 -.02894-.002.26460982.26460982 0 0 0 -.023257.002c-.574503-.0147-1.0314622-.47801-1.0314622-1.05627a.26465001.26465001 0 1 0 -.5291667 0c0 .78309.5742543 1.43638 1.3224007 1.56373v.81701a.26464501.26464501 0 1 0 .5291667 0v-.81649c.7486042-.12669 1.3218812-.7806 1.3218812-1.56425 0-.86995-.7059788-1.58154-1.5745794-1.5875a.2646485.2646485 0 0 0 -.010848-.00053c-.5876317 0-1.058852-.47069-1.058852-1.05833 0-.58498.4671695-1.05411 1.0510997-1.05833a.26464501.26464501 0 0 0 .016536.00053c.5833957.005 1.0474801.4732 1.0474801 1.05781a.26465001.26465001 0 1 0 .5291656 0c0-.78364-.5732769-1.43755-1.321881-1.56424v-.81649a.26460982.26460982 0 0 0 -.2676838-.26768z"
          />
        </g>
      </g>
    </>,
  ],
  error: [
    32,
    32,
    <>
      <defs>
        <path
          d="M27.88 16C27.88 22.42 22.55 27.63 16 27.63C9.45 27.63 4.12 22.42 4.12 16C4.12 9.58 9.45 4.37 16 4.37C22.55 4.37 27.88 9.58 27.88 16Z"
          id="bc4Pw5nal"
        />
        <path
          d="M0 16C0 24.84 7.16 32 16 32C24.84 32 32 24.84 32 16C32 7.16 24.84 0 16 0C7.16 0 0 7.16 0 16ZM13.89 24C13.89 22.71 14.79 21.79 16 21.79C17.28 21.79 18.11 22.71 18.11 24C18.11 25.25 17.28 26.21 16 26.21C14.75 26.21 13.89 25.25 13.89 24ZM15.17 17.76C14.79 16.49 13.42 11.65 13.42 8.51C13.42 4.36 18.61 4.34 18.61 8.51C18.6 11.67 17.16 16.63 16.83 17.76C16.51 18.85 15.51 18.87 15.17 17.76Z"
          id="at1PIPubg"
        />
      </defs>
      <g>
        <g>
          <use href="#bc4Pw5nal" opacity="1" fill="#ffffff" fillOpacity="1" />
        </g>
        <g>
          <use href="#at1PIPubg" opacity="1" fillOpacity="1" />
          <g>
            <use
              href="#at1PIPubg"
              opacity="1"
              fillOpacity="0"
              stroke="#000000"
              strokeWidth="1"
              strokeOpacity="0"
            />
          </g>
        </g>
      </g>
    </>,
  ],
  replace_old: [
    409.6,
    409.6,
    <>
      <g>
        <g>
          <path
            d="M392.535,0h-170.67c-9.38,0-17.065,7.68-17.065,17.065v102.4c0,9.385,7.685,17.065,17.065,17.065h170.67
			c9.38,0,17.065-7.68,17.065-17.065v-102.4C409.6,7.68,401.915,0,392.535,0z M375.465,102.4h-136.53V34.135h136.53V102.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M187.735,273.07H17.065C7.685,273.07,0,280.75,0,290.13v102.4c0,9.39,7.685,17.07,17.065,17.07h170.67
			c9.38,0,17.065-7.68,17.065-17.07v-102.4C204.8,280.75,197.115,273.07,187.735,273.07z M170.665,375.47H34.135V307.2h136.53
			V375.47z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M119.485,85.33h51.18V51.2h-51.18C81.787,51.2,51.2,81.751,51.2,119.45v61.22L24.136,153.62L0,177.751l56.202,56.182
			c6.651,6.671,17.464,6.671,24.136,0l56.202-56.197L112.399,153.6l-27.064,27.069l0.015-61.22
			C85.35,100.598,100.634,85.33,119.485,85.33z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M353.398,175.667c-6.651-6.666-17.464-6.666-24.136,0l-56.197,56.202L297.201,256l27.064-27.069l-0.015,61.22
			c0,18.852-15.283,34.12-34.135,34.12h-51.18v34.13h51.18c37.699,0,68.285-30.551,68.285-68.25v-61.22l27.064,27.049l24.136-24.131
			L353.398,175.667z"
          />
        </g>
      </g>
    </>,
  ],
  check: [
    350,
    350,
    <>
      <g>
        <g stroke="null">
          <path
            stroke="null"
            d="m127.54446,349.506c-10.80811,0 -21.11145,-4.781 -28.18507,-13.146l-89.07643,-105.412c-13.33884,-15.789 -11.53568,-39.552 4.03024,-53.082c15.55902,-13.545 38.98529,-11.716 52.33991,4.081l58.23344,68.909l184.04738,-225.115c28.48971,-40.478 58.30837,-18.063 29.69247,22.588l-180.8847,285.41c-6.6359,9.419 -17.16993,15.217 -28.56365,15.729c-0.55012,0.023 -1.09136,0.038 -1.63359,0.038z"
          />
        </g>
      </g>
    </>,
  ],
  add_folder: [
    512,
    512,
    <>
      <g>
        <path d="M416,260.666V119.5a40.045,40.045,0,0,0-40-40H208V72a40.045,40.045,0,0,0-40-40H56A40.045,40.045,0,0,0,16,72V392a40.045,40.045,0,0,0,40,40H292.141A111.981,111.981,0,1,0,416,260.666ZM376,95.5a24.028,24.028,0,0,1,24,24v16.522A39.788,39.788,0,0,0,376,128H208V95.5ZM56,416a24.027,24.027,0,0,1-24-24V72A24.027,24.027,0,0,1,56,48H168a24.027,24.027,0,0,1,24,24v64a8,8,0,0,0,8,8H376a24.028,24.028,0,0,1,24,24v89.148A112,112,0,0,0,272,368a111.334,111.334,0,0,0,10.821,48Zm328,48a96,96,0,1,1,96-96A96.108,96.108,0,0,1,384,464Z" />
        <path d="M440,360H392V312a8,8,0,0,0-16,0v48H328a8,8,0,0,0,0,16h48v48a8,8,0,0,0,16,0V376h48a8,8,0,0,0,0-16Z" />
      </g>
    </>,
  ],
  up_folder: [
    512,
    512,
    <>
      <g>
        <path d="M288,416H416a40.045,40.045,0,0,0,40-40V104a40.045,40.045,0,0,0-40-40H248V56a40.045,40.045,0,0,0-40-40H96A40.045,40.045,0,0,0,56,56V376a40.045,40.045,0,0,0,40,40H208v40a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8ZM416,80a24.028,24.028,0,0,1,24,24v16.022A39.788,39.788,0,0,0,416,112H248V80ZM96,400a24.027,24.027,0,0,1-24-24V56A24.027,24.027,0,0,1,96,32H208a24.027,24.027,0,0,1,24,24v64a8,8,0,0,0,8,8H416a24.027,24.027,0,0,1,24,24V376a24.027,24.027,0,0,1-24,24H288V368h48a8,8,0,0,0,6.291-12.942l-88-112a8,8,0,0,0-12.582,0l-88,112A8,8,0,0,0,160,368h48v32Zm176-40v88H224V360a8,8,0,0,0-8-8H176.46L248,260.949,319.54,352H280A8,8,0,0,0,272,360Z" />
        <path d="M280,480H216a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" />
      </g>
    </>,
  ],
  csv_new: [
    58,
    58,
    <>
      <g>
        <rect x="14.5" y="19" width="8" height="2" />
        <rect x="14.5" y="27" width="8" height="2" />
        <rect x="14.5" y="23" width="8" height="2" />
        <rect x="14.5" y="15" width="8" height="2" />
        <rect x="24.5" y="19" width="19" height="2" />
        <rect x="24.5" y="27" width="19" height="2" />
        <rect x="24.5" y="23" width="19" height="2" />
        <rect x="14.5" y="31" width="8" height="2" />
        <path
          d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M37.5,3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095
		C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M12.5,31v-2v-2v-2v-2v-2v-2v-2v-4h12v4h21v4v2v2v2v2v2v4h-21h-2h-10V31z"
        />
        <path
          d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M17.46,50.664
		c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67c0.296,0.142,0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178
		s0.549-0.31,0.786-0.574l1.135,0.998c-0.374,0.364-0.798,0.638-1.271,0.82c-0.474,0.183-0.984,0.273-1.531,0.273
		c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613
		c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235c0.214-0.643,0.51-1.178,0.889-1.606
		c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335c0.547,0,1.057,0.091,1.531,0.273
		c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574c-0.278-0.118-0.567-0.178-0.868-0.178
		c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183
		s-0.21,1.075-0.219,1.777C17.257,49.598,17.328,50.181,17.46,50.664z M30.407,52.298c-0.15,0.342-0.362,0.643-0.636,0.902
		s-0.611,0.467-1.012,0.622c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116
		c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212
		c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055
		c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793
		c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629
		c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189
		s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116
		c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396
		c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109
		s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014
		c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431
		c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588
		c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854
		c0.209,0.342,0.314,0.781,0.314,1.319C30.633,51.603,30.558,51.956,30.407,52.298z M37.168,54.055h-2.133l-3.131-10.131h1.873
		l2.338,8.695l2.475-8.695h1.859L37.168,54.055z"
        />
        <rect x="24.5" y="31" width="19" height="2" />
      </g>
    </>,
  ],
  doc: [
    58,
    58,
    <>
      <g style={{ fill: "#08A4E0" }}>
        <path
          d="M22.046,46.282c-0.287-0.333-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629h1.627
		c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244
		C22.526,46.986,22.333,46.615,22.046,46.282z"
        />
        <path
          d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M25.5,34h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S26.052,34,25.5,34z
		 M31.5,29h-10c-0.552,0-1-0.448-1-1s0.448-1,1-1h10c0.552,0,1,0.448,1,1S32.052,29,31.5,29z M44.5,29h-9c-0.552,0-1-0.448-1-1
		s0.448-1,1-1h9c0.552,0,1,0.448,1,1S45.052,29,44.5,29z M44.5,24h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1
		S45.052,24,44.5,24z M44.5,19h-2c-0.552,0-1-0.448-1-1s0.448-1,1-1h2c0.552,0,1,0.448,1,1S45.052,19,44.5,19z M37.5,3.391
		c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M30.5,17h8c0.552,0,1,0.448,1,1
		s-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1S29.948,17,30.5,17z M25.79,17.29c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.45,0.29,0.71
		c0,0.26-0.11,0.52-0.29,0.71C27.02,18.89,26.76,19,26.5,19c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71
		C25.5,17.74,25.61,17.48,25.79,17.29z M13.5,12h6c0.552,0,1,0.448,1,1s-0.448,1-1,1h-6c-0.552,0-1-0.448-1-1S12.948,12,13.5,12z
		 M13.5,17h9c0.552,0,1,0.448,1,1s-0.448,1-1,1h-9c-0.552,0-1-0.448-1-1S12.948,17,13.5,17z M13.5,22h22c0.552,0,1,0.448,1,1
		s-0.448,1-1,1h-22c-0.552,0-1-0.448-1-1S12.948,22,13.5,22z M13.5,27h4c0.552,0,1,0.448,1,1s-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1
		S12.948,27,13.5,27z M12.79,32.29c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.44,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71
		C14.02,33.89,13.76,34,13.5,34c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71C12.5,32.74,12.61,32.48,12.79,32.29z"
        />
        <path
          d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M24.233,50.808
		c-0.178,0.588-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219
		C20.503,53.984,20.307,54,20.18,54h-3.814V43.924H19.4c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073
		s0.74,0.955,0.95,1.524c0.209,0.569,0.314,1.155,0.314,1.757C24.5,49.511,24.411,50.22,24.233,50.808z M34.153,51.156
		c-0.214,0.647-0.511,1.185-0.889,1.613c-0.378,0.429-0.82,0.752-1.326,0.971s-1.06,0.328-1.661,0.328s-1.155-0.109-1.661-0.328
		s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235
		c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.82-0.754,1.326-0.978s1.06-0.335,1.661-0.335s1.155,0.111,1.661,0.335
		s0.948,0.549,1.326,0.978c0.378,0.429,0.674,0.964,0.889,1.606c0.214,0.643,0.321,1.388,0.321,2.235S34.367,50.509,34.153,51.156z
		 M38.487,50.664c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67c0.296,0.142,0.608,0.212,0.937,0.212
		s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574l1.135,0.998c-0.374,0.364-0.798,0.638-1.271,0.82
		c-0.474,0.183-0.984,0.273-1.531,0.273c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971
		c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235
		c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335
		c0.547,0,1.057,0.091,1.531,0.273c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574
		c-0.278-0.118-0.567-0.178-0.868-0.178c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649
		c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777C38.284,49.598,38.355,50.181,38.487,50.664z"
        />
        <path
          d="M32.048,45.988c-0.232-0.31-0.497-0.533-0.793-0.67c-0.296-0.137-0.608-0.205-0.937-0.205
		c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183
		s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67
		c0.296,0.142,0.608,0.212,0.937,0.212c0.337,0,0.658-0.066,0.964-0.198c0.305-0.132,0.579-0.349,0.82-0.649
		c0.241-0.301,0.431-0.695,0.567-1.183s0.209-1.082,0.219-1.784c-0.009-0.684-0.08-1.265-0.212-1.743
		C32.462,46.692,32.28,46.298,32.048,45.988z"
        />
      </g>
    </>,
  ],
  gif: [
    508,
    662.66669,
    <>
      <g style={{ fill: "#69249B" }}>
        <path d="m411.625 80-63.835938-63.835938v63.835938zm0 0" />
        <path d="m336.355469 102.855469c-6.308594 0-11.425781-5.117188-11.425781-11.425781v-91.429688h-331.429688v434.289062h434.289062v-331.433593zm34.289062 297.144531c0 6.320312-5.121093 11.429688-11.429687 11.429688h-297.144532c-6.308593 0-11.425781-5.109376-11.425781-11.429688v-262.855469c0-6.320312 5.117188-11.433593 11.425781-11.433593h297.144532c6.308594 0 11.429687 5.113281 11.429687 11.433593zm0 0" />
        <path d="m73.5 388.570312h274.289062v-240h-274.289062zm102.855469-194.28125h86.699219l-14.777344-14.78125c-4.46875-4.46875-4.46875-11.691406 0-16.15625 4.457031-4.46875 11.703125-4.46875 16.160156 0l34.273438 34.269532c1.0625 1.050781 1.898437 2.320312 2.480468 3.726562 1.15625 2.789063 1.15625 5.941406 0 8.730469-.582031 1.40625-1.417968 2.664063-2.480468 3.726563l-34.273438 34.277343c-2.226562 2.226563-5.15625 3.347657-8.082031 3.347657-2.921875 0-5.847657-1.121094-8.078125-3.347657-4.46875-4.46875-4.46875-11.695312 0-16.164062l14.777344-14.773438h-86.699219c-18.898438 0-34.285157 15.378907-34.285157 34.285157 0 6.320312-5.117187 11.425781-11.425781 11.425781-6.308593 0-11.429687-5.105469-11.429687-11.425781 0-31.507813 25.632812-57.140626 57.140625-57.140626zm-56.257813 132.773438c.582032-1.402344 1.414063-2.664062 2.476563-3.726562l34.277343-34.273438c4.457032-4.46875 11.703126-4.46875 16.15625 0 4.472657 4.46875 4.472657 11.6875 0 16.164062l-14.777343 14.773438h86.699219c18.902343 0 34.285156-15.382812 34.285156-34.289062 0-6.316407 5.121094-11.421876 11.429687-11.421876 6.308594 0 11.425781 5.105469 11.425781 11.421876 0 31.511718-25.628906 57.144531-57.140624 57.144531h-86.699219l14.777343 14.78125c4.472657 4.46875 4.472657 11.691406 0 16.15625-2.226562 2.226562-5.152343 3.351562-8.078124 3.351562-2.929688 0-5.851563-1.125-8.078126-3.351562l-34.277343-34.269531c-1.0625-1.054688-1.894531-2.320313-2.476563-3.726563-1.15625-2.789063-1.15625-5.945313 0-8.734375zm0 0" />
        <path d="m-6.5 457.144531v182.855469h434.289062v-182.855469zm80.101562 137.144531h22.710938c6.328125 0 11.476562-5.148437 11.476562-11.476562v-22.8125h-11.433593c-6.308594 0-11.425781-5.109375-11.425781-11.429688 0-6.320312 5.117187-11.425781 11.425781-11.425781h22.859375c6.308594 0 11.429687 5.105469 11.429687 11.425781v34.242188c0 18.925781-15.40625 34.332031-34.332031 34.332031h-22.710938c-18.957031 0-34.386718-15.429687-34.386718-34.390625v-68.363281c0-18.960937 15.429687-34.390625 34.386718-34.390625h45.613282c6.308594 0 11.429687 5.109375 11.429687 11.429688 0 6.320312-5.121093 11.425781-11.429687 11.425781h-45.613282c-6.367187 0-11.53125 5.167969-11.53125 11.535156v68.363281c0 6.367188 5.164063 11.535156 11.53125 11.535156zm171.328126 0c6.308593 0 11.425781 5.105469 11.425781 11.421876 0 6.324218-5.117188 11.433593-11.425781 11.433593h-68.574219c-6.308594 0-11.425781-5.109375-11.425781-11.433593 0-6.316407 5.117187-11.421876 11.425781-11.421876h22.859375v-91.433593h-22.859375c-6.308594 0-11.425781-5.105469-11.425781-11.425781 0-6.320313 5.117187-11.429688 11.425781-11.429688h68.574219c6.308593 0 11.425781 5.109375 11.425781 11.429688 0 6.320312-5.117188 11.425781-11.425781 11.425781h-22.859376v91.433593zm125.714843-57.144531c6.308594 0 11.425781 5.105469 11.425781 11.425781 0 6.320313-5.117187 11.429688-11.425781 11.429688h-57.144531v45.710938c0 6.324218-5.121094 11.433593-11.429688 11.433593-6.308593 0-11.425781-5.109375-11.425781-11.433593v-114.28125c0-6.320313 5.117188-11.429688 11.425781-11.429688h68.574219c6.308594 0 11.425781 5.109375 11.425781 11.429688 0 6.320312-5.117187 11.425781-11.425781 11.425781h-57.144531v34.289062zm0 0" />
      </g>
    </>,
  ],
  html: [
    58,
    58,
    <>
      <g style={{ fill: "#F14F45" }}>
        <path
          d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M37.5,3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095
		C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M34.793,18.707c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0l6,6
		c0.391,0.391,0.391,1.023,0,1.414l-6,6C36.012,30.902,35.756,31,35.5,31s-0.512-0.098-0.707-0.293
		c-0.391-0.391-0.391-1.023,0-1.414L40.086,24L34.793,18.707z M16.793,23.293l6-6c0.391-0.391,1.023-0.391,1.414,0
		s0.391,1.023,0,1.414L18.914,24l5.293,5.293c0.391,0.391,0.391,1.023,0,1.414C24.012,30.902,23.756,31,23.5,31
		s-0.512-0.098-0.707-0.293l-6-6C16.402,24.316,16.402,23.684,16.793,23.293z"
        />
        <path
          d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M18.455,54h-1.641v-4.539h-4.361V54h-1.668
		V43.924h1.668v4.416h4.361v-4.416h1.641V54z M28.107,45.045H25.1V54h-1.654v-8.955h-3.008v-1.121h7.67V45.045z M39.373,54h-1.668
		v-6.932l-2.256,5.605H34l-2.27-5.605V54h-1.668V43.924h1.668l2.994,6.891l2.98-6.891h1.668V54z M48.205,54h-6.303V43.924h1.668
		v8.832h4.635V54z"
        />
      </g>
    </>,
  ],
  jpeg: [
    58,
    58,
    <>
      <g style={{ fill: "#2FB57F" }}>
        <path
          d="M50.95,12.187L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963C7.777,0,6.5,0.916,6.5,2.926V39h0.633l16.736-14.245
		c0.397-0.337,0.986-0.314,1.355,0.055l4.743,4.743l9.795-10.727c0.181-0.198,0.434-0.315,0.703-0.325
		c0.282-0.009,0.53,0.09,0.725,0.274l10,9.5l0.311,0.297V13.978C51.5,13.212,51.408,12.645,50.95,12.187z M16.5,23.638
		c-3.071,0-5.569-2.498-5.569-5.569S13.429,12.5,16.5,12.5s5.569,2.498,5.569,5.569S19.571,23.638,16.5,23.638z M48.109,14H37.5
		V3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095C48.796,13.447,48.567,14,48.109,14z"
        />
        <path
          d="M31.383,30.969l4.807,4.807c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0L24.462,26.876L10.218,39H51.5v-7.636
		L40.551,20.928L31.383,30.969z"
        />
        <path d="M16.5,14.5c-1.968,0-3.569,1.601-3.569,3.569s1.601,3.569,3.569,3.569s3.569-1.601,3.569-3.569S18.468,14.5,16.5,14.5z" />
        <g>
          <path
            d="M26.946,45.858c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198h-1.23v3.992h1.504
			c0.2,0,0.398-0.034,0.595-0.103c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
			c0-0.164-0.023-0.354-0.068-0.567C27.181,46.26,27.087,46.055,26.946,45.858z"
          />
          <path
            d="M8.5,41H7.85H6.5v1.08V43v13c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H8.5z M20.021,51.566
			c0,0.474-0.087,0.873-0.26,1.196c-0.173,0.323-0.406,0.583-0.697,0.779c-0.292,0.196-0.627,0.333-1.005,0.41
			c-0.378,0.077-0.768,0.116-1.169,0.116c-0.201,0-0.436-0.021-0.704-0.062c-0.269-0.041-0.547-0.104-0.834-0.191
			s-0.563-0.185-0.827-0.294c-0.265-0.109-0.488-0.232-0.67-0.369l0.697-1.107c0.091,0.063,0.221,0.13,0.39,0.198
			c0.168,0.068,0.353,0.132,0.554,0.191c0.2,0.06,0.41,0.111,0.629,0.157s0.424,0.068,0.615,0.068c0.483,0,0.868-0.094,1.155-0.28
			s0.439-0.504,0.458-0.95v-7.711h1.668V51.566z M28.621,48.429c-0.173,0.415-0.415,0.764-0.725,1.046
			c-0.31,0.282-0.684,0.501-1.121,0.656s-0.921,0.232-1.449,0.232h-1.217V54h-1.641V43.924h2.898c0.428,0,0.852,0.068,1.271,0.205
			c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
			C28.881,47.552,28.794,48.014,28.621,48.429z M38.096,52.701c-0.21,0.265-0.444,0.48-0.704,0.649s-0.533,0.308-0.82,0.417
			S35.988,53.954,35.683,54c-0.306,0.046-0.608,0.068-0.909,0.068c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971
			c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235
			c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335
			c0.547,0,1.057,0.091,1.531,0.273c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.219-0.265-0.47-0.456-0.752-0.574
			c-0.283-0.118-0.574-0.178-0.875-0.178c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649
			c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.276,0.212,1.777
			c0.132,0.501,0.314,0.911,0.547,1.23s0.497,0.556,0.793,0.711c0.296,0.155,0.608,0.232,0.937,0.232c0.1,0,0.234-0.007,0.403-0.021
			c0.168-0.014,0.337-0.036,0.506-0.068c0.168-0.032,0.33-0.075,0.485-0.13c0.155-0.055,0.269-0.132,0.342-0.232v-2.488H34.76
			v-1.121h3.336V52.701z"
          />
        </g>
      </g>
    </>,
  ],
  pdf_new: [
    58,
    58,
    <>
      <g style={{ fill: "#C31817" }}>
        <path
          d="M39.57,25.259c0.149-0.209,0.207-0.343,0.23-0.415c-0.123-0.065-0.286-0.197-1.175-0.197c-0.505,0-1.139,0.022-1.811,0.108
		c0.815,0.627,1.014,0.944,1.547,0.944C38.594,25.7,39.262,25.69,39.57,25.259z"
        />
        <path
          d="M20.536,32.634c0.149-0.047,1.019-0.444,2.64-3.436c-2.138,1.201-3.008,2.188-3.07,2.744
		C20.095,32.034,20.068,32.276,20.536,32.634z"
        />
        <path
          d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M37.5,3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095
		C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M18.432,31.755c0.182-1.628,2.195-3.332,5.985-5.068
		c1.504-3.296,2.935-7.357,3.788-10.75c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215
		c0.228-0.076,0.804-0.172,1.016-0.172c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802
		c1.348,2.784,3.258,5.62,5.088,7.562c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117
		c0.32,0.622,0.189,1.349-0.39,2.16c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285
		c-2.837,0.593-6.151,1.651-8.828,2.822c-0.836,1.774-1.637,3.203-2.383,4.251c-1.023,1.438-1.907,2.107-2.782,2.107h0
		c-0.348,0-0.682-0.113-0.967-0.326C18.506,33.216,18.366,32.347,18.432,31.755z"
        />
        <path
          d="M21.222,45.858c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198h-1.23v3.992h1.504
		c0.2,0,0.398-0.034,0.595-0.103c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649
		c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567C21.456,46.26,21.363,46.055,21.222,45.858z"
        />
        <path
          d="M29.343,18.174c-0.716,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02
		C31.815,22.15,30.466,20.192,29.343,18.174z"
        />
        <path
          d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M22.896,48.429
		c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656s-0.921,0.232-1.449,0.232h-1.217V54h-1.641V43.924
		h2.898c0.428,0,0.852,0.068,1.271,0.205c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991
		s0.308,0.822,0.308,1.306C23.156,47.552,23.069,48.014,22.896,48.429z M32.952,50.808c-0.178,0.588-0.403,1.08-0.677,1.477
		s-0.581,0.709-0.923,0.937s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C29.222,53.984,29.026,54,28.898,54
		h-3.814V43.924h3.035c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524
		c0.209,0.569,0.314,1.155,0.314,1.757C33.219,49.511,33.13,50.22,32.952,50.808z M41.9,45.168h-4.635v3.172h4.211v1.121h-4.211V54
		h-1.668V43.924H41.9V45.168z"
        />
        <path
          d="M30.765,46.282c-0.287-0.333-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629h1.627
		c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244
		C31.245,46.986,31.052,46.615,30.765,46.282z"
        />
        <path d="M28.736,9.712c-0.098,0.033-1.33,1.757,0.096,3.216C29.781,10.813,28.779,9.698,28.736,9.712z" />
      </g>
    </>,
  ],
  png: [
    58,
    58,
    <>
      <g style={{ fill: "#062160" }}>
        <path
          d="M50.95,12.187L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963C7.777,0,6.5,0.916,6.5,2.926V39h0.633l16.736-14.245
		c0.397-0.337,0.986-0.314,1.355,0.055l4.743,4.743l9.795-10.727c0.181-0.198,0.434-0.315,0.703-0.325
		c0.282-0.009,0.53,0.09,0.725,0.274l10,9.5l0.311,0.297V13.978C51.5,13.212,51.408,12.645,50.95,12.187z M16.5,23.638
		c-3.071,0-5.569-2.498-5.569-5.569S13.429,12.5,16.5,12.5s5.569,2.498,5.569,5.569S19.571,23.638,16.5,23.638z M48.109,14H37.5
		V3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095C48.796,13.447,48.567,14,48.109,14z"
        />
        <path
          d="M31.383,30.969l4.807,4.807c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0L24.462,26.876L10.218,39H51.5v-7.636
		L40.551,20.928L31.383,30.969z"
        />
        <path
          d="M20.823,49.058c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
		c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492
		c-0.255-0.132-0.593-0.198-1.012-0.198h-1.23v3.992h1.504C20.429,49.16,20.627,49.126,20.823,49.058z"
        />
        <path d="M16.5,14.5c-1.968,0-3.569,1.601-3.569,3.569s1.601,3.569,3.569,3.569s3.569-1.601,3.569-3.569S18.468,14.5,16.5,14.5z" />
        <path
          d="M7.85,41H6.5v1.08V43v13c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41h-43H7.85z M35.302,46.679
		c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335
		c0.547,0,1.057,0.091,1.531,0.273c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.219-0.265-0.47-0.456-0.752-0.574
		c-0.283-0.118-0.574-0.178-0.875-0.178c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649
		c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.276,0.212,1.777
		c0.132,0.501,0.314,0.911,0.547,1.23s0.497,0.556,0.793,0.711c0.296,0.155,0.608,0.232,0.937,0.232c0.1,0,0.234-0.007,0.403-0.021
		c0.168-0.014,0.337-0.036,0.506-0.068c0.168-0.032,0.33-0.075,0.485-0.13c0.155-0.055,0.269-0.132,0.342-0.232v-2.488h-1.709
		v-1.121H42.5v3.896c-0.21,0.265-0.444,0.48-0.704,0.649s-0.533,0.308-0.82,0.417S40.392,53.954,40.087,54
		c-0.306,0.046-0.608,0.068-0.909,0.068c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971
		c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242S35.087,47.321,35.302,46.679z M25.369,43.924h1.668
		l3.951,6.945v-6.945h1.668V54h-1.668l-3.951-6.945V54h-1.668V43.924z M17.084,43.924h2.898c0.428,0,0.852,0.068,1.271,0.205
		c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
		c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
		s-0.921,0.232-1.449,0.232h-1.217V54h-1.641V43.924z"
        />
      </g>
    </>,
  ],
  ppt: [
    58,
    58,
    <>
      <g style={{ fill: "#EF720F" }}>
        <path
          d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M23.093,48.429
		c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656s-0.921,0.232-1.449,0.232h-1.217V54H16.94V43.924
		h2.898c0.428,0,0.852,0.068,1.271,0.205c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991
		s0.308,0.822,0.308,1.306C23.353,47.552,23.266,48.014,23.093,48.429z M31.364,48.429c-0.173,0.415-0.415,0.764-0.725,1.046
		c-0.31,0.282-0.684,0.501-1.121,0.656s-0.921,0.232-1.449,0.232h-1.217V54h-1.641V43.924h2.898c0.428,0,0.852,0.068,1.271,0.205
		c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
		C31.624,47.552,31.537,48.014,31.364,48.429z M40.606,45.045h-3.008V54h-1.654v-8.955h-3.008v-1.121h7.67V45.045z"
        />
        <path
          d="M21.418,45.858c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198h-1.23v3.992h1.504
		c0.2,0,0.398-0.034,0.595-0.103c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
		c0-0.164-0.023-0.354-0.068-0.567C21.652,46.26,21.559,46.055,21.418,45.858z"
        />
        <rect x="18.5" y="18" width="20" height="12" />
        <path
          d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M37.5,3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095
		C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M16.5,16h11v-2c0-0.553,0.448-1,1-1s1,0.447,1,1v2h11v16h-6.234l2.091,3.485
		c0.284,0.474,0.131,1.088-0.343,1.372C35.854,36.954,35.676,37,35.501,37c-0.34,0-0.671-0.173-0.858-0.485L31.934,32h-6.868
		l-2.709,4.515C22.17,36.827,21.839,37,21.499,37c-0.175,0-0.353-0.046-0.514-0.143c-0.474-0.284-0.627-0.898-0.343-1.372L22.734,32
		H16.5V16z"
        />
        <path
          d="M29.689,45.858c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198h-1.23v3.992h1.504
		c0.2,0,0.398-0.034,0.595-0.103c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
		c0-0.164-0.023-0.354-0.068-0.567C29.924,46.26,29.831,46.055,29.689,45.858z"
        />
      </g>
    </>,
  ],
  txt: [
    58,
    58,
    <>
      <g style={{ fill: "#7F7F7F" }}>
        <path
          d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M25.5,34h-8c-0.553,0-1-0.448-1-1s0.447-1,1-1h8c0.553,0,1,0.448,1,1S26.053,34,25.5,34z
		 M31.5,29h-10c-0.553,0-1-0.448-1-1s0.447-1,1-1h10c0.553,0,1,0.448,1,1S32.053,29,31.5,29z M44.5,29h-9c-0.553,0-1-0.448-1-1
		s0.447-1,1-1h9c0.553,0,1,0.448,1,1S45.053,29,44.5,29z M44.5,24h-6c-0.553,0-1-0.448-1-1s0.447-1,1-1h6c0.553,0,1,0.448,1,1
		S45.053,24,44.5,24z M44.5,19h-2c-0.553,0-1-0.448-1-1s0.447-1,1-1h2c0.553,0,1,0.448,1,1S45.053,19,44.5,19z M37.5,3.391
		c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M30.5,17h8c0.553,0,1,0.448,1,1
		s-0.447,1-1,1h-8c-0.553,0-1-0.448-1-1S29.947,17,30.5,17z M25.8,17.29c0.36-0.37,1.04-0.37,1.41,0c0.18,0.19,0.29,0.45,0.29,0.71
		c0,0.26-0.11,0.52-0.29,0.71C27.02,18.89,26.76,19,26.5,19s-0.521-0.11-0.71-0.29c-0.181-0.19-0.29-0.44-0.29-0.71
		S25.609,17.48,25.8,17.29z M13.5,12h6c0.553,0,1,0.448,1,1s-0.447,1-1,1h-6c-0.553,0-1-0.448-1-1S12.947,12,13.5,12z M13.5,17h9
		c0.553,0,1,0.448,1,1s-0.447,1-1,1h-9c-0.553,0-1-0.448-1-1S12.947,17,13.5,17z M13.5,22h22c0.553,0,1,0.448,1,1s-0.447,1-1,1h-22
		c-0.553,0-1-0.448-1-1S12.947,22,13.5,22z M13.5,27h4c0.553,0,1,0.448,1,1s-0.447,1-1,1h-4c-0.553,0-1-0.448-1-1S12.947,27,13.5,27
		z M12.79,32.29c0.37-0.37,1.05-0.37,1.42,0.01c0.18,0.18,0.29,0.44,0.29,0.7c0,0.26-0.11,0.52-0.29,0.71
		C14.02,33.89,13.76,34,13.5,34s-0.521-0.11-0.71-0.29c-0.181-0.19-0.29-0.45-0.29-0.71C12.5,32.74,12.609,32.48,12.79,32.29z"
        />
        <path
          d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M22.867,45.045h-3.008V54h-1.654v-8.955
		h-3.008v-1.121h7.67V45.045z M32,54h-1.9l-1.6-3.801h-0.137L26.641,54h-1.9l2.557-4.895l-2.721-5.182h1.873l1.777,4.102h0.137
		l1.928-4.102h1.873l-2.721,5.182L32,54z M41.529,45.045h-3.008V54h-1.654v-8.955h-3.008v-1.121h7.67V45.045z"
        />
      </g>
    </>,
  ],
  xls: [
    58,
    58,
    <>
      <g style={{ fill: "#0D6C13" }}>
        <rect x="14.5" y="15" width="8" height="2" />
        <rect x="14.5" y="19" width="8" height="2" />
        <rect x="24.5" y="19" width="19" height="2" />
        <rect x="24.5" y="31" width="19" height="2" />
        <rect x="24.5" y="23" width="19" height="2" />
        <rect x="14.5" y="23" width="8" height="2" />
        <rect x="24.5" y="27" width="19" height="2" />
        <path
          d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M23.936,54h-1.9l-1.6-3.801h-0.137
		L18.576,54h-1.9l2.557-4.895l-2.721-5.182h1.873l1.777,4.102h0.137l1.928-4.102H24.1l-2.721,5.182L23.936,54z M32.672,54h-6.303
		V43.924h1.668v8.832h4.635V54z M39.815,52.298c-0.15,0.342-0.362,0.643-0.636,0.902s-0.611,0.467-1.012,0.622
		c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116
		c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212
		c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055
		c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793
		c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629
		c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189
		s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116
		c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396
		c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109
		s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014
		c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431
		c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588
		c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854
		c0.209,0.342,0.314,0.781,0.314,1.319C40.041,51.603,39.966,51.956,39.815,52.298z"
        />
        <path
          d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M37.5,3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095
		C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M12.5,31v-2v-2v-2v-2v-2v-2v-2v-4h12v4h21v4v2v2v2v2v2v4h-21h-2h-10V31z"
        />
        <rect x="14.5" y="27" width="8" height="2" />
        <rect x="14.5" y="31" width="8" height="2" />
      </g>
    </>,
  ],
  xml: [
    58,
    58,
    <>
      <g style={{ fill: "#E8A721" }}>
        <path
          d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M37.5,3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095
		C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M33.793,18.707c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0l6,6
		c0.391,0.391,0.391,1.023,0,1.414l-6,6C35.012,30.902,34.756,31,34.5,31s-0.512-0.098-0.707-0.293
		c-0.391-0.391-0.391-1.023,0-1.414L39.086,24L33.793,18.707z M24.557,31.667l6-17c0.185-0.521,0.753-0.795,1.276-0.61
		c0.521,0.184,0.794,0.755,0.61,1.276l-6,17C26.298,32.744,25.912,33,25.5,33c-0.11,0-0.223-0.019-0.333-0.058
		C24.646,32.759,24.373,32.188,24.557,31.667z M15.793,23.293l6-6c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414L17.914,24
		l5.293,5.293c0.391,0.391,0.391,1.023,0,1.414C23.012,30.902,22.756,31,22.5,31s-0.512-0.098-0.707-0.293l-6-6
		C15.402,24.316,15.402,23.684,15.793,23.293z"
        />
        <path
          d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M22.936,54h-1.9l-1.6-3.801h-0.137
		L17.576,54h-1.9l2.557-4.895l-2.721-5.182h1.873l1.777,4.102h0.137l1.928-4.102H23.1l-2.721,5.182L22.936,54z M34.666,54h-1.668
		v-6.932l-2.256,5.605h-1.449l-2.27-5.605V54h-1.668V43.924h1.668l2.994,6.891l2.98-6.891h1.668V54z M43.498,54h-6.303V43.924h1.668
		v8.832h4.635V54z"
        />
      </g>
    </>,
  ],
  properties: [
    512,
    512,
    <>
      <g>
        <g>
          <g>
            <path d="m379.655 170.335c-5.522 0-10-4.478-10-10v-68.379c0-5.522 4.478-10 10-10s10 4.478 10 10v68.379c0 5.522-4.477 10-10 10z" />
          </g>
        </g>
        <g>
          <g>
            <circle cx="379.612" cy="59.778" r="10" />
          </g>
        </g>
        <g>
          <path d="m484.648 105.057c0-57.929-47.119-105.057-105.037-105.057-23.973 0-46.095 8.074-63.793 21.646h-252.073c-20.067 0-36.393 16.325-36.393 36.393v363.773c0 20.067 16.326 36.394 36.393 36.394h31.731v17.4c0 20.067 16.326 36.394 36.393 36.394h261.461c20.067 0 36.393-16.326 36.393-36.394v-138.702c0-5.522-4.478-10-10-10s-10 4.478-10 10v138.702c0 9.039-7.354 16.394-16.393 16.394h-261.461c-9.039 0-16.393-7.354-16.393-16.394v-17.4h209.731c20.067 0 36.394-16.326 36.394-36.394v-213.244c5.854 1.016 11.871 1.546 18.011 1.546 10.461 0 20.57-1.538 30.112-4.399v40.778c0 5.522 4.478 10 10 10s10-4.478 10-10v-49.125c32.692-17.826 54.924-52.52 54.924-92.311zm-143.047 316.756c0 9.039-7.354 16.394-16.394 16.394h-261.462c-9.039 0-16.393-7.354-16.393-16.394v-363.774c0-9.039 7.354-16.393 16.393-16.393h232.171c-12.552 16.533-20.326 36.883-21.248 58.974h-170.291c-5.522 0-10 4.478-10 10v42.234c0 5.522 4.478 10 10 10h180.198c2.273 0 4.369-.759 6.049-2.037 11.946 19.004 29.806 33.931 50.977 42.179zm-67.026-301.193v22.234h-160.198v-22.234zm105.036 69.493c-46.889 0-85.036-38.156-85.036-85.057 0-46.9 38.147-85.057 85.036-85.057 46.89 0 85.037 38.156 85.037 85.057s-38.147 85.057-85.037 85.057z" />
          <g>
            <g>
              <path d="m419.72 301.52c-4.12 0-7.897-2.637-9.349-6.482-1.491-3.946-.27-8.586 3.009-11.255 3.285-2.673 8.014-2.994 11.617-.758 3.596 2.232 5.437 6.635 4.464 10.764-1.053 4.466-5.146 7.731-9.741 7.731z" />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path d="m284.575 217.633h-180.198c-5.522 0-10-4.477-10-10 0-5.522 4.478-10 10-10h180.198c5.522 0 10 4.478 10 10s-4.477 10-10 10z" />
              </g>
            </g>
            <g>
              <g>
                <path d="m284.575 265.063h-180.198c-5.522 0-10-4.478-10-10 0-5.523 4.478-10 10-10h180.198c5.522 0 10 4.477 10 10 0 5.522-4.477 10-10 10z" />
              </g>
            </g>
            <g>
              <g>
                <path d="m284.575 312.493h-180.198c-5.522 0-10-4.478-10-10s4.478-10 10-10h180.198c5.522 0 10 4.478 10 10 0 5.523-4.477 10-10 10z" />
              </g>
            </g>
            <g>
              <g>
                <path d="m284.575 359.923h-180.198c-5.522 0-10-4.478-10-10 0-5.523 4.478-10 10-10h180.198c5.522 0 10 4.477 10 10 0 5.522-4.477 10-10 10z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </>,
  ],
  next: [
    512,
    512,
    <>
      <g>
        <g>
          <g>
            <path
              d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,490.667
				C126.604,490.667,21.333,385.396,21.333,256S126.604,21.333,256,21.333S490.667,126.604,490.667,256S385.396,490.667,256,490.667
				z"
            />
            <path
              d="M306.208,152.458c-4.167-4.167-10.917-4.167-15.083,0c-4.167,4.167-4.167,10.917,0,15.083l77.792,77.792H117.333
				c-5.896,0-10.667,4.771-10.667,10.667s4.771,10.667,10.667,10.667h251.583l-77.792,77.792c-4.167,4.167-4.167,10.917,0,15.083
				c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125l96-96c4.167-4.167,4.167-10.917,0-15.083L306.208,152.458
				z"
            />
          </g>
        </g>
      </g>
      ,
    </>,
  ],
  focus: [
    270,
    270,
    <>
      <defs>
        <path
          d="M253.76 104.17L253.76 17.13L166.72 17.13L166.72 37.61L218.79 37.61L204.81 51.64L161.34 95.06L38.72 217.68L38.72 165.61L18.24 165.61L18.24 252.65L105.28 252.65L105.28 232.17L53.21 232.17L175.83 109.55L219.25 66.08L233.28 52.1L233.28 104.17L253.76 104.17Z"
          id="a59P3vqcKp"
        ></path>
      </defs>
      <g>
        <g>
          <g>
            <use
              href="#a59P3vqcKp"
              opacity="1"
              // fill="#000000"
              fillOpacity="1"
            ></use>
            <g>
              <use
                href="#a59P3vqcKp"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="0"
              ></use>
            </g>
          </g>
        </g>
      </g>
    </>,
  ],
  restore: [
    270,
    270,
    <>
      <defs>
        <path
          d="M123.76 232.28L123.76 145.24L36.72 145.24L36.72 165.72L88.79 165.72L19.62 234.89L34.11 249.38L103.28 180.21L103.28 232.28L123.76 232.28Z"
          id="neUEzvEQK"
        ></path>
        <path
          d="M233.89 20.62L164.72 89.79L164.72 37.72L144.24 37.72L144.24 124.76L231.28 124.76L231.28 104.28L179.21 104.28L248.38 35.11L233.89 20.62Z"
          id="c7bk9ZEmQM"
        ></path>
      </defs>
      <g>
        <g>
          <g>
            <use
              href="#neUEzvEQK"
              opacity="1"
              // fill="#000000"
              fillOpacity="1"
            ></use>
            <g>
              <use
                href="#neUEzvEQK"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="0"
              ></use>
            </g>
          </g>
          <g>
            <use
              href="#c7bk9ZEmQM"
              opacity="1"
              // fill="#000000"
              fillOpacity="1"
            ></use>
            <g>
              <use
                href="#c7bk9ZEmQM"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="0"
              ></use>
            </g>
          </g>
        </g>
      </g>
    </>,
  ],
  person: [
    512,
    512,
    <>
      <path d="M68.169,447.023C71.835,449.023,159.075,496,256,496c105.008,0,184.772-47.134,188.116-49.14A8,8,0,0,0,448,440c0-64.593-19.807-123.7-55.771-166.442-25.158-29.9-56.724-50.28-91.539-59.662a104,104,0,1,0-89.38,0c-34.815,9.382-66.381,29.765-91.539,59.662C83.807,316.3,64,375.407,64,440A8,8,0,0,0,68.169,447.023ZM168,120a88,88,0,1,1,88,88A88.1,88.1,0,0,1,168,120ZM132.013,283.859C164.5,245.258,208.528,224,256,224s91.5,21.258,123.987,59.859c32.681,38.838,51.056,92.48,51.977,151.474C414.845,444.6,343.708,480,256,480c-81.11,0-157.5-35.609-175.96-44.856C81,376.223,99.367,322.656,132.013,283.859Z" />
    </>,
  ],
  activate: [
    24,
    24,
    <>
      <path d="m17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-11.5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
      <path d="m16.5 20c-.198 0-.39-.079-.53-.22l-2-2c-.293-.293-.293-.768 0-1.061s.768-.293 1.061 0l1.434 1.433 2.972-3.396c.274-.312.747-.341 1.059-.07.312.272.343.747.07 1.059l-3.5 4c-.138.155-.334.248-.541.255-.008 0-.017 0-.025 0z" />
      <path d="m8.25 20h-6c-1.24 0-2.25-1.01-2.25-2.25v-8.5c0-1.24 1.01-2.25 2.25-2.25h11.5c.645 0 1.255.275 1.675.757.272.312.241.785-.071 1.058-.31.273-.785.242-1.058-.071-.136-.155-.334-.244-.546-.244h-11.5c-.413 0-.75.337-.75.75v8.5c0 .413.337.75.75.75h6c.414 0 .75.336.75.75s-.336.75-.75.75z" />
      <path d="m12.25 8.5c-.414 0-.75-.336-.75-.75v-2.75c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v2.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-2.75c0-2.757 2.243-5 5-5s5 2.243 5 5v2.75c0 .414-.336.75-.75.75z" />
    </>,
  ],
  lock_old: [
    64,
    64,
    <>
      <g>
        <path d="m49.868 26h-2.368v-6.61c0-8.486-6.953-15.39-15.5-15.39s-15.5 6.904-15.5 15.39v6.61h-2.368c-3.033 0-5.5 2.467-5.5 5.5v23c0 3.032 2.467 5.5 5.5 5.5h35.736c3.032 0 5.5-2.468 5.5-5.5v-23c0-3.033-2.468-5.5-5.5-5.5zm-30.368-6.61c0-6.832 5.608-12.39 12.5-12.39s12.5 5.558 12.5 12.39v6.61h-25zm32.868 35.11c0 1.379-1.121 2.5-2.5 2.5h-35.736c-1.378 0-2.5-1.121-2.5-2.5v-23c0-1.378 1.122-2.5 2.5-2.5h35.736c1.379 0 2.5 1.122 2.5 2.5z" />
        <path d="m46 33c-.828 0-1.5.672-1.5 1.5v17c0 .828.672 1.5 1.5 1.5s1.5-.672 1.5-1.5v-17c0-.828-.672-1.5-1.5-1.5z" />
      </g>
    </>,
  ],
  unlock_old: [
    64,
    64,
    <>
      <g>
        <path d="m49.868 26h-3.868-26.5v-6.61c0-6.832 5.607-12.39 12.5-12.39s12.5 5.558 12.5 12.39c0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5c0-8.486-6.953-15.39-15.5-15.39s-15.5 6.904-15.5 15.39v6.61h-2.368c-3.033 0-5.5 2.467-5.5 5.5v23c0 3.032 2.467 5.5 5.5 5.5h35.736c3.032 0 5.5-2.468 5.5-5.5v-23c0-3.033-2.468-5.5-5.5-5.5zm2.5 28.5c0 1.379-1.121 2.5-2.5 2.5h-35.736c-1.378 0-2.5-1.121-2.5-2.5v-23c0-1.378 1.122-2.5 2.5-2.5h35.736c1.379 0 2.5 1.122 2.5 2.5z" />
        <path d="m46 33c-.828 0-1.5.672-1.5 1.5v17c0 .828.672 1.5 1.5 1.5s1.5-.672 1.5-1.5v-17c0-.828-.672-1.5-1.5-1.5z" />
      </g>
    </>,
  ],
  less: [
    290,
    290,
    <>
      <defs>
        <path
          d="M134.07 260.1L134.07 158.01L39.51 158.01L39.51 182.03L96.08 182.03L20.93 263.17L36.67 280.16L111.82 199.03L111.82 260.1L134.07 260.1Z"
          id="cORfoUOQ4"
        ></path>
        <path
          d="M253.73 11.84L178.57 92.97L178.57 31.9L156.32 31.9L156.32 133.99L250.89 133.99L250.89 109.97L194.32 109.97L269.47 28.83L253.73 11.84Z"
          id="b1IlJ8GQ4n"
        ></path>
      </defs>
      <g>
        <g>
          <g>
            <use
              href="#cORfoUOQ4"
              opacity="1"
              // fill="#000000"
              fillOpacity="1"
            ></use>
            <g>
              <use
                href="#cORfoUOQ4"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="0"
              ></use>
            </g>
          </g>
          <g>
            <use
              href="#b1IlJ8GQ4n"
              opacity="1"
              // fill="#000000"
              fillOpacity="1"
            ></use>
            <g>
              <use
                href="#b1IlJ8GQ4n"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="0"
              ></use>
            </g>
          </g>
        </g>
      </g>
    </>,
  ],
  plus: [
    340,
    340,
    <>
      <defs>
        <path
          d="M19.91 10C14.02 10 9.24 14.77 9.24 20.67C9.24 50.53 9.24 289.47 9.24 319.33C9.24 325.23 14.02 330 19.91 330C49.77 330 288.71 330 318.57 330C324.46 330 329.24 325.23 329.24 319.33C329.24 289.47 329.24 50.53 329.24 20.67C329.24 14.77 324.46 10 318.57 10C258.84 10 49.77 10 19.91 10ZM307.91 308.67L30.57 308.67L30.57 31.33L307.91 31.33L307.91 308.67Z"
          id="arUEeKQma"
        ></path>
        <path
          d="M158.57 180.67C158.57 219.07 158.57 240.4 158.57 244.67C158.57 250.56 163.35 255.33 169.24 255.33C175.13 255.33 179.91 250.56 179.91 244.67C179.91 240.4 179.91 219.07 179.91 180.67C218.31 180.67 239.64 180.67 243.91 180.67C249.8 180.67 254.57 175.9 254.57 170C254.57 164.1 249.8 159.33 243.91 159.33C239.64 159.33 218.31 159.33 179.91 159.33C179.91 120.93 179.91 99.6 179.91 95.33C179.91 89.44 175.13 84.67 169.24 84.67C163.35 84.67 158.57 89.44 158.57 95.33C158.57 99.6 158.57 120.93 158.57 159.33C120.17 159.33 98.84 159.33 94.57 159.33C88.68 159.33 83.91 164.1 83.91 170C83.91 175.9 88.68 180.67 94.57 180.67C103.11 180.67 124.44 180.67 158.57 180.67Z"
          id="c1n0f4JCeV"
        ></path>
      </defs>
      <g>
        <g>
          <g>
            <use
              href="#arUEeKQma"
              opacity="1"
              // fill="#000000"
              fillOpacity="1"
            ></use>
            <g>
              <use
                href="#arUEeKQma"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="0"
              ></use>
            </g>
          </g>
          <g>
            <use
              href="#c1n0f4JCeV"
              opacity="1"
              // fill="#000000"
              fillOpacity="1"
            ></use>
            <g>
              <use
                href="#c1n0f4JCeV"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="0"
              ></use>
            </g>
          </g>
        </g>
      </g>
    </>,
  ],
  snapshot: [
    430,
    430,
    <>
      <defs>
        <path
          d="M215 15.32C207.83 15.36 200.66 15.77 193.53 16.56C190.37 14.5 186.18 15.07 183.68 17.88C111.53 29.63 51.44 79.6 26.72 148.39C26.72 148.39 26.72 148.4 26.72 148.4C3.53 214.11 16.22 287.16 60.21 341.2C60.21 341.2 60.21 341.2 60.21 341.2C98.1 387.77 154.97 414.77 215 414.68C225.93 414.66 236.84 413.76 247.63 411.97C250.33 415.18 255.12 415.59 258.32 412.89C259.44 411.95 260.26 410.72 260.69 409.33C326.81 393.72 380.51 345.63 403.28 281.61C403.28 281.61 403.28 281.6 403.28 281.6C426.47 215.89 413.78 142.84 369.79 88.8C331.9 42.23 275.03 15.23 215 15.32ZM354.4 94.37C350.1 101.41 328.57 136.61 289.84 199.97L259.1 146.75C224.82 77.39 205.78 38.85 201.97 31.14C206.37 30.83 210.72 30.68 215 30.68C268.52 30.6 319.42 53.85 354.4 94.37ZM280.78 215L269.98 233.69L247.89 271.94L182.11 271.94L160.02 233.69L149.22 215L160.02 196.31L182.11 158.06L247.89 158.06L269.98 196.31L280.78 215ZM239.97 142.7L177.64 142.7C98.18 143.02 54.03 143.19 45.2 143.23C70.16 84.9 123.16 43.34 185.75 32.99C192.98 47.61 211.05 84.19 239.97 142.7ZM65.44 322.79C31.27 275.27 21.63 214.36 39.47 158.61C47.26 158.58 86.2 158.42 156.3 158.15L164.34 158.12L133.73 211.1C97.31 270.67 74.55 307.9 65.44 322.79ZM75.6 335.63C79.9 328.59 101.43 293.39 140.16 230.03L142.95 234.85L171.07 283.54C211.81 352.08 234.45 390.16 238.97 397.78C231.02 398.8 223.02 399.32 215 399.32C161.48 399.4 110.58 376.15 75.6 335.63ZM226.07 346L191.18 287.3L252.36 287.3C331.83 286.98 375.98 286.81 384.81 286.78C361.55 341.61 313.28 381.88 255.16 394.94C251.28 388.41 241.58 372.1 226.07 346ZM273.7 271.85L265.66 271.88L296.27 218.9C337.24 151.88 360 114.65 364.56 107.21C398.73 154.73 408.37 215.64 390.53 271.39C374.95 271.45 336.01 271.61 273.7 271.85Z"
          id="bJrldCIhl"
        ></path>
      </defs>
      <g>
        <g>
          <g>
            <use
              href="#bJrldCIhl"
              opacity="1"
              // fill="#000000"
              fillOpacity="1"
            ></use>
            <g>
              <use
                href="#bJrldCIhl"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="0"
              ></use>
            </g>
          </g>
        </g>
      </g>
    </>,
  ],
  prevLeg: [
    24,
    24,
    <>
      <g>
        <path d="m12 19a1 1 0 0 1 -.71-.29l-6-6a1 1 0 0 1 0-1.41l6-6a1 1 0 0 1 1.41 1.41l-5.29 5.29 5.29 5.29a1 1 0 0 1 -.7 1.71z" />
        <path d="m18 19a1 1 0 0 1 -.71-.29l-6-6a1 1 0 0 1 0-1.41l6-6a1 1 0 0 1 1.41 1.41l-5.29 5.29 5.29 5.29a1 1 0 0 1 -.7 1.71z" />
      </g>
    </>,
  ],
  nextLeg: [
    24,
    24,
    <>
      <g>
        <path d="m12 19a1 1 0 0 1 -.71-1.71l5.3-5.29-5.3-5.29a1 1 0 0 1 1.41-1.41l6 6a1 1 0 0 1 0 1.41l-6 6a1 1 0 0 1 -.7.29z" />
        <path d="m6 19a1 1 0 0 1 -.71-1.71l5.3-5.29-5.3-5.29a1 1 0 0 1 1.42-1.42l6 6a1 1 0 0 1 0 1.41l-6 6a1 1 0 0 1 -.71.3z" />
      </g>
    </>,
  ],
  return: [
    512,
    512,
    <>
      <g transform="matrix(6.12323e-17 -1 1 6.12323e-17 0 511.784)">
        <g>
          <g>
            <path d="M459.67,196.968l-176-192c-6.048-6.624-17.504-6.624-23.552,0l-176,192c-4.32,4.672-5.408,11.456-2.88,17.248    c2.56,5.824,8.32,9.568,14.656,9.568h80v87.36c0,36.96-11.2,72.64-32.352,103.2c-21.12,30.464-50.624,53.44-85.28,66.464    c-7.264,2.72-11.488,10.24-10.112,17.856c1.376,7.616,8,13.12,15.744,13.12h90.88c117.536,0,213.12-95.616,213.12-213.12v-74.88    h80c6.336,0,12.096-3.744,14.656-9.568C465.078,208.424,463.99,201.64,459.67,196.968z M351.894,191.784c-8.832,0-16,7.168-16,16    v90.88c0,99.872-81.248,181.12-181.12,181.12h-29.632c17.088-13.248,32.16-29.088,44.704-47.2    c24.896-35.968,38.048-77.952,38.048-121.44v-103.36c0-8.832-7.168-16-16-16h-59.616l139.616-152.32l139.616,152.32H351.894z" />
          </g>
        </g>
      </g>
    </>,
  ],
  calculate: [
    430,
    430,
    <>
      <g>
        <g>
          <path
            d="M343.5,0H72.6C32.5,0,0.1,32.5,0,72.5v270.9c0,40.1,32.5,72.5,72.5,72.6h270.9c40.1,0,72.5-32.5,72.6-72.5V72.6
			C416,32.5,383.5,0,343.5,0z M396,343.5c0,29-23.5,52.5-52.5,52.5H72.6c-29,0-52.5-23.5-52.6-52.5V72.6c0-29,23.5-52.5,52.5-52.6
			h270.9c29,0,52.5,23.5,52.6,52.5V343.5z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M155.9,281H119v-31.3c0-5.5-4.5-10-10-10s-10,4.5-10,10V281H62.1c-5.5,0-10,4.5-10,10s4.5,10,10,10H99v37.3
			c0,5.5,4.5,10,10,10s10-4.5,10-10V301h36.9c5.5,0,10-4.5,10-10S161.4,281,155.9,281z"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M155.9,109H62.1c-5.5,0-10,4.5-10,10s4.5,10,10,10h93.8c5.5,0,10-4.5,10-10S161.4,109,155.9,109z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M343.5,313h-93.8c-5.5,0-10,4.5-10,10s4.5,10,10,10h93.8c5.5,0,10-4.5,10-10S349,313,343.5,313z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M343.5,266h-93.8c-5.5,0-10,4.5-10,10s4.5,10,10,10h93.8c5.5,0,10-4.5,10-10S349,266,343.5,266z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M339.6,144.3c0,0,0,0-0.1-0.1l-26.8-26.8l26.8-26.8c3.9-3.9,3.9-10.2,0-14.1s-10.2-3.9-14.1,0l-26.8,26.8l-26.8-26.8
			c-3.9-3.9-10.2-3.9-14.1-0.1c-3.9,3.9-3.9,10.2-0.1,14.1c0,0,0,0,0.1,0.1l26.8,26.8l-26.8,26.8c-3.9,3.8-3.9,10.2,0,14.1
			c3.9,3.9,10.2,3.9,14.1,0l26.8-26.8l26.8,26.8c3.9,3.9,10.2,3.9,14.1,0.1C343.4,154.5,343.4,148.2,339.6,144.3z"
          />
        </g>
      </g>
    </>,
  ],
  deactivate: [
    24,
    24,
    <>
      <path
        d="m11.864 16.75h11.272v1.5h-11.272z"
        transform="matrix(.707 -.707 .707 .707 -7.249 17.5)"
      />
      <path d="m17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-11.5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
      <path d="m8.25 20h-6c-1.24 0-2.25-1.01-2.25-2.25v-8.5c0-1.24 1.01-2.25 2.25-2.25h11.5c.645 0 1.255.275 1.675.757.272.312.241.785-.071 1.058-.31.273-.785.241-1.058-.071-.136-.155-.334-.244-.546-.244h-11.5c-.413 0-.75.337-.75.75v8.5c0 .413.337.75.75.75h6c.414 0 .75.336.75.75s-.336.75-.75.75z" />
      <path d="m12.25 8.5c-.414 0-.75-.336-.75-.75v-2.75c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v2.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-2.75c0-2.757 2.243-5 5-5s5 2.243 5 5v2.75c0 .414-.336.75-.75.75z" />
    </>,
  ],
  access_request: [
    50,
    50,
    <>
      <g>
        <path d="m29.3 24c.1.1.3.1.4.1.2 0 .4-.1.6-.2l6.5-5.2h9.4c1.5 0 2.8-1.3 2.8-2.8v-12c0-1.6-1.2-2.9-2.8-2.9h-18.5c-1.5 0-2.8 1.3-2.8 2.8v12c0 1.5 1.3 2.8 2.8 2.8h1v4.5c0 .4.2.7.6.9zm16.9-7.4h-9.8c-.2 0-.4.1-.6.2l-5.1 4.2v-3.4c0-.6-.4-1-1-1h-.7l18-12.6v11.8c0 .5-.4.8-.8.8zm-18.5-13.6h17.3l-18.1 12.6v-11.8c0-.4.4-.8.8-.8z" />
        <path d="m23.7 19c0-4.6-3.8-8.4-8.4-8.4s-8.4 3.8-8.4 8.4c0 4.8 3.7 10.5 8.4 10.5s8.4-5.8 8.4-10.5zm-14.8 0c0-3.5 2.9-6.4 6.4-6.4s6.4 2.9 6.4 6.4c0 3.7-3.1 8.5-6.4 8.5s-6.4-4.8-6.4-8.5z" />
        <path d="m2 49h26.1c.6 0 1-.4 1-1v-5.4c-.1-6.4-5.4-11.6-11.8-11.6h-4.4c-6.4 0-11.7 5-11.9 11.4v5.6c0 .6.4 1 1 1zm10.9-16h4.4c5.4 0 9.8 4.4 9.9 9.7v4.3h-24.2v-4.5c.2-5.3 4.5-9.5 9.9-9.5z" />
        <path d="m30.1 7.8h.8v.8c0 .6.4 1 1 1s1-.4 1-1v-.8h.8c.6 0 1-.4 1-1s-.4-1-1-1h-.8v-.7c0-.6-.4-1-1-1s-1 .4-1 1v.8h-.8c-.6 0-1 .4-1 1s.5.9 1 .9z" />
        <path d="m44.2 11.5h-3.5c-.6 0-1 .4-1 1s.4 1 1 1h3.5c.6 0 1-.4 1-1s-.5-1-1-1z" />
      </g>
    </>,
  ],
  replace: [
    60,
    60,
    <>
      <g>
        <path
          d="M34.925,20l-8.513,6.191c-0.447,0.324-0.546,0.95-0.221,1.396c0.195,0.27,0.5,0.412,0.81,0.412
		c0.204,0,0.409-0.063,0.587-0.191L39.7,19l-12.112-8.809c-0.448-0.325-1.073-0.227-1.396,0.221
		c-0.325,0.446-0.227,1.072,0.221,1.396L34.925,18H23c-7.168,0-13,5.832-13,13c0,0.553,0.447,1,1,1s1-0.447,1-1
		c0-6.065,4.935-11,11-11H34.925z"
        />
        <path
          d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
		S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"
        />
        <path
          d="M48,28c-0.553,0-1,0.447-1,1c0,6.065-4.935,11-11,11H24.075l8.513-6.191c0.447-0.324,0.546-0.95,0.221-1.396
		c-0.324-0.447-0.949-0.546-1.396-0.221L19.3,41l12.112,8.809C31.59,49.938,31.795,50,31.999,50c0.31,0,0.614-0.143,0.81-0.412
		c0.325-0.446,0.227-1.072-0.221-1.396L24.075,42H36c7.168,0,13-5.832,13-13C49,28.447,48.553,28,48,28z"
        />
      </g>
    </>,
  ],
  lock: [
    512,
    512,
    <>
      <g>
        <g>
          <path
            d="M256,294.128c-22.526,0-40.851,18.325-40.851,40.851c0,12.889,6.156,25.01,16.34,32.67v43.585
			c0,4.513,3.657,8.17,8.17,8.17h32.681c4.513,0,8.17-3.657,8.17-8.17v-43.586c10.183-7.66,16.34-19.781,16.34-32.669
			C296.851,312.453,278.526,294.128,256,294.128z M268.248,356.205c-2.523,1.461-4.077,4.155-4.077,7.071v39.788h-16.34v-39.787
			c0-2.916-1.555-5.61-4.079-7.071c-7.562-4.377-12.262-12.51-12.262-21.226c0-13.515,10.996-24.511,24.511-24.511
			s24.511,10.996,24.511,24.511C280.511,343.695,275.812,351.828,268.248,356.205z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle cx="136.17" cy="454.808" r="8.17" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="168.851" cy="422.128" r="8.17" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M386.723,201.532h-12.936v-84.426C373.787,52.534,321.253,0,256.681,0S139.574,52.534,139.574,117.106v84.426h-14.298
			c-22.526,0-40.851,18.325-40.851,40.851v228.766c0,22.526,18.325,40.851,40.851,40.851h261.447
			c22.526,0,40.851-18.325,40.851-40.851V242.383C427.574,219.857,409.249,201.532,386.723,201.532z M155.915,117.106
			c0-55.563,45.203-100.766,100.766-100.766c55.563,0,100.766,45.203,100.766,100.766v84.426h-27.234v-84.426
			c0-40.546-32.986-73.532-73.532-73.532c-40.546,0-73.532,32.986-73.532,73.532v59.915c0,4.513,3.657,8.17,8.17,8.17
			s8.17-3.657,8.17-8.17v-59.915c0-31.535,25.657-57.191,57.191-57.191s57.192,25.657,57.192,57.191v84.426H155.915V117.106z
			 M411.234,471.149c0,13.515-10.996,24.511-24.511,24.511H125.277c-13.515,0-24.511-10.996-24.511-24.511V242.383
			c0-13.515,10.996-24.511,24.511-24.511h261.447c13.515,0,24.511,10.996,24.511,24.511V471.149z"
          />
        </g>
      </g>
    </>,
  ],
  unlock: [
    512,
    512,
    <>
      <g>
        <g>
          <path
            d="M370.723,0c-64.572,0-117.106,52.534-117.106,117.106v84.426H65.021c-22.526,0-40.851,18.325-40.851,40.851v228.766
			C24.17,493.675,42.495,512,65.021,512h261.447c22.526,0,40.851-18.325,40.851-40.851V242.383
			c0-22.526-18.325-40.851-40.851-40.851h-56.511v-84.426c0-55.563,45.203-100.766,100.766-100.766
			c55.563,0,100.766,45.203,100.766,100.766v84.426h-27.234v-84.426c0-40.546-32.986-73.532-73.532-73.532
			s-73.532,32.986-73.532,73.532v59.915c0,4.513,3.657,8.17,8.17,8.17s8.17-3.657,8.17-8.17v-59.915
			c0-31.535,25.657-57.191,57.191-57.191s57.191,25.657,57.191,57.191v92.596c0,4.513,3.657,8.17,8.17,8.17h43.574
			c4.513,0,8.17-3.657,8.17-8.17v-92.596C487.83,52.534,435.295,0,370.723,0z M326.468,217.872
			c13.515,0,24.511,10.996,24.511,24.511v228.766c0,13.515-10.996,24.511-24.511,24.511H65.021
			c-13.515,0-24.511-10.996-24.511-24.511V242.383c0-13.515,10.996-24.511,24.511-24.511H326.468z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M195.745,294.128c-22.526,0-40.851,18.325-40.851,40.851c0,12.889,6.156,25.01,16.34,32.67v43.585
			c0,4.513,3.657,8.17,8.17,8.17h32.681c4.513,0,8.17-3.657,8.17-8.17v-43.586c10.183-7.66,16.34-19.781,16.34-32.669
			C236.596,312.453,218.269,294.128,195.745,294.128z M207.992,356.205c-2.523,1.461-4.077,4.155-4.077,7.071v39.788h-16.34v-39.787
			c0-2.916-1.555-5.61-4.079-7.071c-7.562-4.377-12.262-12.51-12.262-21.226c0-13.515,10.996-24.511,24.511-24.511
			s24.511,10.996,24.511,24.511C220.255,343.695,215.556,351.828,207.992,356.205z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle cx="75.906" cy="454.808" r="8.17" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="108.587" cy="422.128" r="8.17" />
        </g>
      </g>
    </>,
  ],
  reopen: [
    24,
    24,
    <>
      <g id="XMLID_1_">
        <path d="m23.5 4.997c.28 0 .5.23.5.5 0 .28-.22.5-.5.5h-.5v-1z" />
        <path d="m1 4.997h22v1h-22z" />
        <path d="m14.5 14.997c1.85 0 3.45-1.12 4.14-2.73-.59.46-1.34.73-2.14.73h-6.5c-.28 0-.5-.22-.5-.5v-1.79l-3.29 3.29 3.29 3.3v-1.8c0-.27.22-.5.5-.5zm-9.35-.64c-.2-.2-.2-.51 0-.71l4.5-4.5c.14-.14.36-.19.54-.11.19.08.31.26.31.46v2.5h6c1.38 0 2.5-1.12 2.5-2.5 0-.27.22-.5.5-.5s.5.23.5.5v1c0 3.04-2.47 5.5-5.5 5.5h-4v2.5c0 .21-.12.39-.31.47-.06.02-.13.03-.19.03-.13 0-.26-.05-.35-.14z" />
        <path d="m1 4.997v1h-.5c-.28 0-.5-.22-.5-.5 0-.27.22-.5.5-.5z" />
        <path d="m21.5 1.997h-19c-.83 0-1.5.68-1.5 1.5v1.5h-.5c-.28 0-.5.23-.5.5v-2c0-1.37 1.12-2.5 2.5-2.5h19c1.38 0 2.5 1.13 2.5 2.5v2c0-.27-.22-.5-.5-.5h-.5v-1.5c0-.82-.67-1.5-1.5-1.5z" />
        <path d="m21.5 22.997h-19c-1.38 0-2.5-1.12-2.5-2.5v-15c0 .28.22.5.5.5h.5v14.5c0 .83.67 1.5 1.5 1.5h19c.83 0 1.5-.67 1.5-1.5v-14.5h.5c.28 0 .5-.22.5-.5v15c0 1.38-1.12 2.5-2.5 2.5z" />
      </g>
    </>,
  ],
  change_param: [
    368,
    368,
    <>
      <g>
        <g>
          <path
            d="M303.384,100.944c-0.408-0.984-1-1.872-1.736-2.616l-47.992-47.992c-3.128-3.128-8.184-3.128-11.312,0
			c-3.128,3.128-3.128,8.184,0,11.312L276.688,96H104c-4.416,0-8,3.576-8,8v64c0,4.424,3.584,8,8,8s8-3.576,8-8v-56h164.688
			l-34.344,34.344c-3.128,3.128-3.128,8.184,0,11.312c1.56,1.56,3.608,2.344,5.656,2.344c2.048,0,4.096-0.784,5.656-2.344
			l47.992-47.992c0.744-0.736,1.328-1.624,1.736-2.608C304.192,105.104,304.192,102.896,303.384,100.944z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M264,192c-4.424,0-8,3.576-8,8v56H91.312l34.344-34.344c3.128-3.128,3.128-8.184,0-11.312
			c-3.128-3.128-8.184-3.128-11.312,0l-47.992,47.992c-0.744,0.736-1.328,1.624-1.736,2.608c-0.808,1.952-0.808,4.16,0,6.112
			c0.408,0.984,0.992,1.864,1.736,2.608l47.992,47.992c1.56,1.56,3.608,2.344,5.656,2.344c2.048,0,4.096-0.784,5.656-2.344
			c3.128-3.128,3.128-8.184,0-11.312L91.312,272H264c4.424,0,8-3.576,8-8v-64C272,195.576,268.424,192,264,192z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M328,0H40C17.944,0,0,17.944,0,40v288c0,22.056,17.944,40,40,40h288c22.056,0,40-17.944,40-40.008V40
			C368,17.944,350.056,0,328,0z M352,327.992C352,341.224,341.232,352,328,352H40c-13.232,0-24-10.768-24-24V40
			c0-13.232,10.768-24,24-24h288c13.232,0,24,10.768,24,24V327.992z"
          />
        </g>
      </g>
    </>,
  ],
  portal_home: [
    64,
    64,
    <>
      <path d="m63.168 25.527-30.118-24.497c-.304-.248-.68-.345-1.05-.319-.37-.026-.745.071-1.049.319l-30.119 24.497c-.309.251-.505.614-.546 1.01s.078.791.329 1.1l5.696 7.003c.296.365.729.554 1.165.554.027 0 .053-.012.08-.014.042.003.083.014.125.014.333 0 .667-.11.945-.336l.765-.622v26.698c0 1.301 1.059 2.359 2.36 2.359h40.5c1.302 0 2.36-1.059 2.36-2.359v-26.698l.765.622c.309.25.705.364 1.1.328.023-.002.044-.01.066-.014.047 0 .092.018.139.014.396-.041.76-.237 1.011-.546l5.695-7.003c.521-.643.424-1.587-.219-2.11zm-8.557 4.674v-.148h-.182l-21.379-17.387c-.304-.247-.68-.344-1.05-.319-.37-.026-.745.071-1.049.319l-21.378 17.387h-.183v.148l-1.575 1.281-3.721-4.575 27.906-22.697 27.906 22.698-3.72 4.575zm-17.67 30.092h-9.88v-16.899c0-2.708 2.073-5.038 4.623-5.193 1.438-.096 2.797.422 3.808 1.425.936.951 1.45 2.197 1.45 3.509v17.158zm14.67 0h-11.67v-17.159c0-2.104-.821-4.097-2.324-5.625-1.64-1.627-3.815-2.446-6.118-2.303-4.171.255-7.438 3.851-7.438 8.188v16.899h-11.671v-28.497l19.61-15.949 19.61 15.949v28.497z" />
    </>,
  ],
  specifications: [
    512,
    512,
    <>
      <g>
        <g>
          <path
            d="M456.354,334.396c-0.495-0.828-1.016-1.621-1.536-2.321c-5.171-7.228-12.86-12.006-21.632-13.449
			c-8.73-1.442-17.579,0.614-24.781,5.786l-95.403,68.122h-99.669c-4.702,0-8.533-3.823-8.533-8.533s3.831-8.533,8.533-8.533H268.8
			c16.469,0,29.867-13.397,29.867-29.867c0-0.094-0.009-0.879-0.017-0.964c-0.529-16.461-14.413-29.295-30.532-28.902h-111.01
			c-9.839,0.085-19.422,3.61-26.974,9.907l-41.728,34.731c-1.946,1.63-3.072,4.028-3.072,6.562v102.4
			c0,4.719,3.823,8.533,8.533,8.533h211.721c13.858-0.017,27.358-4.898,38.025-13.73l103.45-85.478
			C461.116,368.648,465.195,349.21,456.354,334.396z M436.685,365.133L332.74,450.987c-7.629,6.315-17.28,9.796-27.162,9.813H102.4
			v-89.865l38.664-32.188c4.54-3.78,10.283-5.897,16.12-5.948l111.206-0.008c7.074-0.009,12.979,5.342,13.21,12.809
			c0,7.057-5.743,12.8-12.8,12.8h-55.467c-14.114,0-25.6,11.486-25.6,25.6s11.486,25.6,25.6,25.6h102.4
			c1.775,0,3.507-0.555,4.975-1.587l97.638-69.726c3.516-2.526,7.791-3.507,12.075-2.825c4.275,0.708,8.013,3.029,10.581,6.613
			c0.256,0.35,0.486,0.708,0.708,1.075C446.029,350.379,444.023,359.876,436.685,365.133z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M93.611,349.867H0v17.067h85.077v128H0V512h93.611c4.71,0,8.533-3.814,8.533-8.533V358.4
			C102.144,353.681,98.321,349.867,93.611,349.867z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M42.667,426.667c-14.114,0-25.6,11.486-25.6,25.6c0,14.114,11.486,25.6,25.6,25.6s25.6-11.486,25.6-25.6
			C68.267,438.153,56.781,426.667,42.667,426.667z M42.667,460.8c-4.702,0-8.533-3.823-8.533-8.533c0-4.71,3.831-8.533,8.533-8.533
			c4.702,0,8.533,3.823,8.533,8.533C51.2,456.977,47.369,460.8,42.667,460.8z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M503.467,264.533H8.533c-4.71,0-8.533,3.814-8.533,8.533c0,32.93,26.795,59.733,59.733,59.733h392.533
			c32.93,0,59.733-26.803,59.733-59.733C512,268.348,508.186,264.533,503.467,264.533z M452.267,315.733H59.733
			c-20.608,0-37.845-14.686-41.805-34.133h476.143C490.112,301.047,472.875,315.733,452.267,315.733z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M256,42.667c-122.334,0-221.867,99.533-221.867,221.867v8.533c0,4.719,3.823,8.533,8.533,8.533h426.667
			c4.719,0,8.533-3.814,8.533-8.533v-8.533C477.867,142.199,378.342,42.667,256,42.667z M51.2,264.533
			c0-112.922,91.878-204.8,204.8-204.8s204.8,91.878,204.8,204.8H51.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M115.644,140.006c-5.965,6.707-11.494,13.884-16.435,21.342l14.225,9.429c4.506-6.793,9.54-13.338,14.967-19.439
			L115.644,140.006z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M256,76.8c-47.923,0.026-93.551,18.133-128.469,50.961l11.691,12.433c31.744-29.85,73.224-46.302,116.787-46.327L256,76.8
			z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="230.4" width="51.2" height="17.067" />
        </g>
      </g>
      <g>
        <g>
          <rect x="247.467" y="8.533" width="17.067" height="42.667" />
        </g>
      </g>
    </>,
  ],
  schedules: [
    128,
    128,
    <>
      <g>
        <path d="m121.693 14.088h-22.429v-7.781a1.75 1.75 0 0 0 -1.75-1.75h-7.462a1.749 1.749 0 0 0 -1.75 1.75v7.781h-18.821v-7.781a1.749 1.749 0 0 0 -1.75-1.75h-7.462a1.749 1.749 0 0 0 -1.75 1.75v7.781h-18.819v-7.781a1.749 1.749 0 0 0 -1.75-1.75h-7.464a1.75 1.75 0 0 0 -1.75 1.75v7.781h-22.429a1.749 1.749 0 0 0 -1.75 1.75v105.855a1.749 1.749 0 0 0 1.75 1.75h115.386a1.749 1.749 0 0 0 1.75-1.75v-105.855a1.749 1.749 0 0 0 -1.75-1.75zm-29.893-6.031h3.962v15.562h-3.962zm-29.783 0h3.962v15.562h-3.96zm-29.783 0h3.966v15.562h-3.964zm-24.177 9.531h20.679v7.781a1.75 1.75 0 0 0 1.75 1.75h7.462a1.749 1.749 0 0 0 1.75-1.75v-7.781h18.821v7.781a1.749 1.749 0 0 0 1.75 1.75h7.462a1.749 1.749 0 0 0 1.75-1.75v-7.781h18.819v7.781a1.749 1.749 0 0 0 1.75 1.75h7.462a1.75 1.75 0 0 0 1.75-1.75v-7.781h20.679v20.025h-111.884zm0 102.355v-78.83h111.886v78.83z" />
        <path d="m27.66 49.015a8.033 8.033 0 1 0 8.033 8.033 8.041 8.041 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z" />
        <path d="m51.887 49.015a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.538 4.538 0 0 1 -4.533 4.533z" />
        <path d="m76.113 49.015a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z" />
        <path d="m100.34 49.015a8.033 8.033 0 1 0 8.032 8.033 8.041 8.041 0 0 0 -8.032-8.033zm0 12.566a4.533 4.533 0 1 1 4.532-4.533 4.537 4.537 0 0 1 -4.532 4.533z" />
        <path d="m27.66 72.5a8.034 8.034 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.538 4.538 0 0 1 -4.533 4.529z" />
        <path d="m51.887 72.5a8.034 8.034 0 1 0 8.033 8.033 8.043 8.043 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.539 4.539 0 0 1 -4.533 4.529z" />
        <path d="m76.113 72.5a8.034 8.034 0 1 0 8.033 8.033 8.043 8.043 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.538 4.538 0 0 1 -4.533 4.529z" />
        <path d="m100.34 72.5a8.034 8.034 0 1 0 8.032 8.033 8.042 8.042 0 0 0 -8.032-8.033zm0 12.567a4.534 4.534 0 1 1 4.532-4.534 4.538 4.538 0 0 1 -4.532 4.529z" />
        <path d="m27.66 95.976a8.033 8.033 0 1 0 8.033 8.033 8.041 8.041 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z" />
        <path d="m51.887 95.976a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.538 4.538 0 0 1 -4.533 4.533z" />
        <path d="m76.113 95.976a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z" />
        <path d="m100.34 95.976a8.033 8.033 0 1 0 8.032 8.033 8.041 8.041 0 0 0 -8.032-8.033zm0 12.566a4.533 4.533 0 1 1 4.532-4.533 4.537 4.537 0 0 1 -4.532 4.533z" />
      </g>
    </>,
  ],
  orders: [
    511.995,
    511.995,
    <>
      <g>
        <g>
          <path
            d="M289.437,23.138c-4.468-10.497-13.268-18.47-24.541-21.975c-16.492-4.306-33.87,3.641-41.425,18.862
			c-12.339,24.789-18.785,52.545-18.632,80.199v266.817c0,0.537,0.051,1.074,0.154,1.612l22.955,118.938
			c1.936,13.925,13.993,24.405,28.029,24.405c0.009,0,0.026,0,0.043,0c14.053,0,26.102-10.488,27.961-23.961l23.023-119.381
			c0.111-0.529,0.162-1.074,0.162-1.612V100.207C307.106,73.526,300.915,46.742,289.437,23.138z M290.111,366.214l-22.938,119.023
			c-0.767,5.534-5.568,9.704-11.179,9.704c-5.602,0-10.395-4.17-11.222-10.139l-22.87-118.58V100.182
			c-0.136-25.044,5.688-50.14,16.85-72.567c3.991-8.033,13.2-12.22,21.454-10.062c6.097,1.902,11.043,6.37,13.712,12.637
			c10.54,21.702,16.133,45.919,16.193,70.034V366.214z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M217.732,189.163c-2.584-1.543-5.799-1.603-8.425-0.171L4.654,299.847c-2.754,1.492-4.468,4.366-4.468,7.495v51.163
			c0,2.797,1.364,5.406,3.667,7.009c1.45,0.998,3.147,1.518,4.861,1.518c1.006,0,2.021-0.171,2.993-0.537l204.653-76.745
			c3.326-1.253,5.534-4.434,5.534-7.99v-85.272C221.893,193.487,220.316,190.707,217.732,189.163z M204.839,275.851L17.24,346.201
			v-33.776l187.599-101.61V275.851z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M507.35,299.847L302.697,188.993c-2.643-1.424-5.841-1.373-8.425,0.171c-2.575,1.535-4.161,4.315-4.161,7.325v85.272
			c0,3.556,2.2,6.745,5.526,7.99l204.653,76.745c0.981,0.358,1.995,0.537,3.002,0.537c1.714,0,3.411-0.512,4.843-1.518
			c2.302-1.595,3.675-4.212,3.675-7.009v-51.163C511.81,304.213,510.096,301.339,507.35,299.847z M494.764,346.201l-187.599-70.35
			v-65.046l187.599,101.619V346.201z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M136.621,196.497c-14.104,0-25.582,11.478-25.582,25.582v25.582h17.054v-25.582c0-4.699,3.829-8.527,8.527-8.527
			s8.527,3.829,8.527,8.527v8.527h17.054v-8.527C162.203,207.974,150.725,196.497,136.621,196.497z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M59.876,239.124c-14.104,0-25.582,11.478-25.582,25.582v25.582h17.054v-25.582c0-4.698,3.829-8.519,8.527-8.519
			c4.698,0,8.527,3.82,8.527,8.519h17.054C85.458,250.602,73.98,239.124,59.876,239.124z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M375.383,196.497c-14.104,0-25.582,11.478-25.582,25.582v8.527h17.054v-8.527c0-4.699,3.82-8.527,8.527-8.527
			c4.707,0,8.527,3.829,8.527,8.527v25.582h17.054v-25.582C400.965,207.974,389.487,196.497,375.383,196.497z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M452.128,239.124c-14.104,0-25.582,11.478-25.582,25.582h17.054c0-4.698,3.82-8.519,8.527-8.519
			c4.707,0,8.527,3.82,8.527,8.519v25.582h17.054v-25.582C477.71,250.602,466.232,239.124,452.128,239.124z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M237.532,478.006l-92.392,15.4v-19.212l81.137-48.682l-8.775-14.624l-85.272,51.163c-2.567,1.535-4.136,4.306-4.136,7.308
			v34.109c0,2.507,1.109,4.895,3.019,6.506c1.552,1.313,3.505,2.021,5.509,2.021c0.46,0,0.929-0.043,1.39-0.111l102.327-17.054
			L237.532,478.006z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M379.766,462.051l-85.272-51.163l-8.774,14.624l81.137,48.682v19.203l-92.401-15.4l-2.797,16.824l102.327,17.054
			c0.469,0.077,0.929,0.119,1.398,0.119c2.004,0,3.957-0.708,5.5-2.021c1.919-1.62,3.019-3.999,3.019-6.506v-34.109
			C383.902,466.366,382.333,463.595,379.766,462.051z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M275.333,65.45c-2.788-8.348-10.744-13.712-19.425-13.925c-9.047,0.085-16.824,5.978-19.246,14.309l-5.799,17.054
			l16.151,5.492l5.909-17.413c0.418-1.415,1.68-2.379,3.087-2.388c1.433,0,2.695,0.912,3.147,2.251l5.799,17.481l16.185-5.364
			L275.333,65.45z"
          />
        </g>
      </g>
    </>,
  ],
  invoices: [
    463,
    463.152,
    <>
      <path d="m216.074219 179.574219c-30.925781 0-56 25.074219-56 56 0 30.929687 25.074219 56 56 56 30.929687 0 56-25.070313 56-56-.035157-30.910157-25.085938-55.964844-56-56zm0 96c-22.089844 0-40-17.90625-40-40 0-22.089844 17.910156-40 40-40 22.09375 0 40 17.910156 40 40-.023438 22.082031-17.917969 39.976562-40 40zm0 0" />
      <path d="m48.074219 155.574219h16v-16h-24c-4.417969 0-8 3.582031-8 8v24h16zm0 0" />
      <path d="m48.074219 299.574219h-16v24c0 4.421875 3.582031 8 8 8h24v-16h-16zm0 0" />
      <path d="m.0742188 115.574219v240c0 4.421875 3.5820312 8 8.0000002 8h416c4.421875 0 8-3.578125 8-8v-240c0-4.417969-3.578125-8-8-8h-416c-4.417969 0-8.0000002 3.582031-8.0000002 8zm16.0000002 8h400v224h-400zm0 0" />
      <path d="m392.074219 195.574219c-26.496094-.023438-47.972657-21.5-48-48 0-4.417969-3.578125-8-8-8h-240c-4.417969 0-8 3.582031-8 8-.023438 26.5-21.5 47.976562-48 48-4.417969 0-8 3.582031-8 8v64c0 4.421875 3.582031 8 8 8 26.5.027343 47.976562 21.503906 48 48 0 4.421875 3.582031 8 8 8h240c4.421875 0 8-3.578125 8-8 .027343-26.496094 21.503906-47.972657 48-48 4.421875 0 8-3.578125 8-8v-64c0-4.417969-3.578125-8-8-8zm-8 64.496093c-28.980469 3.703126-51.800781 26.523438-55.503907 55.503907h-224.992187c-3.703125-28.980469-26.519531-51.800781-55.503906-55.503907v-48.992187c28.984375-3.703125 51.800781-26.519531 55.503906-55.503906h224.992187c3.703126 28.984375 26.523438 51.800781 55.503907 55.503906zm0 0" />
      <path d="m392.074219 139.574219h-24v16h16v16h16v-24c0-4.417969-3.578125-8-8-8zm0 0" />
      <path d="m384.074219 315.574219h-16v16h24c4.421875 0 8-3.578125 8-8v-24h-16zm0 0" />
      <path d="m108.074219 48.480469 8 13.839843c54.410156-31.375 120.398437-35.367187 178.195312-10.785156l-33.769531 16.878906 7.152344 14.320313 48-24c1.90625-.9375 3.359375-2.601563 4.039062-4.613281.679688-2.015625.53125-4.21875-.414062-6.121094l-24-48-14.320313 7.152344 13.597657 27.199218c-61.078126-23.851562-129.6875-18.65625-186.480469 14.128907zm0 0" />
      <path d="m316.074219 414.671875-8-13.839844c-54.40625 31.371094-120.390625 35.367188-178.183594 10.785157l33.769531-16.882813-7.152344-14.320313-48 24c-3.957031 1.976563-5.5625 6.785157-3.582031 10.738282l24 48 14.316407-7.152344-13.597657-27.199219c61.066407 23.835938 129.65625 18.640625 186.429688-14.128906zm0 0" />
    </>,
  ],
  metrics: [
    900,
    900,
    <>
      <path
        id="_36-Bar_graph"
        d="m783.37 777.18h-19.83v-500.18a16 16 0 0 0 -16-16h-129.68a16 16 0 0 0 -16 16v500.18h-66.11v-670.36a16 16 0 0 0 -16-16h-129.68a16 16 0 0 0 -16 16v670.36h-66.07v-224.59a16 16 0 0 0 -16-16h-129.72a16 16 0 0 0 -16 16v224.59h-29.65a16 16 0 0 0 0 32h666.74a16 16 0 0 0 0-32zm-149.51-484.18h97.68v484.18h-97.68zm-131.8 484.18-96-96v-40.48l97.68 97.68v38.8zm1.69-554.53v40.49l-97.68-97.68v-40.46zm0 85.74v40.92l-97.68-97.68v-40.92zm0 86.17v40.49l-97.68-97.68v-40.49zm0 85.74v40.92l-97.68-97.68v-40.92zm0 86.17v40.53l-97.68-97.68v-40.53zm0 85.74v40.92l-97.68-97.68v-40.92zm0-474.81-54.58-54.58h54.58zm-97.68 549 50.73 50.74h-50.73zm-227.79-157.81h97.72v208.59h-97.72z"
        data-name="36-Bar graph"
      />
    </>,
  ],
  galleys: [
    409.605,
    409.605,
    <>
      <g>
        <g>
          <path
            d="M404.485,62.108h-30.141c-2.278,0-4.285,1.51-4.92,3.702l-19.912,68.925h-32.44V98.102
			c11.453-4.48,19.574-23.895,19.574-48.635c0-7.788-0.84-26.286-2.452-33.848c-0.507-2.365-2.596-4.055-5.013-4.055h-34.468
			c-2.417,0-4.506,1.69-5.012,4.055c-1.608,7.567-2.452,26.061-2.452,33.848c0,24.74,8.12,44.155,19.574,48.635v36.628h-54.2V98.102
			c11.453-4.48,19.574-23.895,19.574-48.635c0-7.788-0.84-26.276-2.447-33.843c-0.507-2.371-2.591-4.06-5.013-4.06h-34.473
			c-2.422,0-4.506,1.69-5.012,4.06c-1.603,7.573-2.447,26.061-2.447,33.843c0,24.735,8.12,44.15,19.569,48.635v36.628h-30.935
			v-17.879c0-2.831-2.289-5.12-5.12-5.12h-0.829c-1.003-44.058-33.531-80.374-75.894-87.317c1.229-2.324,1.992-4.931,1.992-7.736
			c0-9.196-7.48-16.676-16.676-16.676c-9.196,0-16.681,7.48-16.681,16.676c0,2.806,0.763,5.412,1.992,7.736
			c-42.342,6.948-74.87,43.259-75.873,87.317h-0.829c-2.831,0-5.12,2.289-5.12,5.12v17.879H5.12c-2.831,0-5.12,2.289-5.12,5.12
			v229.463c0,2.831,2.289,5.12,5.12,5.12h20.623c0.42,19.461,16.348,35.169,35.912,35.169c19.558,0,35.487-15.708,35.907-35.169
			h161.26c0.42,19.461,16.348,35.169,35.907,35.169c19.564,0,35.492-15.708,35.912-35.169h22.723c2.831,0,5.12-2.289,5.12-5.12
			V140.582l19.712-68.234h26.291c2.831,0,5.12-2.289,5.12-5.12S407.316,62.108,404.485,62.108z M297.492,49.467
			c0-6.252,0.589-19.63,1.587-27.663h25.738c0.993,8.033,1.587,21.417,1.587,27.663c0,24.033-8.561,39.373-14.454,39.373
			S297.492,73.5,297.492,49.467z M233.052,49.467c0-6.246,0.589-19.625,1.587-27.663h25.733c0.993,8.038,1.587,21.422,1.587,27.663
			c0,24.033-8.561,39.373-14.454,39.373C241.608,88.845,233.052,73.5,233.052,49.467z M114.918,10.248
			c3.553,0,6.436,2.883,6.436,6.436s-2.883,6.436-6.436,6.436c-3.553,0-6.441-2.888-6.441-6.436S111.365,10.248,114.918,10.248z
			 M114.918,33.359c43.658,0,79.222,34.975,80.333,78.377H34.586C35.697,68.334,71.265,33.359,114.918,33.359z M28.636,121.971
			h172.57v12.744H28.636V121.971z M61.655,399.368c-13.906,0-25.206-11.121-25.631-24.929h51.256
			C86.856,388.242,75.561,399.368,61.655,399.368z M294.723,399.368c-13.906,0-25.201-11.121-25.626-24.929h51.256
			C319.933,388.242,308.634,399.368,294.723,399.368z M348.242,364.198H10.24v-32.251h338.002V364.198z M348.242,321.708H10.24
			V186.197h338.002V321.708z M348.242,175.957H10.24V144.97h338.002V175.957z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M182.615,94.508c-6.559-24.038-26.624-42.455-51.118-46.909c-2.77-0.532-5.443,1.336-5.949,4.122
			c-0.512,2.78,1.331,5.443,4.117,5.949c20.639,3.758,37.545,19.277,43.069,39.531c0.62,2.278,2.683,3.773,4.936,3.773
			c0.451,0,0.901-0.056,1.352-0.179C181.75,100.047,183.363,97.236,182.615,94.508z"
          />
        </g>
      </g>
    </>,
  ],
  doc_nbr: [
    470.586,
    470.586,
    <>
      <g>
        <path
          d="M327.081,0H90.234c-15.9,0-28.854,12.959-28.854,28.859v412.863c0,15.924,12.953,28.863,28.854,28.863H380.35
		c15.917,0,28.855-12.939,28.855-28.863V89.234L327.081,0z M333.891,43.184l35.996,39.121h-35.996V43.184z M384.972,441.723
		c0,2.542-2.081,4.629-4.634,4.629H90.234c-2.551,0-4.62-2.087-4.62-4.629V28.859c0-2.548,2.069-4.613,4.62-4.613h219.41v70.181
		c0,6.682,5.444,12.099,12.129,12.099h63.198V441.723z M294.886,148.942h-28.827l-8.429,56.356h-29.462l8.092-56.356h-28.83
		l-8.086,56.356h-32.072v30.124h27.533l-5.181,36.271h-31.413v29.79h26.238l-8.42,57.973h29.137l8.098-57.973h29.471l-8.091,57.973
		h29.134l8.109-57.973h31.741v-29.79h-26.877l5.185-36.271h30.434v-30.124h-25.906L294.886,148.942z M247.912,271.694h-29.468
		l5.184-36.271h29.468L247.912,271.694z"
        />
      </g>
    </>,
  ],

  legend: [
    53,
    53,
    <>
      <g>
        <path d="M39.645,29.854a1,1,0,0,0,1.374-.334A10.547,10.547,0,0,0,25.3,15.905a10.514,10.514,0,0,0-3.84,8.139,3.121,3.121,0,1,0,6.242,0,4.312,4.312,0,0,1,5.2-4.215,4.238,4.238,0,0,1,3.322,3.321,4.34,4.34,0,0,1-1.641,4.342,13.7,13.7,0,0,0-5.7,10.969v.432a3.122,3.122,0,0,0,6.243,0v-.432a7.525,7.525,0,0,1,3.2-5.974,1,1,0,1,0-1.2-1.6,9.5,9.5,0,0,0-4,7.574v.432a1.122,1.122,0,0,1-2.243,0v-.432a11.727,11.727,0,0,1,4.9-9.369,6.327,6.327,0,0,0,2.405-6.324A6.307,6.307,0,0,0,25.7,24.044a1.121,1.121,0,1,1-2.242,0,8.548,8.548,0,0,1,16.925-1.7,8.624,8.624,0,0,1-1.07,6.139A1,1,0,0,0,39.645,29.854Z" />
        <path d="M32,44.257a3.121,3.121,0,1,0,3.121,3.121A3.125,3.125,0,0,0,32,44.257ZM32,48.5a1.121,1.121,0,1,1,1.121-1.121A1.123,1.123,0,0,1,32,48.5Z" />
        <path d="M32,8a24,24,0,0,0,0,48,23.746,23.746,0,0,0,14.941-5.217A1,1,0,1,0,45.7,49.218,21.757,21.757,0,0,1,32,54a22,22,0,1,1,16.678-7.652,1,1,0,1,0,1.515,1.3A24,24,0,0,0,32,8Z" />
      </g>
    </>,
  ],

  res_code: [
    512,
    512,
    <>
      <g>
        <path d="m 323.352 290.335 c 6.604 -3.931 12.778 -8.586 18.471 -13.935 c 20.714 -19.462 32.121 -45.467 32.121 -73.225 s -11.407 -53.763 -32.121 -73.225 c -19.87 -18.67 -45.898 -28.951 -73.29 -28.951 h -58.461 c -11.875 0 -23.492 4.823 -31.872 13.233 c -8.034 8.061 -12.642 18.634 -13.09 29.942 c -0.073 0.599 -0.11 1.207 -0.11 1.824 v 220 c 0 24.813 20.187 45 45 45 s 45 -20.187 45 -45 v -17.103 l 41.22 46.833 c 8.541 9.704 20.857 15.27 33.792 15.27 c 10.944 0 21.499 -3.985 29.719 -11.221 c 18.626 -16.393 20.442 -44.883 4.049 -63.51 Z m 16.558 86.925 c -2.74 2.412 -6.255 3.74 -9.898 3.74 c -4.317 0 -8.425 -1.855 -11.272 -5.09 l -67.479 -76.67 c -2.904 -3.3 -7.034 -5.091 -11.263 -5.091 c -1.774 0 -3.567 0.315 -5.293 0.967 c -5.839 2.204 -9.704 7.793 -9.704 14.034 v 56.85 c 0 8.271 -6.729 15 -15 15 s -15 -6.729 -15 -15 v -218.504 c 0.049 -0.492 0.074 -0.991 0.074 -1.496 c 0 -3.998 1.553 -7.759 4.375 -10.59 c 2.834 -2.844 6.607 -4.41 10.623 -4.41 h 58.461 c 19.729 0 38.462 7.393 52.748 20.814 c 14.614 13.731 22.663 31.972 22.663 51.361 s -8.049 37.63 -22.663 51.361 c -7.904 7.426 -17.092 12.989 -27.311 16.538 c -4.72 1.639 -8.313 5.52 -9.585 10.351 c -1.272 4.832 -0.055 9.979 3.246 13.729 l 53.629 60.935 c 5.463 6.21 4.858 15.706 -1.351 21.171 Z" />
        <path d="m 313.944 203.176 c 0 -22.861 -20.796 -42.176 -45.411 -42.176 h -28.371 c -3.985 0 -7.807 1.586 -10.621 4.408 c -2.814 2.821 -4.39 6.647 -4.379 10.633 c 0.03 10.82 0.055 21.696 0.055 27.135 c 0 5.517 0.031 14.715 0.093 27.341 c 0.041 8.26 6.748 14.927 14.999 14.927 h 0.072 c 10.557 -0.05 21.452 -0.092 28.151 -0.092 c 24.616 0 45.412 -19.315 45.412 -42.176 Z m -45.411 12.176 c -3.502 0 -8.145 0.012 -13.288 0.029 c -0.019 -5.138 -0.028 -9.221 -0.028 -12.205 c 0 -2.84 -0.007 -7.157 -0.018 -12.176 h 13.333 c 8.065 0 15.411 5.804 15.411 12.176 s -7.345 12.176 -15.41 12.176 Z" />
        <path d="m 437.02 74.98 c -48.353 -48.351 -112.64 -74.98 -181.02 -74.98 s -132.667 26.629 -181.02 74.98 c -48.352 48.353 -74.98 112.64 -74.98 181.02 s 26.628 132.667 74.98 181.02 c 48.353 48.351 112.64 74.98 181.02 74.98 s 132.667 -26.629 181.02 -74.98 c 48.351 -48.353 74.98 -112.64 74.98 -181.02 s -26.629 -132.667 -74.98 -181.02 Z m -181.02 407.02 c -124.617 0 -226 -101.383 -226 -226 s 101.383 -226 226 -226 s 226 101.383 226 226 s -101.383 226 -226 226 Z" />
      </g>
    </>,
  ],
  reset_pswd: [
    24,
    24,
    <>
      <g>
        <path d="m21.5 23h-19c-1.378 0-2.5-1.122-2.5-2.5v-17c0-1.378 1.122-2.5 2.5-2.5h19c1.378 0 2.5 1.122 2.5 2.5v17c0 1.378-1.122 2.5-2.5 2.5zm-19-21c-.827 0-1.5.673-1.5 1.5v17c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-17c0-.827-.673-1.5-1.5-1.5z" />
      </g>
      <g>
        <path d="m23.5 6h-23c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h23c.276 0 .5.224.5.5s-.224.5-.5.5z" />
      </g>
      <g>
        <path d="m5.5 17c-.276 0-.5-.224-.5-.5v-4c0-.276.224-.5.5-.5s.5.224.5.5v4c0 .276-.224.5-.5.5z" />
      </g>
      <g>
        <path d="m3.769 16c-.173 0-.341-.089-.434-.25-.138-.239-.056-.545.183-.683l3.464-2c.238-.139.545-.057.683.183.138.239.056.545-.183.683l-3.464 2c-.079.046-.164.067-.249.067z" />
      </g>
      <g>
        <path d="m7.231 16c-.085 0-.171-.021-.25-.067l-3.464-2c-.239-.138-.321-.444-.183-.683.138-.24.444-.322.683-.183l3.464 2c.239.138.321.444.183.683-.092.161-.26.25-.433.25z" />
      </g>
      <g>
        <path d="m12 17c-.276 0-.5-.224-.5-.5v-4c0-.276.224-.5.5-.5s.5.224.5.5v4c0 .276-.224.5-.5.5z" />
      </g>
      <g>
        <path d="m10.269 16c-.173 0-.341-.089-.434-.25-.138-.239-.056-.545.183-.683l3.464-2c.238-.139.544-.057.683.183.138.239.056.545-.183.683l-3.464 2c-.079.046-.164.067-.249.067z" />
      </g>
      <g>
        <path d="m13.731 16c-.085 0-.171-.021-.25-.067l-3.464-2c-.239-.138-.321-.444-.183-.683.138-.24.444-.322.683-.183l3.464 2c.239.138.321.444.183.683-.092.161-.26.25-.433.25z" />
      </g>
      <g>
        <path d="m18.5 17c-.276 0-.5-.224-.5-.5v-4c0-.276.224-.5.5-.5s.5.224.5.5v4c0 .276-.224.5-.5.5z" />
      </g>
      <g>
        <path d="m16.769 16c-.173 0-.341-.089-.434-.25-.138-.239-.056-.545.183-.683l3.464-2c.238-.139.545-.057.683.183.138.239.056.545-.183.683l-3.464 2c-.079.046-.164.067-.249.067z" />
      </g>
      <g>
        <path d="m20.231 16c-.085 0-.171-.021-.25-.067l-3.464-2c-.239-.138-.321-.444-.183-.683.138-.24.444-.322.683-.183l3.464 2c.239.138.321.444.183.683-.092.161-.26.25-.433.25z" />
      </g>
    </>,
  ],
  letter_D: [
    512,
    512,
    <>
      <g>
        <path d="m190.125 512h-64.249c-33.084 0-60-26.916-60-60v-392c0-33.084 26.916-60 60-60h64.249c68.38 0 132.667 26.629 181.019 74.981s74.98 112.639 74.98 181.019-26.629 132.667-74.98 181.019c-48.352 48.352-112.639 74.981-181.019 74.981zm-64.249-482c-16.542 0-30 13.458-30 30v392c0 16.542 13.458 30 30 30h64.249c60.367 0 117.12-23.508 159.806-66.194s66.193-99.439 66.193-159.806-23.508-117.121-66.193-159.806-99.439-66.194-159.806-66.194zm64.249 392h-19.249c-8.284 0-15-6.716-15-15v-302c0-8.284 6.716-15 15-15h19.249c91.532 0 165.999 74.467 165.999 166s-74.467 166-165.999 166zm-4.249-30h4.249c74.99 0 135.999-61.009 135.999-136s-61.009-136-135.999-136h-4.249z" />
      </g>
    </>,
  ],
  box_check: [
    32,
    32,
    <>
      <path d="m4.2 1.6c-1.4 0-2.6 1.2-2.6 2.6v23.6c0 1.4 1.2 2.6 2.6 2.6h23.6c1.4 0 2.6-1.2 2.6-2.6v-20c0-.6-.5-1-1-1-.6 0-1 .5-1 1v20c0 .3-.2.5-.5.5h-23.7c-.3 0-.5-.2-.5-.5v-23.6c0-.3.2-.5.5-.5h20c.6 0 1.1-.5 1.1-1 0-.6-.5-1-1.1-1h-20zm24.1 1.1c-.3 0-.5.1-.7.3l-11.6 12-3.4-3.8c-.4-.5-1-.5-1.5-.1-.4.4-.5 1.1 0 1.5l4.1 4.6c.4.4 1.1.5 1.5 0l12.3-12.8c.7-.7.2-1.8-.7-1.7z" />
    </>,
  ],
  box_uncheck: [
    32,
    32,
    <>
      <path d="m4.2 1.6c-1.4 0-2.6 1.2-2.6 2.6v23.6c0 1.4 1.2 2.6 2.6 2.6h23.6c1.4 0 2.6-1.2 2.6-2.6v-23.6c0-1.4-1.2-2.6-2.6-2.6zm0 2.1h23.6c.3 0 .5.2.5.5v23.6c0 .3-.2.5-.5.5h-23.6c-.3 0-.5-.2-.5-.5v-23.6c0-.3.2-.5.5-.5z" />
    </>,
  ],
  box_add: [
    152,
    152,
    <>
      <g>
        <g>
          <g>
            <path d="m140 0h-128a12 12 0 0 0 -12 12v128a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12v-128a12 12 0 0 0 -12-12zm-24 86.49h-28.08v29.51h-23.77v-29.51h-28.15v-21.81h28.15v-28.68h23.77v28.68h28.08z" />
          </g>
        </g>
      </g>
    </>,
  ],
  box_modified: [
    152,
    152,
    <>
      <g>
        <g>
          <g>
            <path d="m140 0h-128a12 12 0 0 0 -12 12v128a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12v-128a12 12 0 0 0 -12-12zm-32.7 105.45-15.47 10.55-16.37-26.29-16.46 25.4-15.46-10.11 20.39-24.33-29.16-8 5.81-16.88 28.53 11.7-2.23-31.49h19.12l-2.31 32.08 27.73-11.44 5.81 17.06-29.51 8z" />
          </g>
        </g>
      </g>
    </>,
  ],
  box_removed: [
    152,
    152,
    <>
      <g>
        <g>
          <g>
            <path d="m140 0h-128a12 12 0 0 0 -12 12v128a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12v-128a12 12 0 0 0 -12-12zm-24 86.49h-80v-21.83h80z" />
          </g>
        </g>
      </g>
    </>,
  ],

  zip: [
    58,
    58,
    <>
      <path
        d="M28.5,33c1.654,0,3-1.346,3-3v-3h-6v3C25.5,31.654,26.846,33,28.5,33z M27.5,29h2c0.552,0,1,0.447,1,1s-0.448,1-1,1h-2
		c-0.552,0-1-0.447-1-1S26.948,29,27.5,29z"
      />
      <path
        d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M37.5,3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095
		C48.796,13.447,48.567,14,48.109,14H37.5V3.391z M23.5,25h4v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2V9h2V7h2v2h2v2h-2v2h2v2h-2v2h2
		v2h-2v2h2v2h-2v2h4v5c0,2.757-2.243,5-5,5s-5-2.243-5-5V25z"
      />
      <path
        d="M37.251,45.858c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198h-1.23v3.992h1.504
		c0.2,0,0.398-0.034,0.595-0.103c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
		c0-0.164-0.023-0.354-0.068-0.567C37.485,46.26,37.392,46.055,37.251,45.858z"
      />
      <path
        d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M26.266,45.25l-4.799,7.205l-0.273,0.219
		h5.072V54h-6.699v-1.326l4.799-7.205l0.287-0.219h-5.086v-1.326h6.699V45.25z M30.271,54h-1.668V43.924h1.668V54z M38.926,48.429
		c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656s-0.921,0.232-1.449,0.232h-1.217V54h-1.641V43.924
		h2.898c0.428,0,0.852,0.068,1.271,0.205c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991
		s0.308,0.822,0.308,1.306C39.186,47.552,39.099,48.014,38.926,48.429z"
      />
    </>,
  ],

  default_fileType: [
    58,
    58,
    <>
      <path
        d="M6.5,41v15c0,1.009,1.22,2,2.463,2h40.074c1.243,0,2.463-0.991,2.463-2V41H6.5z M19.5,52c-2.206,0-4-1.794-4-4s1.794-4,4-4
		s4,1.794,4,4S21.706,52,19.5,52z M29.5,52c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S31.706,52,29.5,52z M39.5,52
		c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S41.706,52,39.5,52z"
      />
      <path
        d="M51.5,39V13.978c0-0.766-0.092-1.333-0.55-1.792L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963
		C7.777,0,6.5,0.916,6.5,2.926V39H51.5z M37.5,3.391c0-0.458,0.553-0.687,0.877-0.363l10.095,10.095
		C48.796,13.447,48.567,14,48.109,14H37.5V3.391z"
      />
    </>,
  ],

  star: [
    24,
    24,
    <>
      <g>
        <g>
          <path d="m19.107 24c-.083 0-.167-.021-.242-.062l-6.865-3.795-6.866 3.795c-.167.093-.374.081-.53-.029s-.236-.3-.206-.489l1.317-8.072-5.573-5.714c-.131-.134-.176-.33-.116-.508s.213-.307.398-.335l7.683-1.174 3.44-7.33c.165-.352.74-.352.905 0l3.44 7.33 7.683 1.174c.185.028.339.158.398.335s.015.374-.116.508l-5.574 5.713 1.317 8.072c.031.189-.049.379-.206.489-.084.061-.186.092-.287.092zm-7.107-4.929c.083 0 .167.021.242.062l6.207 3.431-1.192-7.305c-.025-.157.025-.316.136-.43l5.07-5.197-6.984-1.067c-.165-.025-.306-.131-.377-.282l-3.102-6.606-3.101 6.607c-.071.151-.212.257-.377.281l-6.984 1.067 5.07 5.197c.111.114.161.273.136.43l-1.192 7.305 6.207-3.431c.074-.041.158-.062.241-.062z" />
        </g>
      </g>
    </>,
  ],

  star_solid: [
    512,
    512,
    <>
      <defs>
        <path
          d="M402.46 510.19C392.69 504.79 343.88 477.8 256 429.23C168.12 477.8 119.29 504.79 109.53 510.19C105.97 512.17 101.55 511.91 98.22 509.57C94.89 507.22 93.19 503.17 93.83 499.14C95.7 487.66 105.07 430.25 121.92 326.93C50.59 253.79 10.96 213.16 3.03 205.03C0.24 202.18 -0.72 197.99 0.56 194.2C1.84 190.4 5.1 187.65 9.05 187.05C19.98 185.38 74.61 177.03 172.95 162.01C216.99 68.18 241.45 16.06 246.34 5.63C249.86 -1.88 262.13 -1.88 265.65 5.63C270.54 16.06 295 68.18 339.03 162.01C437.38 177.03 492.01 185.38 502.94 187.05C506.88 187.65 510.17 190.42 511.43 194.2C512.69 197.97 511.75 202.18 508.95 205.03C501.03 213.16 461.39 253.79 390.04 326.91C406.9 430.23 416.26 487.63 418.14 499.11C418.8 503.15 417.09 507.2 413.74 509.55C411.95 510.85 409.77 511.51 407.62 511.51C405.85 511.51 404.06 511.06 402.46 510.19ZM261.17 407.68C269.99 412.56 314.13 436.96 393.58 480.87C378.32 387.37 369.85 335.42 368.15 325.03C367.62 321.69 368.69 318.29 371.05 315.86C378.27 308.47 414.32 271.51 479.21 204.99C389.82 191.33 340.16 183.75 330.22 182.23C326.7 181.7 323.69 179.43 322.18 176.21C317.77 166.82 295.71 119.84 256 35.29C216.31 119.85 194.26 166.84 189.85 176.23C188.33 179.46 185.33 181.72 181.81 182.23C171.87 183.75 122.21 191.33 32.81 204.99C97.71 271.51 133.76 308.47 140.97 315.86C143.34 318.29 144.41 321.69 143.88 325.03C142.18 335.42 133.7 387.37 118.45 480.87C197.9 436.96 242.03 412.56 250.86 407.68C252.44 406.81 254.23 406.36 256 406.36C257.77 406.36 259.57 406.81 261.17 407.68Z"
          id="c30aQ0081"
        />
        <path
          d="M132.87 320L113.07 490.69L255.99 417.43L403.17 490.69L379.41 320L487.33 198.61L331.88 175.84L253.66 24.36L175.45 175.84L25.94 201.58L132.87 320Z"
          id="aLMFqydzn"
        />
      </defs>
      <g>
        <g>
          <g>
            <use href="#c30aQ0081" opacity="1" fillOpacity="1" />
            <g>
              <use
                href="#c30aQ0081"
                opacity="1"
                fillOpacity="0"
                strokeWidth="1"
                strokeOpacity="0"
              />
            </g>
          </g>
          <g>
            <use
              href="#aLMFqydzn"
              opacity="1"
              fill="#000000"
              fill-opacity="1"
            />
            <g>
              <use
                href="#aLMFqydzn"
                opacity="1"
                fillOpacity="0"
                stroke="#000000"
                strokeWidth="1"
                strokeOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </>,
  ],
  "download-center": [
    25,
    25,
    <>
      <g id="Layer_2">
        <g id="Icons">
          <g id="Layer_23">
            <path
              fill="#cfd2d3"
              d="M22.1,25H2.9A2.9,2.9,0,0,1,0,22.1V2.9A2.9,2.9,0,0,1,2.9,0H22.1A2.9,2.9,0,0,1,25,2.9V22.1A2.9,2.9,0,0,1,22.1,25ZM2.9,1A1.9,1.9,0,0,0,1,2.9V22.1A1.9,1.9,0,0,0,2.9,24H22.1A1.9,1.9,0,0,0,24,22.1V2.9A1.9,1.9,0,0,0,22.1,1Z"
            />
            <polygon
              fill="#a2a9ad"
              points="19.55 19.51 5.45 19.51 5.45 14.45 6.45 14.45 6.45 18.51 18.55 18.51 18.55 14.45 19.55 14.45 19.55 19.51"
            />
            <rect fill="#a2a9ad" x="12" y="6.12" width="1" height="8.76" />
            <polygon
              fill="#a2a9ad"
              points="12.5 15.58 9 12.09 9.71 11.38 12.5 14.17 15.29 11.38 16 12.09 12.5 15.58"
            />
          </g>
        </g>
      </g>
    </>,
  ],
  ChefChat: [
    469,
    469,
    <>
      <g>
        <g>
          <g>
            <path
              d="M128,224c0-5.896-4.771-10.667-10.667-10.667c-5.896,0-10.667,4.771-10.667,10.667c0,28.01,30.896,66.469,34.417,70.771
				c2.115,2.563,5.177,3.896,8.26,3.896c2.375,0,4.771-0.792,6.76-2.417c4.552-3.74,5.208-10.458,1.479-15.021
				C146.146,267.292,128,239.437,128,224z"
            />
            <path
              d="M352,213.333c-5.896,0-10.667,4.771-10.667,10.667c0,15.385-18.146,43.271-29.583,57.24
				c-3.729,4.552-3.063,11.271,1.49,15.01c1.979,1.625,4.375,2.417,6.76,2.417c3.083,0,6.135-1.333,8.25-3.896
				c3.521-4.302,34.417-42.76,34.417-70.771C362.667,218.104,357.896,213.333,352,213.333z"
            />
            <path
              d="M234.667,213.333c-5.896,0-10.667,4.771-10.667,10.667v64c0,5.896,4.771,10.667,10.667,10.667
				s10.667-4.771,10.667-10.667v-64C245.333,218.104,240.562,213.333,234.667,213.333z"
            />
            <path
              d="M352,42.667c-6.464,0-13.219,0.855-20.234,2.158C308.273,17.439,273.496,0,234.667,0s-73.607,17.439-97.099,44.824
				c-7.016-1.302-13.771-2.158-20.234-2.158C52.635,42.667,0,95.302,0,160c0,44.333,25,84.635,64.25,104.562L64.042,425.76
				c-0.01,11.635,4.51,22.573,12.729,30.802c8.229,8.24,19.156,12.771,30.792,12.771h254.25c24,0,43.521-19.521,43.521-43.521
				V264.406c39.104-19.979,64-60.219,64-104.406C469.333,95.302,416.698,42.667,352,42.667z M384,425.813
				c0,12.229-9.958,22.188-22.188,22.188h-254.25c-5.927,0-11.5-2.313-15.698-6.51c-4.188-4.198-6.5-9.771-6.49-15.708L85.43,384
				H384V425.813z M390.604,247.802c-0.563,0.229-1.094,0.5-1.594,0.823c-1.344,0.833-2.448,1.938-3.271,3.208
				c-0.833,1.26-1.396,2.719-1.625,4.281c-0.094,0.594-0.125,1.188-0.115,1.792v104.76H85.457l0.137-104.615
				c0.01-0.583-0.021-1.177-0.104-1.75c-0.229-1.615-0.823-3.115-1.688-4.417c-0.813-1.219-1.875-2.281-3.167-3.094
				c-0.531-0.333-1.094-0.625-1.677-0.865C43.948,232.615,21.333,198.135,21.333,160c0-52.938,43.063-96,96-96
				c2.069,0,4.253,0.25,6.396,0.419c-10.792,18.756-17.063,40.43-17.063,63.581c0,5.896,4.771,10.667,10.667,10.667
				c5.896,0,10.667-4.771,10.667-10.667c0-58.813,47.854-106.667,106.667-106.667S341.333,69.187,341.333,128
				c0,5.896,4.771,10.667,10.667,10.667c5.896,0,10.667-4.771,10.667-10.667c0-23.151-6.271-44.824-17.063-63.581
				C347.747,64.25,349.931,64,352,64c52.938,0,96,43.063,96,96C448,198,425.479,232.437,390.604,247.802z"
            />
          </g>
        </g>
      </g>
    </>,
  ],
};
